var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499, _path6500, _path6501, _path6502, _path6503, _path6504, _path6505, _path6506, _path6507, _path6508, _path6509, _path6510, _path6511, _path6512, _path6513, _path6514, _path6515, _path6516, _path6517, _path6518, _path6519, _path6520, _path6521, _path6522, _path6523, _path6524, _path6525, _path6526, _path6527, _path6528, _path6529, _path6530, _path6531, _path6532, _path6533, _path6534, _path6535, _path6536, _path6537, _path6538, _path6539, _path6540, _path6541, _path6542;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDvdCdVcrTape(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e9e9e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 108v1h3v1h3v1h3v1h4v1h2v2h1v-1h1v1h3v4h1v2h-1v-1h-3v-1h-3v-1h-3v-1h-3v-1h-3v-1h-3v-1h-3v-1h-1v-1h-5v-1h-4v-1h-3v-1h-3v-1h-3v-2h-2v1h-1v-1h-3v-1h-3v-1h-3v-1h-3v-1h-3v-1h-4v-1h-3v-1h-3v-1h-1v-4h2v1h4v1h3v1h3v1h4v1h3v1h3v1h4v1h3v1h3v1h3v1h4v1h3v1h3v1zm-18-2h-1v1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1zm-9 4v1h-1v-1zm39 13h1v1h-1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#25201d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 90v2h1v2h-3v-1h-1v2h-3v-1h-1v-2h-1v2h-1v-1h-2v-2h-1v1h-1v2h-1v-2h-1v-2h-1v1h-2v-1h-3v-1h-1v-3h1v-2h2v2h1v-2h1v-1h-4v-2h1v1h1v-1h-1v-3h2v1h3v1h1v1h-1v1h1v1h-1v1h2v-1h3v-1h-1v-2h4v1h3v3h2v-1h1v-1h2v1h1v1h-1v1h1v1h2v1h1v1h-2v2zm-1 1h-1v1h1zm-14-3h-2v1h2zm7 3h1v-2h1v1h1v-1h-1v-1h-2zm2-5v1h1v-1zm5 0v1h1v-1h-1v-1h-2v1h1zm-4-1v-1h-1v1zm5-2h-1v2h1v-1zm-17-2v1h1v-1zm19 7h-1v1h1zm-12-4v1h1v-1zm5 4v1h1v-1zm-15-2h-1v1h1zm11-5h-1v1h1zm8 8h1v-1h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1zm-20 6h1v1h-1zm20 6h1v1h-1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 96v1H8v-1H7v-3H6v-5h2v1h3v1h3v1h1v6h1v2h-1v-1h-3v-2zm81 27h-2v-9h2v1h2v3h-2v1h-1v1h1zM14 39v-1h1v1zm3 1h-1v-1h1zm10 2v-1h1v1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h4v1h-3v1h-2v-1h1zm-3 2h-1v2h-1v-2h-2v-1h4zm10 7h-1v-3h2v1h-1zm7 1v-2h1v1h1v2h-1v-1zm-4-10h1v1h1v1h-2zm-8 12v-1h3v1zm-4-15h-2v-1h2zm15 7h-2v-1h2zm6 0h1v1h-2v-1zm-21 3h-1v-1h2v1zm20-1h1v1h-2v-1zm-11-8h1v1h-1zm-12 2h-1v-1h1zm3-1v1h-1v-1zm15 3v-1h1v1zm-9 1v-1h1v1zm11-1h1v1h-1zm1 1h1v1h-1zm5 0v1h-1v-1zm-28 1h1v1h-1zm16 1h-1v-1h1zm5-1v1h-1v-1zm-4 2v1h-1v-1zm3 0h1v1h-1zm3 1h-1v-1h1zm-8 0h1v1h-1zm-10 3v-1h1v1zm4-1h1v1h-1zm11 0v1h-1v-1zm-13 2h-1v-1h1zm1-1h1v1h-1zm6 1h-1v-1h1zm5 0v1h-1v-1zm-2 3h-1v-1h1zm3 0v-1h1v1z",
    fill: "#241f1c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1zm6 2h1v1h-1zm13 4h1v1h-1zm-16 2v-1h1v1zm19-1h1v1h-1zm-15 1v1h-1v-1zm23 1v1h-1v-1zm-17 1v1h-1v-1zm19 0h1v1h-1zm-17 2v-1h1v1zm24 1v-1h1v1zm-18 0h1v1h-1zm25 2h-1v-1h1zm-18 1h-1v-1h1zm24 0h1v1h-1zm-11 4h-1v-1h1zm6 1v1h-1v-1zm2 1h1v1h-1zm4 1v1h-1v-1zm3 1v1h-1v-1zm2 2v-1h1v1zm3 1v-1h1v1zm7 2h-1v-1h1z",
    fill: "#f3f3f3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94v-1h1v2h-2v-1zm10 2h1v1h-1zm10 3h1v1h-1zm4 2h-1v-1h1zm-13 0h1v1h-1zm4 1v1h-1v-1zm3 2h-1v-1h1zm16 0h-1v-1h1zm-13 1h-1v-1h1zm15-1h1v1h-1zm-12 2h-1v-1h1zm6 1v1h-1v-1zm17 0v1h-1v-1zm10 4h-1v-1h1zm-14 0v1h-1v-1zm17 1h-1v-1h1zm-8 2v1h-1v-1zm3 1v1h-1v-1zm3 2h-1v-1h1zm3 1h-1v-1h1z",
    fill: "#eaeaea"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 18v1h1v1h-5v-1h1v-1zm-7 2h-4v-1h4zM35 5h1v1h-2V5zm12 13v1h-1v-1z",
    fill: "#eebf00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 98h1v1h-2v-1zM27 88v1h-1v-1zm4 2h1v1h-1zm5 0v1h-1v-1zm-6 1h1v1h-1zm8 1h-1v-1h1zm-5 1v-1h1v1zm3 0v-1h1v1zm16-1h1v1h-1zm-22 1v1h-1v-1zm5 0h1v1h-1zm3 3v-1h1v1zm4 1h1v1h-1zm9 1v-1h1v1z",
    fill: "#3e3a3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89 120v2h-1v-2zM17 97v-1h1v1zm11-1h1v1h-1zm11 4h-1v-1h1zm5 1h-1v-1h1zm-13 2h-1v-1h1zm3 1h-1v-1h1zm2 1v-1h1v1zm30 2h1v1h-1zm8 4v-1h1v1zm-15 2v-1h1v1zm11 2h1v1h-1zm4 1v1h-1v-1zm2 2v-1h1v1z",
    fill: "#efefef"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19h1v-1h1v2h-2zm7 1v1h1v1h-2v-2zm-3 8h-1v-1h2v1zm-4-11v1H9v-1zm3 4h-1v-1h1zm5-1h1v1h-1zm-1 7v1h-1v-1zm-1 2h-1v-1h1zm-2 1v1h-1v-1z",
    fill: "#e4b601"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h1v2h-2v-1h1zm6 3v1h-2v-1h1zm-12-5v-1h1v1zm2 1v-1h1v1zm-3 2v-1h1v1zm4 1v-1h1v1zm9-1h1v1h-1zm-10 1h1v1h-1zm3 1h-1v-1h1zm2 1h-1v-1h1zm4 1h1v1h-1z",
    fill: "#3f3b3c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h2v1h1v1h-3zm-1 1v1h-2v-1h1zm0 3h-2v-1h2zM40 8v1h-1V8zm5 1h-1V8h1zm4 3h1v1h-1zm-33 3h-1v-1h1z",
    fill: "#edbd01"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44 15v1h-1v1h1v1h-2v-1h-1v-1h1v-2h1v-1h1v1h1v1zm-1-5h-1V9h1zm3 2v1h-1v-1zm3 3v1h-1v-1z",
    fill: "#ecbc00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101h1v1h-2v-1zm6 8v1h-2v-1h1zM22 94h1v1h-1zm11 3v1h-1v-1zm-12 2v1h-1v-1zm35 6h-1v-1h1zm13 4h-1v-1h1zm-11 3h-1v-1h1zm20-1h1v1h-1zm5 1v1h-1v-1zm2 9h-1v-1h1z",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h1v4h-1v-1zm0 5v2h-1v-2zm2-7h-1v-1h1zm11 2h-1v-1h1zm7 1v-1h1v1zm-4 1h1v1h-1zm5 0h1v1h-1zm-23 6v-1h1v1z",
    fill: "#26211e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-3v-1h1zM29 15h1v1h-2v-1zm-7 5v-2h1v2zm81 31h2v1h-2zm-40-2h1v1h-1zm18 45v-1h1v1z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-2v-2h1v-1h2v2zm-6-7h1v1h-1zm8 6v-1h1v1zm-2 4v-1h1v1zm-2 7h-1v-1h1z",
    fill: "#e5b701"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13v2h-3v-2zm-5-4h1v1h-1zm-8 3v-1h1v1zm-23 1v1h-1v-1zm3 1v1h-1v-1z",
    fill: "#edbc00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21v4h-1v-4zm-2 2h-2v-1h1v-1h1zm-4-2v-1h1v1zm4 6h-1v-1h1zm-2 4h1v1h-1z",
    fill: "#e5b501"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47v-1h1v2h-2v-1zm10 1h1v1h-2v-1zm-5-2v-1h1v1zm-2 1h-1v-1h1zm6 0v-1h1v1zm-12 1v-1h1v1zm6 1h-1v-1h1z",
    fill: "#c6c9c2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68 75v2h-1v-1h-1v-1zm-5-2h2v1h-2zm8 5h-2v-1h2zm12-18h1v1h-1zM71 76h-1v-1h1zm-7 1h-1v-1h1z",
    fill: "#1e1e20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79h1v1h-1zM32 91v-1h1v1zm6-1v1h-1v-1zm-1 1v1h-1v-1zm-2 2v-1h1v1zm2-1h1v1h-1zm-6 2h-1v-1h1zm5 0v-1h1v1zm7-1h1v1h-1zm10 4v1h-1v-1z",
    fill: "#413d3e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1zm-12 2h-1v-1h1zm2 1v-1h1v1zm4 1h-1v-1h1zm29 2v1h-1v-1zm1 2h-1v-1h1zm13 3v1h-1v-1zm-9 3v1h-1v-1zm19 0v1h-1v-1zm-16 1v1h-1v-1z",
    fill: "#ededed"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26h-3v-2h1v1h2zm-6-7H9v-1h2v1zm-1-2v1H8v-1zm1 13v-1h1v1zm1 3h-1v-1h1z",
    fill: "#e3b500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h-1v-1h2v-1h1v2h-1v1h-1zm-1 2h-1v-1h2v1zM6 18h1v1H6zm4 2H9v-1h1z",
    fill: "#e3b601"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31h1v-2h1v1h1v3h-2v-1h-1zm3 4h-1v-1h1z",
    fill: "#e8ba02"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h-1v1h-1v-5h2v2h-1v1h1zm-5 5v-1h1v1z",
    fill: "#e8bc03"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v1h1v1h-2v-4h1v1h1v1zm1 3v1h-1v-1zm2 3v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#b1b2aa"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51v1h-1v-1zm15 16v1h-1v-1zm44 5h-1v-1h1zm41 10v-1h1v1zM4 84h1v1H4zm0 3v1H3v-1zm21 16v1h-1v-1zm82 2h-1v-1h1zm-18 19h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M84 81h1v1h-2v-1zm-9-6v-1h1v1zm8 8v1h-1v-1zm21 2v-1h1v1zm2 8h-1v-1h1zm-33 8v-1h1v1zm23 6h1v1h-1zm1 1h1v1h-1z",
    fill: "#2c2b30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104v1h-1v-2h1zm15-26h-1v-1h1zM65 99v1h-1v-1zm1 0h1v1h-1zm-3 3v-1h1v1zm3-1h1v1h-1zm5 3h1v1h-1zm15 2h-1v-1h1z",
    fill: "#2f2d30"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110v-1h1v2h-1zm-7-30h1v1h-1zm19 18v-1h1v1zm-9 8h-1v-1h1zm-17 1v1h-1v-1zm10 1h-1v-1h1zm-2 1h1v1h-1zm11 0v1h-1v-1z",
    fill: "#313035"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h-1v-1h1zm7 0v1h-1v-1zm2 2h-1v-1h1zm-8 2h-1v-1h1zm18 1h-1v-1h1zm21 5v1h-1v-1zm2 1v1h-1v-1zm23 8h-1v-1h1zm3 8v-1h1v1z",
    fill: "#f1f1f1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-2h1v1zm-7-4h1v1h-1zm1 3h1v1h-1zm2 2v-1h1v1zm9 1h-1v-1h1zm10 0v1h-1v-1zm-16 2h1v1h-1zm22 5h1v1h-1z",
    fill: "#323033"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M84 110v-2h1v2zM58 97v-1h1v1zm11 0v1h-1v-1zm-9 2v1h-1v-1zm6 0v1h-1v-1zm-7 2h1v1h-1zm7 3h1v1h-1zm12 3v1h-1v-1z",
    fill: "#333134"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1zm19-1v1h-1v-1zm-4 4v1h-1v-1zm16 1v-1h1v1zm24 7h-1v-1h1zm-16 2v-1h1v1zm13 3h-1v-1h1zm3 0v1h-1v-1zm2 2v-1h1v1z",
    fill: "#ebebeb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65 76h-2v-2h2zm21-33h-1v-1h1zM63 74h-1v-1h1zm-7 3v-1h1v1zm8 0v1h-1v-1z",
    fill: "#202022"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78v-1h3v1zm-13-3v2h-1v-2zm24-14h-1v-1h1zM73 76h-1v-1h1zm2 1v-1h1v1z",
    fill: "#212025"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60 77v-1h-1v-1h2v2zm12-1h-1v-1h1zm-14 0v1h-1v-1zm14 1v-1h1v1zm3 0h-1v-1h1zm-4 2v-1h1v1z",
    fill: "#201f24"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h1zm16 4v-1h1v1zm-1 1v-1h1v1zm0 1h-1v-1h1zm-3 17v-1h1v1zm-16 1h-1v-1h1zm6 2v1h-1v-1zm-3 3v1h-1v-1z",
    fill: "#323136"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h2v1h-2zm6 2h-1v-1h2v1zm22-20v-1h1v1zm1 5h-1v-1h1zm-21 17v1h-1v-1zm9 1h1v1h-1z",
    fill: "#323035"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h-1v-1h1zm7 0h-1v-1h1zm0 6v-1h1v1zm20 0h-1v-1h1zm13 4h-1v-1h1zm-6 4v-1h1v1zm24 0h1v1h-1zm4 2h1v1h-1z",
    fill: "#ececec"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1zm-15 2v-1h1v1zm30 2v1h-1v-1zm-6 4v1h-1v-1zm36 5h1v1h-1zm1 7v1h-1v-1zm3 1v1h-1v-1zm6 0v1h-1v-1z",
    fill: "#f0f0f0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h1v1h-1zm67 31v1h-1v-1zM13 54v1h-1v-1zm53 7h-1v-1h1zm-18 6v-1h1v1zm58 39v1h-1v-1zm-14 19h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h2v1h-1zm-7-9h-1V8h1zm2-1v1h-1V8zm-30 2v1h-1v-1zm40 5v-1h1v1zm-30 1v1h-1v-1z",
    fill: "#edbd00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43 13v1h-1v-2h1zm1 0v-1h1v2h-1zm-3 3v-2h1v2zm5-1v1h-1v-1z",
    fill: "#ebbb00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74v1h-2v-1h1zm24-30h-1v-1h1zM59 77v-1h1v1zm18-1v1h-1v-1zm-2 2v1h-1v-1zm1 1h1v1h-1z",
    fill: "#222126"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M108 45h2v1h-1v1h-1zm4 3h-1v-3h1v1zm-9 0v-1h1v1z",
    fill: "#c7cac3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47v-1h2v1h-1zm13-2h1v1h-1zm-9 1v1h-1v-1zm-1 1v1h-1v-1zm10 0h1v1h-1zm-9 1h1v1h-1z",
    fill: "#c5c8c1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h-1v-2h1v1zm-1 11h1v1h-1zM56 72h1v1h-1zm3 1h-1v-1h1zm3-1v1h-1v-1zm-5 1h1v1h-1z",
    fill: "#222224"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v-1h1v2h-1zm21-19h1v1h-1zM21 86v1h-1v-1zm1 0h1v1h-1zm3 4h1v1h-1zm0 1v1h-1v-1z",
    fill: "#3d3739"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1zm-1 3h-1v-1h1zM22 87h-1v-1h1zm0 0h1v1h-1zm7 2h1v1h-1zm-2 3h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#3f393b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1zm14 25v1h-1v-1zm1 3v-1h1v1zm0 2v-1h1v1zm6 0v1h-1v-1zm1 1v1h-1v-1zm1 3h1v1h-1z",
    fill: "#2d2b2e"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v2h-1v-1zm-3-2v-1h1v1zm10-1h1v1h-1zm-11 2v-1h1v1zm10 0h-1v-1h1zm-3 4h-1v-1h1z",
    fill: "#423e3f"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94h-1v-1h1zm4 7h-1v-1h1zm19 0h-1v-1h1zm-14 1h-1v-1h1zm24 2h-1v-1h1zm12 4v-1h1v1zm3 7v-1h1v1z",
    fill: "#eee"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104h1v1h1v1h-2zm-12-7v1h-1v-1zm23 7h-1v-1h1zm9 2h-1v-1h1zm-2 3v-1h1v1z",
    fill: "#2e2c31"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88 119h-1v-4h1v1zm-42-13h1v1h-2v-1zm39 9h-1v-1h1z",
    fill: "#e9e9e8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7V6h1v1zm-23 5v1h-1v-1zm37 4h-1v-1h1zm3 1v1h-1v-1zm-8 2v-1h1v1zm8-1h1v1h-1z",
    fill: "#eebe00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8V7h1v1zm-5 0v1h-1V8zm-2 4h-1v-1h1zm-17 3h1v1h-1zm35 0h1v1h-1zm-12 4h1v1h-1z",
    fill: "#ebbe01"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9v1h-1V9zm-2 2v1h-1v-1zm-16 4h-1v-1h1zm34 0h1v1h-1zm-6 2h1v1h-1zm4 1h-1v-1h1z",
    fill: "#edbe01"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15h-1v-1h1zm2 0v1h-1v-1zm29 1h-1v-1h1zm-7 0h1v1h-1zm7 1v-1h1v1zm-1 0h1v1h-1z",
    fill: "#ecbc01"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16v1H3v-1zm68 3h-1v-1h1zm5 25h-1v-1h1zm-1 5h-1v-1h1zm-7 9v-1h1v1zm-52 1h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M51 16h2v1h-1v1h-2v-1h1zm-4 3v-1h2v1h-1z",
    fill: "#edbe00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17h1v1H5zm4 2H8v-1h1zm2 1h1v1h-1zm-1 3H9v-1h1zm-4 6v-1h1v1zm7 0v1h-1v-1z",
    fill: "#e4b500"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19v1h-1v-2h1zm2 1v-1h1v1zm3 5h-1v-1h1zm-4 3h1v1h-1zm-1 6h-1v-1h1z",
    fill: "#e5b802"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h3v1h1v1h-2v-1zm-3 0v1h-1v-1z",
    fill: "#efc001"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28h1v-2h1v3H8zm-3-5v-2h1v2z",
    fill: "#e4b301"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23h-1v-1h2v-1h1v1h1v1h-2v1h-1z",
    fill: "#e4b600"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28h-1v-1h-1v-3h1v1h1v2z",
    fill: "#e2b301"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M89 51v1h-1v2h-1v-3zm-1-5v1h-1v-2h1z",
    fill: "#b0b1a9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v-2h1v2zm16 0v1h-1v-1zM55 72v1h-1v-1zm9 0v1h-1v-1zm-9 4h-1v-1h1z",
    fill: "#272729"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115 52h2v1h-2zm-12 3h2v1h-2zm14-2h1v1h-1zm-11 4v1h-1v-1z",
    fill: "#cccdc7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54h-1v-1h2v1zm14 6h1v1h-1zM56 71h-1v-1h1zm26 34h1v1h-1zm-1 3h1v1h-1z",
    fill: "#313133"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1zm10 4v-1h1v1zm-5 27v1h-1v-1zm12 4h-1v-1h1zm-2 1v-1h1v1zm2 0h1v1h-1z",
    fill: "#2e2d32"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h3v1h-3zm-22-8h1v1h-1zm26 8h1v1h-1zm-9 11v1h-1v-1z",
    fill: "#241f1d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M64 95v-2h1v1h1v1zm-6-17h1v1h-1zm1 4v-1h1v1zm9 14v-1h1v1z",
    fill: "#24201c"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1zm6-1h1v1h-1zm16 3h1v1h-1zm1 2v-1h1v1zm-21 5v1h-1v-1zm17 5h-1v-1h1z",
    fill: "#26201d"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M50 90v-1h1v2h-1zm10-9h-1v-1h1zm17 8v1h-1v-1zm-4 2v-1h1v1zm-2 4v1h-1v-1z",
    fill: "#251f1c"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-2v-1h1zm38-16v1h-1v-1zm2 1h1v1h-1zm1 6v-1h1v1zm-9 18v1h-1v-1z",
    fill: "#3d393c"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82v-1h1v1zm12 0v1h-1v-1zm-17 3v-1h1v1zm16 0h-1v-1h1zm-6 0h1v1h-1zm-13 18h1v1h-1z",
    fill: "#3b393e"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1zm14 5v1h-1v-1zm-4 2v1h-1v-1zm10 4h-1v-1h1zm2-1h1v1h-1zm3 2v-1h1v1z",
    fill: "#403c3d"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1zm4 4h-1v-1h1zm2 0v1h-1v-1zm4 2h1v1h-1zm14 5v-1h1v1zm5-1v1h-1v-1z",
    fill: "#3c3839"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90v-1h1v1zm12 1v-1h1v1zm-3 3v1h-1v-1zm6 2v1h-1v-1zm9 1h1v1h-1zm0 2v1h-1v-1z",
    fill: "#3d393a"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1zm13 1v1h-1v-1zm-3 4v1h-1v-1zm4 1h-1v-1h1zm4 2h1v1h-1zm11 2v-1h1v1z",
    fill: "#37353a"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1zm3 1h-1v-1h1zm2 1v1h-1v-1zm1 1v1h-1v-1zm-3 2v-1h1v1zm13 5h-1v-1h1z",
    fill: "#302e33"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M76 104v-1h1v2h-2v-1zm-7 1v1h-1v-1zm4 1v-1h1v1zm4 0v-1h1v1z",
    fill: "#312f34"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M62 113v-1h3v1h-1zm21 0v2h-1v-2zm-35-6v-1h1v1z",
    fill: "#e9e9ea"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M47 13v-1h2v1h-1zm-9-6h1v1h-1zm5 1v1h-1V8zm-3 2h-1V9h1z",
    fill: "#edbc01"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M42 18v1h-1v-2h1zm-7-9h-1V8h1zm8-1h1v1h-1zm4 1v1h-1V9z",
    fill: "#ecbd01"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25v1h-2v-1h1zm14-9h-1v-1h1zm-19 1v1h-1v-1zm3 11h-1v-1h1z",
    fill: "#e8bb00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17h1v2h-1v-1zm2 15v-2h1v2zm3-4v1h-1v-1z",
    fill: "#e4b701"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18v1h-1v-1zm3 7h1v1h-1zm-1 3v1h-1v-1zm-4 4v-1h1v1zm0 3v-1h1v1z",
    fill: "#e5b801"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19v1H6v-1zm1 1h1v1H8zm0 2h1v1H8zm5 2h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#e5b401"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23v1h-1v-1zm-8 3v1H5v-1zm6 4h-1v-1h1zm-1 1h-1v-1h1zm-1 0v1H9v-1z",
    fill: "#e3b400"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18 34h2v3h-1v-2h-1zm3-9h1v1h-1z",
    fill: "#e5ba01"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31v-2h1v2zm2-2h-1v-1h1zm-2 4v-1h1v1zm3 0v1h-1v-1z",
    fill: "#e7b901"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M108 44h1v1h-1zm5 3h-1v-1h1zm1 1h-1v-1h1zm1 0v1h-1v-1zm-15 10h-1v-1h1z",
    fill: "#cbcec7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46h-1v1h-1v-2h2zm11 1h-1v-1h1zm-8 1h1v1h-1z",
    fill: "#c4c7c0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47v1h-2v-1h1zm-1 2v1h-1v-1zm-1 4h1v1h-1zm2 2h-1v-1h1z",
    fill: "#b2b3ab"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M105 56v-1h1v1zm9-1v1h-1v-1zm3 0v1h-1v-1zm0 1h1v1h-1zm-10 2h-1v-1h1z",
    fill: "#d0d1cb"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1zm-4 2v-1h1v1zm2 1v-1h1v1zm2 1h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#282828"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v-1h2v1h-1zm24 3h1v1h-2v-1zm9-16h-1v-1h1z",
    fill: "#242425"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80v-2h1v2zm16-16v-1h1v1zm-40 7v1h-1v-1zm26 13h-1v-1h1z",
    fill: "#2d2d2f"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67v-1h3v1h-1zm29 16h1v1h-1zM12 99h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.047
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1zm26 5v1h-1v-1zm5 8h-1v-1h1zm-11 18v1h-1v-1zm-3 4v-1h1v1z",
    fill: "#2d2c2f"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1zm29 12h-1v-1h1zm-15 21h1v1h-1zm10 2v-1h1v1zm7 1v1h-1v-1z",
    fill: "#2f2f31"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1zM21 86v-1h1v1zm4 2h-1v-1h1zm-1 1v1h-1v-1zm51 6h1v1h-1z",
    fill: "#3e383a"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1zm-35 7h1v1h-1zm7 10v-1h1v1zm16 5v1h-1v-1zm20 7v-1h1v1z",
    fill: "#353132"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1zm3-1h1v1h-1zm2 1v1h-1v-1zm1 2h-1v-1h1zm11 4h-1v-1h1z",
    fill: "#212123"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1zm8 3v-1h1v1zm4 0v1h-1v-1zm2 1h-1v-1h1zm5 6v-1h1v1z",
    fill: "#2f2e33"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1zm15 7h-1v-1h1zm-1 0v1h-1v-1zm24 6v-1h1v1zm0 10v-1h1v1z",
    fill: "#29282d"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h2v1h-2zM18 89v-1h1v1zm3 2v-1h1v1zm33 8v-1h1v1z",
    fill: "#373334"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1zm16 24v1h-1v-1zm-4 3v-1h1v1zm2 3v1h-1v-1zm6 2h-1v-1h1z",
    fill: "#2e2c2f"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1zm18 2v-1h1v1zm0 2v1h-1v-1zm31 13v-1h1v1zm-9 16h1v1h-1z",
    fill: "#232327"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1zm8 5h-1v-1h1zm23 11h-1v-1h1zm-11 13v1h-1v-1zm1 3h1v1h-1z",
    fill: "#2a292e"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1zm-43 9h1v1h-1zm9 5h1v1h-1zm4 2h-1v-1h1zm32 10v-1h1v1z",
    fill: "#222021"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1zM72 98v1h-1v-1zm-6 3h-1v-1h1zm5 2v-1h1v1zm15 1v1h-1v-1z",
    fill: "#353336"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1zm5 2h1v1h-1zM59 99v-1h1v1zm19 4v-1h1v1zm4 6v-1h1v1z",
    fill: "#3b393c"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v1h-1v-2h1zm-2 5v-2h1v2zm-1 6h-1v-1h1z",
    fill: "#322a27"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1zm-1 0v1h-1v-1zm26 6h-1v-1h1zm-9 23h-1v-1h1zm-7 1h1v1h-1z",
    fill: "#28272c"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81h1v1h-2v-1zm2-1v-1h1v1zm16 9v1h-1v-1zm-13 5v1h-1v-1z",
    fill: "#24201d"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v2h-1zm0 4v1h-1v-2h1zm-2 3h1v1h-1z",
    fill: "#312926"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84h-1v-1h1zm1-1h1v1h-1zm-2 1v1h-1v-1zm-24 23h-1v-1h1zm11 1h-1v-1h1z",
    fill: "#302f34"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1zm-1 3h-1v-1h1zm-18 6h-1v-1h1zm6 2v-1h1v1zm4 1v-1h1v1z",
    fill: "#231e1b"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88v1h-1v-1zm2 1v-1h1v1zm-4 1h-1v-1h1zm4 3h-1v-1h1zm16 2v-1h1v1z",
    fill: "#433f40"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1zm4 3v1h-1v-1zm3 2h-1v-1h1zm-2 1v-1h1v1zm12 1v-1h1v1z",
    fill: "#444041"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1zm-5 1h1v1h-1zm4 1h-1v-1h1zm3-1h1v1h-1zm0 3h1v1h-1z",
    fill: "#454142"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M12 97v1h-1v-2h1zm-6-4h1v1H6zm9 5v1h-1v-1zm77 21v1h-1v-1z",
    fill: "#010101"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h2v1zm-4-4v-1h1v1zm25 11v-1h1v1zm-2 0h1v1h-1z",
    fill: "#312f32"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1zm13 4h1v1h-1zm4 0v1h-1v-1zm11 6v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#343235"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M103 103h-1v-2h1v1zm-6 3h1v1h-1zm-3 5v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#2b2a30"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119h-1v-1h2v1zm-1 4v-1h1v2h-1zm0-8v-1h1v1z",
    fill: "#000001"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5V4h1v1zm-15 9v-1h1v1zm2 2v-1h1v1zm33 3v-1h1v1z",
    fill: "#efc000"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M33 5h1v1h-1zm-17 8h1v1h-1zm27 7v1h-1v-1zm6 0h1v1h-1z",
    fill: "#efbf00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7h-1V6h1zm7 5h-1v-1h1zm0 3h-1v-1h1zm-6 4h-1v-1h1z",
    fill: "#eebd01"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14h-3v-1h3zm30-6h1v1h-1z",
    fill: "#eebd00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11v-1h1v1zm-15 6h-1v-1h1zm22 0v1h-1v-1zM23 27h1v1h-1z",
    fill: "#eabd01"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1zm-2 2v1h-1v-1zm-29 2v-1h1v1zm28 2h1v1h-1z",
    fill: "#ecba01"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v1H8v-1zm6 4h1v1h-1zm3 0v1h-1v-1zm-5 12v1h-1v-1z",
    fill: "#e5b601"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27v-1h2v2h-1v-1zm-6-10v-1h1v1z",
    fill: "#e6b802"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21v1H6v-2h1zm1-4v1H7v-1zm4 6v1h-1v-1z",
    fill: "#e5b402"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21v1h-1v-2h1zm-6-3h-1v-1h1zm6 7v1h-1v-1z",
    fill: "#e5b700"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18h1v1h-1zm4 6h-1v-1h1zm-2 2h1v1h-1zm2 1v-1h1v1z",
    fill: "#e6b801"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19h1v1H8zm4 12v-1h1v1zm-2 0h1v1h-1zm2 2h-1v-1h1z",
    fill: "#e4b501"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20v1H7v-1zm3 4h-1v-1h1zm0 1v-1h1v1zm0 2v1h-1v-1z",
    fill: "#e3b402"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1zM4 30h1v1H4zm68 26h-1v-1h1zM27 66v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22v-1h3v1zm-5 0v-1h1v1z",
    fill: "#f1c001"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23v1H5v-1zm3 1v-1h1v1zm4 1v1h-1v-1zm-1 4h-1v-1h1z",
    fill: "#e2b401"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24v-1h1v2h-1zm-1 5h1v1h-1zm-4 1h1v1H9z",
    fill: "#e2b500"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1zM15 56v1h-1v-1zm1 2h-1v-1h1zm6 4h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.055
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M20 26h1v2h-1v-1zm-1 2h1v1h-1zm-2 5v1h-1v-1z",
    fill: "#e6b800"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26v1h-1v-1zm-5 6v-1h1v1zm3 2v1h-1v-1zm-2 1v1h-1v-1z",
    fill: "#e7ba01"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29h2v1h-1v1h-1zm0 6h1v1h-1z",
    fill: "#e3b801"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30h1v1h-1zm-1 3h-1v-1h1zm2 0v-1h1v1zm0 3h1v1h-1z",
    fill: "#e4b801"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h-1v-1h2v1zm-5-1h1v1h-1zm2 1v-1h1v1z",
    fill: "#2a2a2a",
    fillOpacity: 0.094
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h-2v-1h2zm-7-18h-1v-1h1zm10 0h-1v-1h1z",
    fill: "#2a2a2b"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1zm-9 12v1h-1v-1zM56 74v1h-1v-1zm14 33v-1h1v1z",
    fill: "#262526"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v-1h1v1zm4 0h1v1h-1zm5 2h-1v-1h1zm-5 1v-1h1v1z",
    fill: "#c8cbc4"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46v-1h1v2h-1zm0 4h1v1h-1zm1 2v1h-1v-1z",
    fill: "#afb0a8"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M100 45h1v2h-1v1h-1v-2h1z",
    fill: "#c1c2bc"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v2h-1v-2zm1-1v1h-1v-1zm2 9v1h-1v-1z",
    fill: "#b5b7ac"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46h1v1h-1zm1 15v-1h1v1zm-2 1v-1h1v1zm-2 0v1h-1v-1z",
    fill: "#404143"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h2v1h-2zm-3 0v-1h1v1zm-1 8h1v1h-1z",
    fill: "#cdd0c9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1zM54 72v-1h1v1zm3 0h-1v-1h1zm6 0v1h-1v-1z",
    fill: "#242426"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M118 52v1h-1v-1zm-4 1h1v1h-1zm3 2h-1v-1h1zm0 1v-1h1v1z",
    fill: "#cfd0ca"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1zM58 71v1h-1v-1zm21 9v1h-1v-1zm15 34v-1h1v1z",
    fill: "#262628"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54v1h-2v-1h1zm-8 1v1h-1v-1zm8 1h1v1h-1z",
    fill: "#d2d3cd"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57v-1h2v2h-1v-1zm-2 0v1h-1v-1z",
    fill: "#cacbc5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1zm3 4h1v1h-1zm4 2h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#212121"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h1v1h-2v-1zm-6-1v-1h1v1zM59 72h1v1h-1z",
    fill: "#222223"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64h-1v-3h1zm-3-4v-1h1v1z",
    fill: "#252525"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1zm4 1v-1h1v1zm-1 1h-1v-1h1zm2 2v-1h1v1z",
    fill: "#202020"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1zm-1 3v-1h1v1zm3 0v-1h1v1zm-10 50v-1h1v1z",
    fill: "#2f2f2f"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h-1v-2h2v1h-1zm-27 50h-1v-1h1z",
    fill: "#5a5a5a"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M118 60h1v1h-2v-1zm-3 1h1v1h-1zm2 4h-1v-1h1z",
    fill: "#464749"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1zm2 2h-1v-1h1zM29 94h1v1h-1zm30 10v-1h1v1z",
    fill: "#1c1b1b"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1zm3 0v-1h1v1zM22 93h-1v-1h1zm58 18v-1h1v1z",
    fill: "#1b1b1b"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v2h-1v-2zm15-40h-1v-1h1zM89 83h-1v-1h1z",
    fill: "#39393a"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M103 66h2v1h-2zm6 1v-1h1v1zM6 98v-1h1v1z",
    fill: "#5a5a5a",
    fillOpacity: 0.067
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1zm-2 30v1h-1v-1zm15 0v1h-1v-1zm2 2v1h-1v-1z",
    fill: "#383637"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1zm0 3v-1h1v1zM21 88v-1h1v1zm1 2v-1h1v1z",
    fill: "#3a3436"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1zm32 8h-1v-1h1zm21 16v1h-1v-1zm-46 5v1h-1v-1z",
    fill: "#303032"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1zm5 0h1v1h-1zm18 12h1v1h-1zm9 30v-1h1v1z",
    fill: "#2a2a2c"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-3v-1zm32 39v-1h1v1z",
    fill: "#2c2c2e"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h2v1h-2zm16-19h-1v-1h1zM23 91v-1h1v1z",
    fill: "#413b3d"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1zm52 15v1h-1v-1zm-29 13v1h-1v-1zm18 6h1v1h-1z",
    fill: "#2c2a2f"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M60 73v1h-2v-1h1zm-3 1h1v1h-1zm21 7v1h-1v-1z",
    fill: "#232326"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1zm18 2v1h-1v-1zm30 17v-1h1v1zm-13 15v1h-1v-1z",
    fill: "#232227"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1zm2 2h-1v-1h1zm-8 2v-1h1v1zm5 0h-1v-1h1z",
    fill: "#1d1d1e"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1zm11 5h1v1h-1zm20 5h1v1h-1zm-12 24h-1v-1h1z",
    fill: "#2b2a2f"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v2h-1zm4 0h-1v-1h1zm4 1v-1h1v1z",
    fill: "#1f1f21"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1zm-6 2h-1v-1h1zm4 0h-1v-1h1zm5 1h-1v-1h1z",
    fill: "#1e1e21"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1zM12 87v-1h1v1zm22 9h-1v-1h1zm63 17v-1h1v1z",
    fill: "#262324"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1zm2 3h-1v-1h1zm0 1v-1h1v1zm-3 1v-1h1v1z",
    fill: "#252429"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1zm20 4v1h-1v-1zm3 1v1h-1v-1zM69 94h1v1h-1z",
    fill: "#251f1d"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1zm2 0v1h-1v-1zm-4 12v1h-1v-1zm5 1v1h-1v-1z",
    fill: "#25201c"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1zm3-1v1h-1v-1zm11 25v1h-1v-1zm-5 6h-1v-1h1z",
    fill: "#2d2c31"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1zm-2 5v-1h1v1zm5 21v1h-1v-1zm-3 4v1h-1v-1z",
    fill: "#313034"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97h-1v-1h2v2h-1zm47-15h1v1h-1z",
    fill: "#403e41"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M106 83h-1v-1h1zm-6 3v-1h1v1zm-16 1h-1v-1h1zm-5 20h1v1h-1z",
    fill: "#39383d"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1zm15 1h-1v-1h1zm-18 0h1v1h-1zm-28 7v1h-1v-1z",
    fill: "#3f3d41"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85v1h-1v-1zm4 10h-1v-1h1zm-1 2v1h-1v-1zm-5 8v-1h1v1z",
    fill: "#323137"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h1v1h-1zm35 12h-1v-1h1zm-1 0v1h-1v-1zm3 2v-1h1v1z",
    fill: "#393536"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1zm3 6v-1h1v1zm14 6h1v1h-1zm10 2h1v1h-1z",
    fill: "#39373a"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1zm8 6h-1v-1h1zm19 4v1h-1v-1zm-10 2h-1v-1h1z",
    fill: "#302e31"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1zm7 1h-1v-1h1zm10 3v-1h1v1zm-2 5v-1h1v1z",
    fill: "#323034"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1zm-8 3v1h-1v-1zm26 4h-1v-1h1zm-2 5h-1v-1h1z",
    fill: "#373538"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-2h1zm1-2h1v1h-1zm1 2h1v1h-1z",
    fill: "#2c2a2d"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M102 101v-1h1v1zm-25 5h-1v-1h1zm14-1h1v1h-1zm-1 3h1v1h-1z",
    fill: "#38363b"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1zm9 1h-1v-1h1zm1 2h1v1h-1zm1 2v-1h1v1z",
    fill: "#323235"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M35 4v1h-2V4h1zm17 17h1v1h-1z",
    fill: "#f1bf00"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6v1h-1V6zm3 2V7h1v1zm-2 11v-1h1v1z",
    fill: "#ecbd02"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h-1V7h1zm-24 5h-1v-1h1zm8 3v1h-1v-1z",
    fill: "#ecbe01"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9h1v1h-1zm40 12h-1v-1h1zm1 2v-1h1v1z",
    fill: "#efbf01"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10v1h-1v-1zm10 2h-1v-1h1zM9 13v-1h1v1z",
    fill: "#ecbb03"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M43 11h-1v-1h2v1zm-7 2h-1v-1h1z",
    fill: "#edbb01"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12h1v1h-1zm3 1v1h-1v-1zm38 6v1h-1v-1z",
    fill: "#efbe00"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-2v-1h1zM21 29v-1h1v1z",
    fill: "#e9ba01"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16h1v1h-1zm5 3h-1v-1h1zm3 1h-1v-1h1z",
    fill: "#e6b701"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17h1v1H6zm4 1v-1h1v1zm2 16v-1h1v1z",
    fill: "#e4b602"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18h-1v-1h1zm6 9v1h-1v-1zm-2 5v1h-1v-1z",
    fill: "#e5b702"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17h1v1h-1zm6 7h1v1h-1zm0 3v1h-1v-1z",
    fill: "#e7b900"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19v-1h1v1zm5 2h1v1h-1zm1 7h-1v-1h1z",
    fill: "#e3b501"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19v-1h1v1zm-1 16h-1v-1h1zm0 2v-1h1v1z",
    fill: "#e6b900"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21v2h-1v-2zm-1 0H9v-1h1z",
    fill: "#e5b400"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20v2h-1v-1h-1v-1z",
    fill: "#e7b501"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h1v1h-2z",
    fill: "#f0c101"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1zm-2 2h-1v-1h1zm-7 1v-1h1v1z",
    fill: "#c2e0cd"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v-1h1v1zm5 0v-1h1v1zm3 8v1h-1v-1z",
    fill: "#e6b400"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24H4v-1h1zm3 1h1v1H8zm1 2v1H8v-1z",
    fill: "#e3b300"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24H8v-1h1zm-1 0v1H7v-1zm3 5h-1v-1h1z",
    fill: "#e3b401"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h3v1h-1z",
    fill: "#f2c200"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1zm4 1h-1v-1h1zm1-1h1v1h-1z",
    fill: "#f4c502"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-2v-1h2zm-4-1h1v1h-1z",
    fill: "#f4c402"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1zm-1 4h1v1h-1zm3 3v-1h1v1z",
    fill: "#fdf2c5"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30v-1h1v2H8zm5-1h-1v-1h1z",
    fill: "#e2b400"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32h-1v-3h1v1z",
    fill: "#e5b902"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34h-1v-1h2v1zm2-4h-1v-1h1z",
    fill: "#e7ba02"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h2v1h-1zm-13-6v1h-1v-1z",
    fill: "#000200"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1zM67 74h-1v-1h1zm19 38v-1h1v1z",
    fill: "#242325"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1zm8 11v1h-1v-1zM54 69h1v1h-1z",
    fill: "#363637"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66h1v1h-2v-1zM81 43h1v1h-1z",
    fill: "#636363",
    fillOpacity: 0.071
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h1v1h-2v-1zm-3 1v-1h1v1z",
    fill: "#a6a8a5"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1zm6 4v-1h1v1zm-4 5h-1v-1h1z",
    fill: "#b6b8af"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M107 45v-1h1v1zm5 0v-1h1v1zm1 1v-1h1v1z",
    fill: "#caccc6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44h1v1h-1zm6 12v1h-1v-1zm-9 3h-1v-1h1z",
    fill: "#cbccc7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M121 45v-1h1v1zm-11 9h-1v-1h1zM10 98v1H9v-1z",
    fill: "#888",
    fillOpacity: 0.059
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1zm-1 9v1h-1v-1zm4 3v-1h1v1z",
    fill: "#b2b3aa"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M114 46v-1h1v1zm1 2h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#c9ccc5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1zm0 9h-1v-1h1zm0 0h1v1h-1z",
    fill: "#b5b6ae"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47v-1h1v2h-1zm-1-1v1h-1v-1z",
    fill: "#cacdc6"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h-1v-3h1z",
    fill: "#aeafa7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v-1h1v1zm-5 11h1v1h-1zm5 2v-1h1v1z",
    fill: "#444547"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1zm3 0h-1v-1h1zm-4 0v1h-1v-1z",
    fill: "#f9feff"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-2h1v2zm-1 4h1v1h-1z",
    fill: "#b3b4ac"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49h-1v-1h1zm1 10h-1v-1h1zm-4 2v1h-1v-1z",
    fill: "#47484a"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1zm2-1h1v1h-1zm-6 2h1v1h-1z",
    fill: "#fcfeff"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-2h1zm0-2h1v1h-1z",
    fill: "#b6b7af"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h2v1zm4 5v-1h1v1z",
    fill: "#42433f"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h3v1h-3z",
    fill: "#fefdff"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M111 52h-1v-1h1zM53 64h1v1h-1zM16 75v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M116 54h-1v-1h2v1zm-1-3h1v1h-1z",
    fill: "#cecfc9"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54h-1v-1h1zm0 7v-1h1v1zm1 1h1v1h-1z",
    fill: "#585858"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M114 55h-1v-1h1zm1 1v-1h1v1zm-7 2v-1h1v1z",
    fill: "#d5d6d0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M118 54v1h-1v-1zm-12 3h-1v-1h1zm-3 0h1v1h-1z",
    fill: "#cdcec8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1zm3 1h1v1h-1zm-1 2h-1v-1h1z",
    fill: "#b0b2a7"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M90 58h-2v-1h2zm0-2h-1v-1h1z",
    fill: "#b1b3a8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1zm-1 2h1v1h-1zM28 95h-1v-1h1z",
    fill: "#2d2d2d"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59v1h-1v-1zm19 3v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#38393c"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1zm0 2v-1h1v1zm1 1v-1h1v1z",
    fill: "#1f1f1f"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1zm1 3h1v1h-1zm4 0v1h-1v-1z",
    fill: "#242424"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1zm2 0h1v1h-1zm-5 61h-1v-1h1z",
    fill: "#313131"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62h1v1h-2v-1zM16 95h-1v-1h1z",
    fill: "#333"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M100 63h-1v-1h1zM89 82h1v1h-1zm-3 25h1v1h-1z",
    fill: "#363738"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h-1v-1h1zm-1 1h1v1h-1zm-60 36h-1v-1h1z",
    fill: "#454545"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64h1v1h-1zM80 77v-1h1v1zm24 22h1v1h-1z",
    fill: "#333336"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66h2v1h-2zm-4 10v1h-1v-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.086
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-3v-1h3z",
    fill: "#616161",
    fillOpacity: 0.082
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M105 66h1v1h-1zm6 1v-1h1v1zM3 87v-1h1v1z",
    fill: "#4f4f4f",
    fillOpacity: 0.063
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1zm-6 20h-1v-1h1zm17 9h1v1h-1z",
    fill: "#484344"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1zM31 89h1v1h-1zm14 8h-1v-1h1z",
    fill: "#453f41"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68v1h-3v-1z",
    fill: "#3e3b38"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-2v-1h1zm15 29v1h-1v-1z",
    fill: "#333032"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1zm5 27v-1h1v1zm15 1h1v1h-1z",
    fill: "#363336"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1zM20 87h1v1h-1zm4 3h1v1h-1z",
    fill: "#3c3638"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h3v1z",
    fill: "#363135"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1zm2 2h1v1h-1zM20 88h1v1h-1z",
    fill: "#393335"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1zm0 4h-1v-1h1zm5 28v-1h1v1z",
    fill: "#2b292a"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1zM24 91v1h-1v-1zm8 2h1v1h-1z",
    fill: "#3b3738"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M18 87v-2h1v2zm29-15v1h-1v-1z",
    fill: "#363233"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1zM19 87v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#343031"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1zm16 2v1h-1v-1zm10 3v1h-1v-1z",
    fill: "#252527"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1zm19 6v-1h1v1zm0 4h-1v-1h1z",
    fill: "#29292b"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1zm-56 29h1v1h-1zm35 12h-1v-1h1z",
    fill: "#484848",
    fillOpacity: 0.027
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1zm2 26v1h-1v-1zm15 3h-1v-1h1z",
    fill: "#302e2f"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M54 73v1h-1v-1zm28 5h-1v-1h1zm1 32h1v1h-1z",
    fill: "#29282a"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1zm28 32v1h-1v-1zm-2 5v-1h1v1z",
    fill: "#2b2c30"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1zm3 5h-1v-1h1zm4 2v1h-1v-1z",
    fill: "#212024"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1zm-1 4v-1h1v1zm0 4h-1v-1h1z",
    fill: "#382e2c"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h2v1h-1zm1 2v-1h1v1z",
    fill: "#1d1d20"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1zm-4 1v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#1f1e23"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v2h-1zm3-9h-1v-1h1z",
    fill: "#302825"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1zm-2 5h1v1h-1zm-2 7v1h-1v-1z",
    fill: "#2e2623"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1zm0 2v-1h1v1zm-2 5h1v1h-1z",
    fill: "#2b2321"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1zm3-1v1h-1v-1zm13 5v-1h1v1z",
    fill: "#25201e"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1zm-2 2h1v1h-1zm32 16h-1v-1h1z",
    fill: "#232226"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v2h-1v-1zm-2 9v-1h1v1z",
    fill: "#3a302e"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80h-1v-2h1v1zm-2 6v1h-1v-1z",
    fill: "#2c2523"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1zm6 6h1v1h-1zm4 1h-1v-1h1z",
    fill: "#434145"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v2h-1zm-1 3h1v1h-1z",
    fill: "#403532"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1zm19 6v-1h1v1zm-22 6v1h-1v-1z",
    fill: "#261f1d"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83v2h-1v-2zm1-2h-1v-1h1z",
    fill: "#2c2422"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1zm-9 21h1v1h-1zm-7 3h1v1h-1z",
    fill: "#333135"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80h1v1h-1zM75 93h1v1h-1zm0 6h-1v-1h1z",
    fill: "#433e42"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h1v1h-1zm-58 8v1h-1v-1zm7 4v-1h1v1z",
    fill: "#3c393b"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83h2v1h-2zm-9-1v1h-1v-1z",
    fill: "#39373c"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M92 83v-1h1v1zm9 6h-1v-1h1zm-25 5v1h-1v-1z",
    fill: "#403d42"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82h1v1h-1zm-2 2h1v1h-1zm-18 9v1h-1v-1z",
    fill: "#424044"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83h-1v-1h1zm-11 2v-1h1v1zm7 2v-1h1v1z",
    fill: "#3e3d42"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M13 84v-1h1v1zm1 3v-1h1v1zm2 1h-1v-1h1z",
    fill: "#2c2829"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M98 83h1v1h-1zm-17 3v-1h1v1zM57 97v1h-1v-1z",
    fill: "#3d3b3f"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85v-1h2v1H8zm3 0v-1h1v1z",
    fill: "#231f20"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M95 84h1v2h-1v-1zm-13 1v-1h1v1z",
    fill: "#3d3b40"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85h1v1h-1zm-23 18v-1h1v1zm10 2h-1v-1h1z",
    fill: "#333237"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M10 86h1v1h1v1h-2z",
    fill: "#232122"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1zm11 5v-1h1v1zm8 3v1h-1v-1z",
    fill: "#464243"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-2v-1h1zm-18-4v1h-1v-1z",
    fill: "#413c3e"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1zm7 0h1v1h-1zm-5 5v1h-1v-1z",
    fill: "#443e40"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1zm36 9v1h-1v-1zm31 4v-1h1v1z",
    fill: "#363334"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M105 91v-1h1v1zm2-1h1v1h-1zm-5 15h-1v-1h1z",
    fill: "#2a292f"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92h-1v-1h1zm19 6v-1h1v1zm27 8v-1h1v1z",
    fill: "#131212"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1zm4 1h-1v-1h1zm10 3h-1v-1h1z",
    fill: "#292323"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1zm0 8h-1v-1h1zm3 0h1v1h-1z",
    fill: "#343234"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1zm-6 4v1h-1v-1zm53 10h-1v-1h1z",
    fill: "#cacaca"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1zm14 6h-1v-1h1zm18 10h-1v-1h1z",
    fill: "#2e2d31"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1zm2 2v-1h1v1zm4 4h-1v-1h1z",
    fill: "#373537"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1zm22 7v-1h1v1zm21 13v1h-1v-1z",
    fill: "#e2e2e2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1zm2 2v-1h1v1zm4 2h-1v-1h1z",
    fill: "#363439"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1zm6 0h-1v-1h1zm-9 2h-1v-1h1z",
    fill: "#2e2c2e"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1zm36 10v1h-1v-1zm-12 5h-1v-1h1z",
    fill: "#e7e7e7"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1zm-3 3v1h-1v-1zm11 4h1v1h-1z",
    fill: "#302e32"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1zm-14 4h-1v-1h1zm23 7h-1v-1h1z",
    fill: "#333236"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1zm7 2h-1v-1h1zm39 6h-1v-1h1z",
    fill: "#f0f0ef"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v1h-2v-1h1zm0-4h-1v-1h1z",
    fill: "#010103"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M93 120v1h1v1h-2v-2z",
    fill: "#000002"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4h-1V3h1zm-4 5h1v1h-1z",
    fill: "#f1c81c"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M32 3h1v1h-1zm-2 3v1h-1V6z",
    fill: "#efc61e"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4v1h-1V4zm0 8v-1h1v1z",
    fill: "#f0c200"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4h1v1h-1zm7 12v-1h1v1z",
    fill: "#eec001"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M37 4v1h-1V4zm8 19h-1v-1h1z",
    fill: "#f2c201"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5h1v1h-1zm-1 34v-1h1v1z",
    fill: "#eec919"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6V5h1v1zm1 1V6h1v1z",
    fill: "#edc007"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M37 6V5h1v1zm9 5v-1h1v1z",
    fill: "#edbe02"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h1v1h-1zm-2 15h1v1h-1z",
    fill: "#f3c203"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7V6h1v1zm-5 3h-1V9h1z",
    fill: "#ebbe02"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M41 7h-1V6h1zm-3 0v1h-1V7z",
    fill: "#eebd03"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7V6h1v1zm-26 5v1h-1v-1z",
    fill: "#f0bf00"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M34 7h1v1h-1zm-9 21v-1h1v1z",
    fill: "#ebbe03"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M37 7v1h-1V7zm10 5v-1h1v1z",
    fill: "#edbd02"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7h1v1h-1zm10 7h-1v-1h1z",
    fill: "#efbc02"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h-1V7h1zm8 13v-1h1v1z",
    fill: "#efbd00"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8h1v1h-2V8z",
    fill: "#f1c300"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9V8h1v1zM18 9v1h-1V9z",
    fill: "#f2c712"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9V8h1v1zm-7 20h-1v-1h1z",
    fill: "#ebbf02"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h1v1h-1zm6 5h1v1h-1z",
    fill: "#f1c102"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h-1V9h1zm32 13h-1v-1h1z",
    fill: "#f1c201"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V9h1v1zm8 9v-1h1v1z",
    fill: "#eec106"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V9h1v1zm0 2v1h-1v-1z",
    fill: "#ecbc02"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9v1h-1V9zM14 36h-1v-1h1z",
    fill: "#ecbb05"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-1zm-1 9v1h-1v-1z",
    fill: "#eebc01"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1zm-1 2h1v1h-1z",
    fill: "#ecbd03"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M31 10v1h-1v-1zm21 12v1h-1v-1z",
    fill: "#f1c000"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M32 11h-1v-1h1zm-6 19h-1v-1h1z",
    fill: "#ebc003"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-2v-1h1z",
    fill: "#edbc02"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11h1v1h-1zm23 12h1v1h-1z",
    fill: "#f2c503"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12v-1h1v1zm8 0h-1v-1h1z",
    fill: "#edba02"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v1h-1v-1zM24 26h1v1h-1z",
    fill: "#eabc02"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1zM12 35h-1v-1h1z",
    fill: "#ecbc08"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12h1v1h-1zm-13 1h1v1h-1z",
    fill: "#f0c303"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h1v1zM23 28h1v1h-1z",
    fill: "#eabc01"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1zm-26 3h-1v-1h1z",
    fill: "#ebbc02"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1zm-32 1h1v1h-1z",
    fill: "#ecbb01"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14v-1h1v1zm32-1v1h-1v-1z",
    fill: "#ecba00"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13h1v1h-1zm23 8h1v1h-1z",
    fill: "#f0c202"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1zm-25 3v-1h1v1z",
    fill: "#eaba01"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H4v-1h1zm58 46h1v1h-1z",
    fill: "#e7ffff",
    fillOpacity: 0.043
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v1h-1v-1zm32 4h-1v-1h1z",
    fill: "#eebf01"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1zm-24 3h-1v-1h1z",
    fill: "#ebba01"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16v-2h1v2z",
    fill: "#ebbb01"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H7v-1h1zm7 3v1h-1v-1z",
    fill: "#e7b701"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16h1v1H6zm8 18h1v1h-1z",
    fill: "#e7b601"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H9v-1h1zm3 2v1h-1v-1z",
    fill: "#e6b601"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-1h1v1zm4 18h1v1h-1z",
    fill: "#e7b801"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17v-1h1v1zM8 32v-1h1v1z",
    fill: "#e8b801"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17v-1h1v1zm6 11h1v1h-1z",
    fill: "#e9bb01"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16h1v1h-1zm-8 77h-1v-1h1z",
    fill: "#fefefe"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h1v1h-1zm0 2h-1v-1h1z",
    fill: "#fbfcfb"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-1h1zm22 92h-1v-1h1z",
    fill: "#ececeb"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1zm-2 1v-1h1v1z",
    fill: "#cfe3c6"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18h-1v-1h1zm1 15h1v1h-1z",
    fill: "#e7b800"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1zm2-1h1v1h-1z",
    fill: "#cee2c7"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19h-1v-1h1zm29 30h1v1h-1z",
    fill: "#fbfeff"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1zm-33 2v1h-1v-1z",
    fill: "#cce7d4"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1zm6 11h1v1h-1z",
    fill: "#c8e6d5"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21H2v-1h1zm22 42v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1zm8 1v1h-1v-1z",
    fill: "#f0bf01"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21v-1h1v2h-1z",
    fill: "#f0c000"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1zm3 0v1h-1v-1z",
    fill: "#f0c001"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H8v-1h1zm-5 1v-1h1v1z",
    fill: "#e6b300"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22v-1h1v1zm4 0v1h-1v-1z",
    fill: "#e5b500"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1zm-3 0h1v1h-1z",
    fill: "#d1e6d9"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1zm10 1h1v1h-1z",
    fill: "#f1c101"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1zm2 1h-1v-1h1z",
    fill: "#c2e1ca"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22h1v1h-1zm0 10v-1h1v1z",
    fill: "#e6b501"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22h1v1h-1zm-4 3v-1h1v1z",
    fill: "#e6b602"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1zm31 8v1h-1v-1z",
    fill: "#cfe5d6"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23h-2v-1h2z",
    fill: "#f1c302"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M46 24v-2h1v2z",
    fill: "#f1c301"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24v-1h1v1zm2 5v1H7v-1z",
    fill: "#e3b301"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h-1v-1h1zm39 20v1h-1v-1z",
    fill: "#b5d1c5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24h-1v-1h1zM9 42v-1h1v1z",
    fill: "#d6e8d7"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1zm3 1v-1h1v1z",
    fill: "#f1c502"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1zm6 2h-1v-1h1z",
    fill: "#f3c402"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-2v-1z",
    fill: "#f3c301"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25v-1h1v1zm2 3H6v-1h1z",
    fill: "#e2b300"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1zM27 49h1v1h-1z",
    fill: "#bcd6c8"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1zM11 41v1h-1v-1z",
    fill: "#bedac6"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1zM29 47h-1v-1h1z",
    fill: "#c0dbc5"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1zm7 11h-1v-1h1z",
    fill: "#fff4b7"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1zm4 2h-1v-1h1z",
    fill: "#f3c703"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1zm-7 31h1v1h-1z",
    fill: "#d1e5df"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26v1H8v-1zm0 4v-1h1v1z",
    fill: "#e4b400"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29v-1h1v1zm-1 3v-1h1v1z",
    fill: "#e9bd04"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1zm-8 4h-1v-1h1z",
    fill: "#bce0d3"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1zm-1 6h1v1h-1z",
    fill: "#fef4cf"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#e6b901"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-2v-1h2z",
    fill: "#cbe9db"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1zm-5 7h-1v-1h1z",
    fill: "#c5ecdc"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1zm-1 6v1h-1v-1z",
    fill: "#edc517"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1zm1 3v-1h1v1z",
    fill: "#fff1b3"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1zM17 45h-1v-1h1z",
    fill: "#b1d5c5"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33v1h-1v-1zm1 1h1v1h-1z",
    fill: "#e4b603"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v1h-1v-1zm-2 3v-1h1v1z",
    fill: "#e6ba01"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1zm-11 0h1v1h-1z",
    fill: "#fee68a"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34v1h-1v-2h1z",
    fill: "#d3eed7"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1zm-9 1h1v1h-1z",
    fill: "#d3eedf"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#fff0b3"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36v1h-1v-2h1z",
    fill: "#f4d03d"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v2h-1v-1z",
    fill: "#fadd64"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1zm-2 1v-1h1v1z",
    fill: "#01fee5"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1zm-2 3h-1v-1h1z",
    fill: "#00fffd"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h2v1h-2z",
    fill: "#4f4f4f",
    fillOpacity: 0.114
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v-1h1v1zm15-1v1h-1v-1z",
    fill: "#525252",
    fillOpacity: 0.122
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41h-1v-1h1zm16-1v1h-1v-1z",
    fill: "#575757",
    fillOpacity: 0.137
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1zm4 1v-1h1v1z",
    fill: "#03fdff"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1zm-1 1v-1h1v1z",
    fill: "#01feff"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43v-1h1v2h-1z",
    fill: "#bed8c6"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1zm-5 2v-1h1v1z",
    fill: "#0ff"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1zm-5 0v1h-1v-1z",
    fill: "#00feff"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1zM60 70v-1h1v1z",
    fill: "#5f5f5f",
    fillOpacity: 0.063
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43v-1h2v1h-1z",
    fill: "#1d1b1d"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1zM56 76v1h-1v-1z",
    fill: "#201f20"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1zm-4 17h1v1h-1z",
    fill: "#2c2c2d"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43v-1h1v1zm19 15v-1h1v1z",
    fill: "#494b4c"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v1h-1v-1zm-19 76v1h-1v-1z",
    fill: "#565759"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M118 42v1h-1v-1zm-17 23v-1h1v1z",
    fill: "#2e2f31"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43v1h-1v-2h1z",
    fill: "#303132"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44h-1v-1h1zm33 8h1v1h-1z",
    fill: "#b7d1c8"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1zm15 5h1v1h-1z",
    fill: "#b4d1c2"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M105 44h-1v-1h1zm11 15h-1v-1h1z",
    fill: "#a8aaa7"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M111 43h2v1h-2z",
    fill: "#9fa19d"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M117 44v-1h1v1zm-8 6v-1h1v1z",
    fill: "#5e6060"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1zm-9 6v1h-1v-1z",
    fill: "#aec4b8"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1zm-1 35v1h-1v-1z",
    fill: "#2b2b2e"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1zm4 2v-1h1v1z",
    fill: "#b7b9b0"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1zm5 3v-1h1v1z",
    fill: "#b9bab1"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h2v1h-2z",
    fill: "#b9bbb2"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-2v-1h2z",
    fill: "#bcbeb5"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h-1v-1h2v1z",
    fill: "#bfc1b7"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h2v1z",
    fill: "#c4c5be"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1zm-4 13h-1v-1h1z",
    fill: "#c5c7bf"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M118 45h-1v-1h1zm1 8h-1v-1h1z",
    fill: "#c2c3bf"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M9 46H8v-1h1zm62 11h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1zm-10 2v1h-1v-1z",
    fill: "#bcd5c7"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1zm-22 7v-1h1v1z",
    fill: "#a9c2b8"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1zm-4 4h-1v-1h1z",
    fill: "#d1fefe"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46v1h-1v-2h1z",
    fill: "#b3b4ad"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47v-2h1v2z",
    fill: "#c5c7c0"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46h-2v-1h2z",
    fill: "#c5c8c0"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M118 46h-1v-1h1zm0 4h-1v-1h1z",
    fill: "#c9cbc4"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46v1h-1v-2h1z",
    fill: "#abaea9"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M120 45v1h-1v-1zm-2 20h-1v-1h1z",
    fill: "#3b3c3e"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M122 45v1h-1v-1zM88 66v1h-1v-1z",
    fill: "#787878",
    fillOpacity: 0.067
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1zm3 6v1h-1v-1z",
    fill: "#abc8b8"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-2h1v2z",
    fill: "#6d6d6c"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1zm0 11h-1v-1h1z",
    fill: "#b6b8ae"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1zm0 0v1h-1v-1z",
    fill: "#c3c4be"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1zm11 2v1h-1v-1z",
    fill: "#bdd7c7"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1zm-12 7h1v1h-1z",
    fill: "#c2dac8"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1zm-15 9v1h-1v-1z",
    fill: "#a8c3b1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1zm3 1h1v1h-1z",
    fill: "#a8c5ad"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1zm-1 11v-1h1v1z",
    fill: "#bcbdb5"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49h-2v-1h2z",
    fill: "#bbd6c7"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1zm1 2v1h-1v-1z",
    fill: "#c2dacc"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1zm-9 6v1h-1v-1z",
    fill: "#b0c8bb"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1zm3 0h1v1h-1z",
    fill: "#f6ffff"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1zm1 9v-1h1v1z",
    fill: "#b4b5ac"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1zm4 0h-1v-1h1z",
    fill: "#fcfffe"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1zm-50 56h1v1h-1z",
    fill: "#080808",
    fillOpacity: 0.118
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1zm-5 32h-1v-1h1z",
    fill: "#252526"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1zm8 7v1h-1v-1z",
    fill: "#b5b7ad"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M114 49h1v1h-1zm-11 8v1h-1v-1z",
    fill: "#cdcec7"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#c9cac4"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M116 50v-1h1v1zm-15 5h1v1h-1z",
    fill: "#c7c8c2"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1zM27 61v1h-1v-1z",
    fill: "#a8c5b5"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1zm-2 1h-1v-1h1z",
    fill: "#fffbfe"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v2h-1v-1z",
    fill: "#080808",
    fillOpacity: 0.122
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M115 51v-1h1v1zm1 1v-1h1v1z",
    fill: "#cbccc6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1zm-22 0h1v1h-1z",
    fill: "#aecbc3"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1zm-6 2h-1v-1h1z",
    fill: "#fff7fe"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1zM28 65h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.09
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M114 51h1v1h-1zm0 6v-1h1v1z",
    fill: "#d3d4ce"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1zm2 7h1v1h-1z",
    fill: "#a8c2b5"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1zm10 2h1v1h-1z",
    fill: "#b0c7ba"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1zm3 0v1h-1v-1z",
    fill: "#ffefff"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1zM53 71h1v1h-1z",
    fill: "#272628"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1zm-35 9v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1zm16 10h1v1h-1z",
    fill: "#3c3c3c"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54v-1h1v1zm-13 7h1v1h-1z",
    fill: "#2e2e2e"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M114 53v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#d4d5d0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M119 53v1h-1v-1zm-8 5v1h-1v-1z",
    fill: "#c5c6c1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#757470"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v1h-1v-1zm-12 5v-1h1v1z",
    fill: "#cacbc6"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-1h1v1zm2-1h1v1h-1z",
    fill: "#a6c3af"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57v-2h1v2z",
    fill: "#b2c9ba"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h2v1h-2z",
    fill: "#b2cabc"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1zm1 1h1v1h-1z",
    fill: "#b2b4a9"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M107 56h-1v-1h1zm0 1v-1h1v1z",
    fill: "#d1d3cd"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M113 56v1h-1v-2h1z",
    fill: "#d6d7d1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1zm1 5v-1h1v1z",
    fill: "#a9c2b2"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1zm-2 2h1v1h-1z",
    fill: "#a6c0b2"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1zm-2 1h1v1h-1z",
    fill: "#afcbbd"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M59 56h1v2h-1v-1z",
    fill: "#fed3ff"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1zM34 97v-1h1v1z",
    fill: "#232223"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57h1v1h-1zm-1 1v1h-1v-1z",
    fill: "#abc2af"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h2v1z",
    fill: "#fbd7fd"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#a6c2af"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M56 58h2v1h-2z",
    fill: "#f7dcff"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1zm4 1h-1v-1h1z",
    fill: "#979892"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1zm-1 2h-1v-1h1z",
    fill: "#f4d9ff"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h2v1z",
    fill: "#f8e0fe"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1zM56 72h-1v-1h1z",
    fill: "#232325"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1zm5 0v-1h1v1z",
    fill: "#272726"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1zm6 5h-1v-1h1z",
    fill: "#2b2b2a"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60v-1h2v1h-1z",
    fill: "#4b4b4a"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M107 59h1v1h-1zM34 96v1h-1v-1z",
    fill: "#4e4e4e"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M120 59v1h-1v-1zm-2 3h-1v-1h1z",
    fill: "#454648"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1zm-11 46v-1h1v1z",
    fill: "#2f2f30"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1zM16 92h-1v-1h1z",
    fill: "#303030"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M103 61v-1h1v1zm-15 61h1v1h-1z",
    fill: "#505050"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60h1v1h-1zm4 3h-1v-1h1z",
    fill: "#525252"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M105 60h1v1h-1zm5 2v1h-1v-1z",
    fill: "#4f4f4f"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63h-1v-2h1v1z",
    fill: "#323232"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1zm15 2h1v1h-1z",
    fill: "#383838"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62h-1v-1h1zm-48 42v-1h1v1z",
    fill: "#4e4f4f"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M113 61h1v1h-1zm-8 2h1v1h-1z",
    fill: "#494948"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1zM61 75h1v1h-1z",
    fill: "#1f1e22"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1zm0 1h1v1h-1z",
    fill: "#1e1e1e"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v1h-1v-1zm-38 44h1v1h-1z",
    fill: "#454546"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M113 63h-1v-1h1zm-8 0v1h-1v-1z",
    fill: "#424242"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62h1v1h-1zm-33 47v1h-1v-1z",
    fill: "#2b2b2d"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1zm6-1v1h-1v-1z",
    fill: "#a9c0ba"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1zm4 0h1v1h-1z",
    fill: "#2c2c2c"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v2h-1z",
    fill: "#272727"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M98 64v-1h1v1zm-38 40h1v1h-1z",
    fill: "#292929"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64v-1h1v1zm16 1v-1h1v1z",
    fill: "#343537"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1zM20 93v-1h1v1z",
    fill: "#414141"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64v1h-1v-1zM41 96h-1v-1h1z",
    fill: "#3a393a"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65v-1h1v1zm-33 45v-1h1v1z",
    fill: "#3b3b3b"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1zm-3 7h1v1h-1z",
    fill: "#626262",
    fillOpacity: 0.051
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M114 67h-2v-1h2z",
    fill: "#555",
    fillOpacity: 0.059
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1zm3 4h1v1h-1z",
    fill: "#5b5253"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1zm5 4h1v1h-1z",
    fill: "#544b4c"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1zm1 3h-1v-1h1z",
    fill: "#484142"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1zm-11 3v1h-1v-1z",
    fill: "#514a4a"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1zm5-1v1h-1v-1z",
    fill: "#554e4e"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1zm3 3h-1v-1h1z",
    fill: "#564f50"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1zm-1 27h-1v-1h1z",
    fill: "#434144"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1zM34 89h1v1h-1z",
    fill: "#424042"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1zM23 91v1h-1v-1z",
    fill: "#3d3a3b"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1zm-3 0h1v1h-1z",
    fill: "#534d4f"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1zm11 24v-1h1v1z",
    fill: "#383333"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1zm33 24h1v1h-1z",
    fill: "#433b3c"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1zm13 28h-1v-1h1z",
    fill: "#2e2b2f"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70v1h-2v-1h1z",
    fill: "#343436"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1zm83 42h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M46 72h-1v-1h2v1z",
    fill: "#393437"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1zM17 90v-1h1v1z",
    fill: "#312e30"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1zm-1 4v-1h1v1z",
    fill: "#2a292a"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1zm24 6v-1h1v1z",
    fill: "#585858",
    fillOpacity: 0.102
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1zm2 1h1v1h-1z",
    fill: "#bcb1b9"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h2v1h-1z",
    fill: "#4b4343"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1zm32 25v1h-1v-1z",
    fill: "#3b3537"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1zm41 38h-1v-1h1z",
    fill: "#28282a"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1zm32 34v1h-1v-1z",
    fill: "#2b2a2e"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1zm21 22v1h-1v-1z",
    fill: "#3b3538"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1zM17 87v-1h1v1z",
    fill: "#322f30"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1zm16 31h1v1h-1z",
    fill: "#2a282c"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1zm17 26v-1h1v1z",
    fill: "#2a282a"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1zm17 4v1h-1v-1z",
    fill: "#232225"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1zm11 7v-1h1v1z",
    fill: "#27272b"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1zm17 10v1h-1v-1z",
    fill: "#2f3033"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1zm-8 24v-1h1v1z",
    fill: "#312d2e"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1zm19 26h1v1h-1z",
    fill: "#2c2a2c"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1zm12 5h1v1h-1z",
    fill: "#212124"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1zm5 3h-1v-1h1z",
    fill: "#1f1f20"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1zm11 35h1v1h-1z",
    fill: "#1c1c1e"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1zm35 16v1h-1v-1z",
    fill: "#28282c"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1zm44 21v1h-1v-1z",
    fill: "#beb4bd"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1zm-16 2h1v1h-1z",
    fill: "#bdb2bb"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1zm-39 7v1h-1v-1z",
    fill: "#2c2827"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1zM14 87h1v1h-1z",
    fill: "#2a2627"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1zm24 4h1v1h-1z",
    fill: "#252428"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1zm7 6v1h-1v-1z",
    fill: "#313135"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1zm-1 6v-1h1v1z",
    fill: "#3c312f"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1zm0 4h-1v-1h1z",
    fill: "#2e2723"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1zm-2 15h-1v-1h1z",
    fill: "#2c2623"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1zm10 1h-1v-1h1z",
    fill: "#201f23"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1zm4 1h1v1h-1z",
    fill: "#1d1d1f"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1zm24 23h1v1h-1z",
    fill: "#28282b"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1zm-2 9v-1h1v1z",
    fill: "#3a383b"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1zm54 23h1v1h-1z",
    fill: "#e2ddf0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1zm-1 8h-1v-1h1z",
    fill: "#3b312f"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1zm-2 10h-1v-1h1z",
    fill: "#27211f"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1zm8 27v1h-1v-1z",
    fill: "#1d1b1e"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1zm10 30v1h-1v-1z",
    fill: "#1f1e21"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1zm-5 10h-1v-1h1z",
    fill: "#3f3f41"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1zm65 20v1h-1v-1z",
    fill: "#dad5e9"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1zm-3 2v1h-1v-1z",
    fill: "#e3dbe8"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#443633"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1zm2-1h1v1h-1z",
    fill: "#1b1b1c"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1zm5 3v-1h1v1z",
    fill: "#1e1d21"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1zm2 2v-1h1v1z",
    fill: "#242328"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1zm3 1v1h-1v-1z",
    fill: "#242327"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1zm2 31v-1h1v1z",
    fill: "#363638"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1zM54 94h-1v-1h1z",
    fill: "#474549"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1zM49 93h-1v-1h1z",
    fill: "#4a4549"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78h1v1h-1zm6 31v-1h1v1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79h1v1h-1zm6 8v-1h1v1z",
    fill: "#373233"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1zm-2 8v1h-1v-1z",
    fill: "#453734"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1zm17 12h-1v-1h1z",
    fill: "#261f1c"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M92 79v1h-1v-1zm-4 7v-1h1v1z",
    fill: "#474245"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v-1h1v1zm20 14v-1h1v1z",
    fill: "#373133"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1zm6 3h-1v-1h1z",
    fill: "#e3d9e4"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h2v1h-1z",
    fill: "#dfdced"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v2h-1z",
    fill: "#29211f"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1zm3 1v1h-1v-1z",
    fill: "#181718"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1zm25 4v1h-1v-1z",
    fill: "#28272d"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1zm72 20h-1v-1h1z",
    fill: "#e1d7e4"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1zm0 4v1h-1v-1z",
    fill: "#372d2b"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1zm11 12h1v1h-1z",
    fill: "#251f1e"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1zm2 12h1v1h-1z",
    fill: "#231e1d"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1zm26 10v-1h1v1z",
    fill: "#27262c"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1zm6 28v-1h1v1z",
    fill: "#313033"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1zM51 95h1v1h-1z",
    fill: "#454044"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M96 82h-1v-1h1zm-68 6h1v1h-1z",
    fill: "#454144"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1zm-3 3v1h-1v-1z",
    fill: "#423e43"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M97 81h1v1h-1zM52 99v1h-1v-1z",
    fill: "#434041"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82v-1h1v1zm-6 5v-1h1v1z",
    fill: "#4a4548"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83h-1v-1h1zm5 7h-1v-1h1z",
    fill: "#2a2625"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82h1v1h-1zm6 4h-1v-1h1z",
    fill: "#302c2d"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1zm-1 4h1v1h-1z",
    fill: "#4c3d38"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-2h1v1z",
    fill: "#483a37"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1zm-2 6h-1v-1h1z",
    fill: "#3d3331"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1zm-1 5v-1h1v1z",
    fill: "#362d2a"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1zm-11 20v1h-1v-1z",
    fill: "#2c2b2e"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1zm-8 19h-1v-1h1z",
    fill: "#2f2e31"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-1zm12 10v-1h1v1z",
    fill: "#413f45"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83h-1v-1h1zm-20 17v1h-1v-1z",
    fill: "#3a383a"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h1v1h-1zm-10 25v-1h1v1z",
    fill: "#3b3a3c"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82h1v1h-1zm-18 24h-1v-1h1z",
    fill: "#3c3a3f"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h1v1h-1zm0 9v-1h1v1z",
    fill: "#3a393e"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84v-1h1v1zm-2 1h1v1H7z",
    fill: "#252122"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M11 84v-1h1v1zm3 3v1h-1v-1z",
    fill: "#282425"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M13 83v1h-1v-1zm18 11v1h-1v-1z",
    fill: "#2a2728"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h2v1h-2z",
    fill: "#312c2d"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83v1h-1v-1zm9 3h1v1h-1z",
    fill: "#5c5355"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M43 85v-2h1v2z",
    fill: "#3c3230"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1zm-2 4v-1h1v1z",
    fill: "#392f2d"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1zm-20 9h-1v-1h1z",
    fill: "#241e1c"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M90 83v1h-2v-1h1z",
    fill: "#38373b"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M91 83h1v1h-1zm12 7h1v1h-1z",
    fill: "#424247"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83h1v1h-1zm-9 1v1h-1v-1z",
    fill: "#3e3c41"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83v1h-1v-1zm-5 21h-1v-1h1z",
    fill: "#2c2b31"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M15 84h1v1h-1zm1 2v1h-1v-1z",
    fill: "#2d292a"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M17 86h-1v-2h1v1z",
    fill: "#2f2c2d"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v2h-1v-2z",
    fill: "#4f403a"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1zm-1 4h-1v-1h1z",
    fill: "#342c29"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-2h1v1z",
    fill: "#2e2624"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-2h1z",
    fill: "#28221f"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1zm-9 12h-1v-1h1z",
    fill: "#26201e"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1zm7 21h1v1h-1z",
    fill: "#353339"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M89 84v1h-1v-1zm-12 20v-1h1v1z",
    fill: "#353338"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1zm-16 15v-1h1v1z",
    fill: "#39363b"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-1h1v1zm4 1h-1v-1h1z",
    fill: "#464449"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M98 84h1v2h-1v-1z",
    fill: "#3b3a3f"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85h-1v-1h1zm-19 19h-1v-1h1z",
    fill: "#343237"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M109 86h-1v-2h1v1z",
    fill: "#212227"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M111 85v-1h1v1zm-1 1h-1v-1h1z",
    fill: "#22252a"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v2h-1v-2z",
    fill: "#332b28"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85v1h-1v-1zm-21 5v-1h1v1z",
    fill: "#3f3e43"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M6 86h1v1H6zm21 7v1h-1v-1z",
    fill: "#201e1f"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86h1v1h-1zm39 15v1h-1v-1z",
    fill: "#2e2c2d"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87h-1v-1h1zm11 1v1h-1v-1z",
    fill: "#423c3e"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M29 87h-1v-1h1zm15 3h1v1h-1z",
    fill: "#4a4444"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1zm-30 3v1h-1v-1z",
    fill: "#241f1b"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1zm-9 11h1v1h-1z",
    fill: "#322d2f"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1zm-5 3v1h-1v-1z",
    fill: "#423d40"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-1h1zm4 0v1h-1v-1z",
    fill: "#403c40"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87h-1v-1h1zm1-1h1v1h-1z",
    fill: "#36353b"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M25 87h1v1h-1zm51 8h1v1h-1z",
    fill: "#413d3d"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88h-1v-1h1zm19 3v1h-1v-1z",
    fill: "#464141"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89h-1v-2h1v1z",
    fill: "#2b2422"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1zm-29 6v1h-1v-1z",
    fill: "#3f3d42"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1v1h-1zm5 2h-1v-1h1z",
    fill: "#7f7579"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87h1v1h-1zm-6 24v1h-1v-1z",
    fill: "#37363b"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87v1h-1v-1zm-21 19h1v1h-1z",
    fill: "#343338"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M102 87h1v1h-2v-1z",
    fill: "#343439"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M103 87h1v1h-1zm-5 19h-1v-1h1z",
    fill: "#2d2d32"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h1v1h-1zm-6 18h1v1h-1z",
    fill: "#292a2f"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M106 88v-1h1v1zm-9 26h-1v-1h1z",
    fill: "#232429"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88v1h-1v-1zm47 15h-1v-1h1z",
    fill: "#2f2d2e"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1zm22 6h1v1h-1z",
    fill: "#3e3a3a"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1zm-5 17v1h-1v-1z",
    fill: "#383538"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1zm-2 1v1h-1v-1z",
    fill: "#403f43"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h2v1h-1z",
    fill: "#a399a0"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88v1h-1v-1zm1 2v-1h1v1z",
    fill: "#36353a"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89h-1v-1h1zm-6 15h1v1h-1z",
    fill: "#2d2c32"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89v1h-1v-1zm3 2h-1v-1h1z",
    fill: "#030303"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M21 89v1h-1v-1zm54 4v-1h1v1z",
    fill: "#3a3537"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90v-1h1v1zm21 5v-1h1v1z",
    fill: "#413c3d"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M88 89h1v1h-1zm13 6v-1h1v1z",
    fill: "#b4aeb6"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M105 90h-1v-1h1zm-3 12v1h-1v-1z",
    fill: "#302f35"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91v-1h1v1zm45 13h1v1h-1z",
    fill: "#111010"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M18 90v1h-1v-1zm29 10h-1v-1h1z",
    fill: "#211f20"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M18 91v-1h1v1zm20 6h-1v-1h1z",
    fill: "#2e2b2c"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1zm33 11h-1v-1h1z",
    fill: "#383536"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91v-1h1v1zm17 7h1v1h-1z",
    fill: "#3c393a"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M30 90v1h-1v-1zm23 9h-1v-1h1z",
    fill: "#433e3f"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1zm1 6v-1h1v1z",
    fill: "#403a3d"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1zm17 4v1h-1v-1z",
    fill: "#3c393c"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1zm8 4v-1h1v1z",
    fill: "#433f43"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M43 92v-1h2v1h-1z",
    fill: "#3e3b3c"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M48 92h-2v-1h2z",
    fill: "#4e4a4a"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1zm12 11v1h-1v-1z",
    fill: "#3f3a3d"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1zm26 8h1v1h-1z",
    fill: "#131213"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1zm-7 4h-1v-1h1z",
    fill: "#484347"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1zm-5 5h-1v-1h1z",
    fill: "#262120"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h1v1h-1zm2 3h1v1h-1z",
    fill: "#d6d3e5"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1zm5 5h1v1h-1z",
    fill: "#d8d2e2"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93v1h-1v-1zm53 15v-1h1v1z",
    fill: "#545454"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1zm4 1h1v1h-1z",
    fill: "#464244"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1zm3 1v1h-1v-1z",
    fill: "#413c40"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1zm-8 3v-1h1v1z",
    fill: "#444042"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M94 94h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#d7d3e4"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1zm22 6h1v1h-1z",
    fill: "#141314"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1zm31 1v-1h1v1z",
    fill: "#474446"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1zm6 0h1v1h-1z",
    fill: "#433f42"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#423e42"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1zm-5 3h1v1h-1z",
    fill: "#3e3c3d"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1zm14-1v1h-1v-1z",
    fill: "#2d2928"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1zm18 6v-1h1v1z",
    fill: "#1b191a"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1zm37 10v-1h1v1z",
    fill: "#3b353a"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1zm-23 1h1v1h-1z",
    fill: "#3b3839"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96h1v1h-1zm55 21h-1v-1h1z",
    fill: "#c3c3c3"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1zm60 19v1h-1v-1z",
    fill: "#f2f4f3"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1zm4 2v1h-1v-1z",
    fill: "#ebecec"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1zm5 3v-1h1v1z",
    fill: "#161616"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1zm44 9h1v1h-1z",
    fill: "#3a3739"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1zm18 2h-1v-1h1z",
    fill: "#3b383b"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1zm21 10h-1v-1h1z",
    fill: "#302f33"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1zm7 1h-1v-1h1z",
    fill: "#332f32"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96v2h-1v-2z",
    fill: "#3b373b"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1zm9 4h-1v-1h1z",
    fill: "#dcdde5"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M11 98h-1v-1h1zm2 1v-1h1v1z",
    fill: "#040404"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v1h-1v-1zm68 24h1v1h-1z",
    fill: "#a6a6a6"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1zm51 19h1v1h-1z",
    fill: "#f2f3f3"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1zm23 7v1h-1v-1z",
    fill: "#747474"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-2v-1h1z",
    fill: "#3e3c3e"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1zm8 4h1v1h-1z",
    fill: "#353335"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1zm22 7v-1h1v1z",
    fill: "#312e31"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1zm4 6h1v1h-1z",
    fill: "#3a383d"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M104 99v-1h1v1zm-35 0v1h-1v-1z",
    fill: "#29272a"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99v1h-1v-1zm61 12h1v1h-1z",
    fill: "#d6d6d6"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1zm7 0v-1h1v1z",
    fill: "#3c3a3b"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1zm3 3h1v1h-1z",
    fill: "#363335"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v2h-1v-1z",
    fill: "#2b292c"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99v1h-1v-1zm-6 10h1v1h-1z",
    fill: "#636571"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1zm15 12h-1v-1h1z",
    fill: "#d2d2d2"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1zm25 3h-1v-1h1z",
    fill: "#302d30"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1zm19 6v-1h1v1z",
    fill: "#2f2e32"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M106 101h-1v-1h1zm-4 5h1v1h-1z",
    fill: "#696d7f"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M20 102h-1v-1h1zm67 22v-1h1v1z",
    fillOpacity: 0.208
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1zm-3 1h1v1h-1z",
    fill: "#312e33"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1zm46 9h-1v-1h1z",
    fill: "#f4f4f4"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1zm21 5h1v1h-1z",
    fill: "#2f2d31"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1zm4 1h-1v-1h1z",
    fill: "#363437"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1zm-1 3h-1v-1h1z",
    fill: "#333136"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103h-2v-1h2z",
    fill: "#e7dce7"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1zm7 1v-1h1v1z",
    fill: "#2f2d32"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M104 104v-1h1v1zm-3 10h-1v-1h1z",
    fill: "#666d80"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1zm6 2h1v1h-1z",
    fill: "#212021"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1zm33 9h-1v-1h1z",
    fill: "#2d2c2e"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1zm26 4v1h-1v-1z",
    fill: "#2d2b30"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v1h-1zm-1 1h1v1h-1z",
    fill: "#323133"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v1h-1v-1zm9 3h-1v-1h1z",
    fill: "#303035"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M104 106h-1v-1h1zm-5 12h-1v-1h1z",
    fill: "#656c7f"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1zm34 11v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.671
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1zm36 11h1v1h-1z",
    fill: "#757575"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1zm-17 1v1h-1v-1z",
    fill: "#f3f3f4"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1zm1 8h1v1h-1z",
    fill: "#868686"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1zm8 2h-1v-1h1z",
    fill: "#111012"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1zm6 0h1v1h-1z",
    fill: "#343437"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108v-1h1v1zm0 2h-1v-1h1z",
    fill: "#666c80"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1zm17 1h1v1h-1z",
    fill: "#2b2a2d"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108h1v1h-1zm-1 3v-1h1v1z",
    fill: "#505255"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1zm37 13v-1h1v1z",
    fill: "#dcdcdc"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1zm4 10v-1h1v1z",
    fill: "#e5e5e5"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1zm-3 7h1v1h-1z",
    fill: "#7b7b7b"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1zm2 1h1v1h-1z",
    fill: "#f1f1f2"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1zm3 0v1h-1v-1z",
    fill: "#3a383c"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M91 113v1h-2v-1h1z",
    fill: "#050506"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v1h-1v-1zm-2 6v-1h1v1z",
    fill: "#000003"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3h-1V2h1z",
    fill: "#5af",
    fillOpacity: 0.012
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M25 2v1h-1V2z",
    fill: "#c5c5dc",
    fillOpacity: 0.086
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3V2h1v1z",
    fill: "#c6c0af",
    fillOpacity: 0.176
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2h1v1h-1z",
    fill: "#c3c39b",
    fillOpacity: 0.271
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3V2h1v1z",
    fill: "#ccc690",
    fillOpacity: 0.353
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h1v1h-1z",
    fill: "#cabf80",
    fillOpacity: 0.38
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2v1h-1V2z",
    fill: "#d2bd7b",
    fillOpacity: 0.38
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M31 3h-1V2h1z",
    fill: "#cfbd76",
    fillOpacity: 0.38
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2v1h-1V2z",
    fill: "#cbb976",
    fillOpacity: 0.388
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M32 3V2h1v1z",
    fill: "#ccbe7e",
    fillOpacity: 0.373
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M34 2v1h-1V2z",
    fill: "#c9c58c",
    fillOpacity: 0.298
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2v1h-1V2z",
    fill: "#cccca3",
    fillOpacity: 0.196
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2h1v1h-1z",
    fill: "#bfc8bf",
    fillOpacity: 0.11
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h-1V2h1z",
    fill: "#91daff",
    fillOpacity: 0.027
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4V3h1v1z",
    fill: "#00f",
    fillOpacity: 0.008
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4h-1V3h1z",
    fill: "#c2c2ae",
    fillOpacity: 0.149
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3h1v1h-1z",
    fill: "#d5d0a7",
    fillOpacity: 0.388
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3h1v1h-1z",
    fill: "#dfd79b",
    fillOpacity: 0.612
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3v1h-1V3z",
    fill: "#e5d986",
    fillOpacity: 0.78
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4V3h1v1z",
    fill: "#e7d97e",
    fillOpacity: 0.902
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M26 3v1h-1V3z",
    fill: "#e9d673",
    fillOpacity: 0.973
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M27 4h-1V3h1z",
    fill: "#ead156"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4h-1V3h1z",
    fill: "#f1d13c"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4V3h1v1z",
    fill: "#f3cd28"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4h-1V3h1z",
    fill: "#f3ca1f"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V3h1v1z",
    fill: "#f2c91b"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M34 3v1h-1V3z",
    fill: "#ecc420"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M35 4h-1V3h1z",
    fill: "#e5c22c",
    fillOpacity: 0.984
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3v1h-1V3z",
    fill: "#e0c33c",
    fillOpacity: 0.925
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M36 4V3h1v1z",
    fill: "#dfc34c",
    fillOpacity: 0.82
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h1v1h-1z",
    fill: "#e0c662",
    fillOpacity: 0.651
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4V3h1v1z",
    fill: "#dac77f",
    fillOpacity: 0.416
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3v1h-1V3z",
    fill: "#c6c09e",
    fillOpacity: 0.176
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3v1h-1V3z",
    fill: "#bfffff",
    fillOpacity: 0.016
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-1V4h1z",
    fill: "#ddd",
    fillOpacity: 0.118
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5V4h1v1z",
    fill: "#dfdbaa",
    fillOpacity: 0.447
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4h1v1h-1z",
    fill: "#e1da93",
    fillOpacity: 0.769
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5V4h1v1z",
    fill: "#e7de7d",
    fillOpacity: 0.953
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5h-1V4h1z",
    fill: "#f6ea7b"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4v1h-1V4z",
    fill: "#f6ea73"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5h-1V4h1z",
    fill: "#f7e769"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5h-1V4h1z",
    fill: "#f4e15f"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4v1h-1V4z",
    fill: "#f2db53"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5h-1V4h1z",
    fill: "#eecf26"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5V4h1v1z",
    fill: "#f0c814"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4h1v1h-1z",
    fill: "#f0c505"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M31 4h1v1h-1z",
    fill: "#efc100"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M36 5h-1V4h1z",
    fill: "#f2c000"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4v1h-1V4z",
    fill: "#f4c509"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5V4h1v1z",
    fill: "#f2c51b"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h-1V4h1z",
    fill: "#e2c12f",
    fillOpacity: 0.973
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5h-1V4h1z",
    fill: "#dec552",
    fillOpacity: 0.788
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4h1v1h-1z",
    fill: "#d9c774",
    fillOpacity: 0.482
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5h-1V4h1z",
    fill: "#c9c9bb",
    fillOpacity: 0.149
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5h1v1h-1z",
    fill: "#fafaf5",
    fillOpacity: 0.208
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6h-1V5h1z",
    fill: "#f5e9c3",
    fillOpacity: 0.608
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v1h-1V5z",
    fill: "#f5e9a4",
    fillOpacity: 0.91
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h1v1h-1z",
    fill: "#fcef90"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6V5h1v1z",
    fill: "#fbea68"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-1V5h1z",
    fill: "#f4e867"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5v1h-1V5z",
    fill: "#eeea70"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5h1v1h-1z",
    fill: "#eee977"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5h1v1h-1z",
    fill: "#f0e983"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5v1h-1V5z",
    fill: "#f0e57f"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M25 6V5h1v1z",
    fill: "#f1e06b"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5v1h-1V5z",
    fill: "#f0d448"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M28 5h1v1h-1z",
    fill: "#f0c516"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6h-1V5h1z",
    fill: "#eec30e"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5h1v1h-1z",
    fill: "#edc304"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M33 5v1h-1V5z",
    fill: "#edbf02"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5v1h-1V5z",
    fill: "#edc000"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5h1v1h-1z",
    fill: "#efbc04"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M39 5h1v1h-1z",
    fill: "#f1be00"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6V5h1v1z",
    fill: "#f3c616"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6V5h1v1z",
    fill: "#e5c436",
    fillOpacity: 0.941
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6V5h1v1z",
    fill: "#dac46b",
    fillOpacity: 0.651
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5v1h-1V5z",
    fill: "#cdc9b2",
    fillOpacity: 0.224
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6v1h-1V6z",
    fill: "#efe7cc",
    fillOpacity: 0.255
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h1v1h-1z",
    fill: "#eede84",
    fillOpacity: 0.678
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6v1h-1V6z",
    fill: "#f2d760",
    fillOpacity: 0.973
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7h-1V6h1z",
    fill: "#ffdf56"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6h1v1h-1z",
    fill: "#fddc50"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6h1v1h-1z",
    fill: "#f8dd4e"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6h1v1h-1z",
    fill: "#f4df4c"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-1V6h1z",
    fill: "#f0e04e"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7V6h1v1z",
    fill: "#f2e362"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6h1v1h-1z",
    fill: "#f1e463"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7V6h1v1z",
    fill: "#f0e367"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7V6h1v1z",
    fill: "#f2e269"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7h-1V6h1z",
    fill: "#f0dd5d"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7h-1V6h1z",
    fill: "#f0d456"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7h-1V6h1z",
    fill: "#efcc34"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7V6h1v1z",
    fill: "#efc81e"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6v1h-1V6z",
    fill: "#edc218"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6h1v1h-1z",
    fill: "#eec210"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7V6h1v1z",
    fill: "#edc001"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7h-1V6h1z",
    fill: "#ecbf01"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7h-1V6h1z",
    fill: "#edbf00"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6v1h-1V6z",
    fill: "#efbc01"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7h-1V6h1z",
    fill: "#f0c70e"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h-1V6h1z",
    fill: "#e6c23a",
    fillOpacity: 0.973
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M46 7h-1V6h1z",
    fill: "#dec474",
    fillOpacity: 0.612
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7h-1V6h1z",
    fill: "#b6c4c4",
    fillOpacity: 0.137
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8h-1V7h1z",
    fill: "#e4e4e9",
    fillOpacity: 0.227
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7v1h-1V7z",
    fill: "#e6d79e",
    fillOpacity: 0.702
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8V7h1v1z",
    fill: "#e6cc4b",
    fillOpacity: 0.988
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7v1h-1V7z",
    fill: "#facd1b"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V7h1v1z",
    fill: "#f7c60d"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7h1v1h-1z",
    fill: "#f7cd1e"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8V7h1v1z",
    fill: "#fad334"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-1V7h1z",
    fill: "#fcdb4b"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7v1h-1V7z",
    fill: "#f7e05a"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7h1v1h-1z",
    fill: "#f6e467"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7v1h-1V7z",
    fill: "#f5e56e"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8h-1V7h1z",
    fill: "#f1e66b"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7h1v1h-1z",
    fill: "#f2e772"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8h-1V7h1z",
    fill: "#f2e781"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8V7h1v1z",
    fill: "#f4e889"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7v1h-1V7z",
    fill: "#f4dc72"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7h1v1h-1z",
    fill: "#f2ce3b"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7h1v1h-1z",
    fill: "#efc714"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7v1h-1V7z",
    fill: "#f0c522"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8h-1V7h1z",
    fill: "#edc21a"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M32 7v1h-1V7z",
    fill: "#ecc104"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7v1h-1V7z",
    fill: "#eec009"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7h1v1h-1z",
    fill: "#ecbf05"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8h-1V7h1z",
    fill: "#eebb02"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7v1h-1V7z",
    fill: "#efbc00"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h1v1h-1z",
    fill: "#f3c512"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7v1h-1V7z",
    fill: "#dfc74d",
    fillOpacity: 0.902
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M48 7v1h-1V7z",
    fill: "#cec892",
    fillOpacity: 0.388
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H9V8h1z",
    fill: "#e5ffff",
    fillOpacity: 0.039
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9h-1V8h1z",
    fill: "#e2e2d4",
    fillOpacity: 0.522
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8h1v1h-1z",
    fill: "#e5d077",
    fillOpacity: 0.965
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V8h1v1z",
    fill: "#f1c81a"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8h1v1h-1z",
    fill: "#f3c406"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8v1h-1V8z",
    fill: "#f1c808"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8h1v1h-1z",
    fill: "#f4ce24"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8v1h-1V8z",
    fill: "#fcd94e"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9h-1V8h1z",
    fill: "#fadf5d"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8v1h-1V8z",
    fill: "#f7e161"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9h-1V8h1z",
    fill: "#f4e76c"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9h-1V8h1z",
    fill: "#f0eb78"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M23 8h1v1h-1z",
    fill: "#f3ed91"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8v1h-1V8z",
    fill: "#f2ee97"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8v1h-1V8z",
    fill: "#f4e790"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9h-1V8h1z",
    fill: "#f2df6f"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9h-1V8h1z",
    fill: "#f1d241"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8h1v1h-1z",
    fill: "#efc208"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8v1h-1V8z",
    fill: "#efc421"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9h-1V8h1z",
    fill: "#ecc315"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9h-1V8h1z",
    fill: "#ecbf02"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h1v1h-1z",
    fill: "#ebbd04"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8v1h-1V8z",
    fill: "#ecbc04"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8h1v1h-1z",
    fill: "#eebb01"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8h1v1h-1z",
    fill: "#f2bf01"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8v1h-1V8z",
    fill: "#e9c631"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8v1h-1V8z",
    fill: "#dbca84",
    fillOpacity: 0.596
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8v1h-1V8z",
    fill: "#d0d0ff",
    fillOpacity: 0.043
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10V9h1v1z",
    fill: "#d9ecf5",
    fillOpacity: 0.106
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9v1H9V9z",
    fill: "#e2d8bc",
    fillOpacity: 0.725
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9h1v1h-1z",
    fill: "#ecd158"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h-1V9h1z",
    fill: "#eebf04"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9h1v1h-1z",
    fill: "#f2c100"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10h-1V9h1z",
    fill: "#f2c402"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V9h1v1z",
    fill: "#f6d344"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9h1v1h-1z",
    fill: "#f8de64"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9v1h-1V9z",
    fill: "#f6e76b"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10V9h1v1z",
    fill: "#f3ed7f"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9v1h-1V9z",
    fill: "#f2ed85"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10V9h1v1z",
    fill: "#f5ec8d"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9h1v1h-1z",
    fill: "#f5ec91"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M26 10h-1V9h1z",
    fill: "#f5e98b"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9v1h-1V9z",
    fill: "#f4e280"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10V9h1v1z",
    fill: "#f3d45f"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10h-1V9h1z",
    fill: "#efc205"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9h1v1h-1z",
    fill: "#ecc118"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10V9h1v1z",
    fill: "#ecc00b"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9z",
    fill: "#ebbc06"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10h-1V9h1z",
    fill: "#edbc06"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h-1V9h1z",
    fill: "#edbb02"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10V9h1v1z",
    fill: "#edbb00"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#f2bc00"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#efc722"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#ddd079",
    fillOpacity: 0.706
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#bfd8f2",
    fillOpacity: 0.078
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11v-1h1v1z",
    fill: "#e4e4ff",
    fillOpacity: 0.114
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10v1H8v-1z",
    fill: "#ddd7ba",
    fillOpacity: 0.8
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10h1v1H9z",
    fill: "#eaca46"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10v1h-1v-1z",
    fill: "#ecbf04"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11h-1v-1h1z",
    fill: "#edc10a"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10v1h-1v-1z",
    fill: "#eec30b"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10v1h-1v-1z",
    fill: "#f0c20e"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10v1h-1v-1z",
    fill: "#f0c315"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h1v1h-1z",
    fill: "#f0c71d"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11v-1h1v1z",
    fill: "#f0cc1e"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10h1v1h-1z",
    fill: "#f3cf3a"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11v-1h1v1z",
    fill: "#f6d44b"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1v1h-1z",
    fill: "#f8db56"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10v1h-1v-1z",
    fill: "#f6e571"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10h1v1h-1z",
    fill: "#f2eb6e"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10h1v1h-1z",
    fill: "#f3ec86"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11v-1h1v1z",
    fill: "#f5ed98"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11v-1h1v1z",
    fill: "#f8ec9b"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11v-1h1v1z",
    fill: "#f5e68a"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10h1v1h-1z",
    fill: "#f1d85e"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10h1v1h-1z",
    fill: "#f2cc2b"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11v-1h1v1z",
    fill: "#f0c508"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10h1v1h-1z",
    fill: "#eabf07"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10v1h-1v-1z",
    fill: "#ebbe04"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11v-1h1v1z",
    fill: "#eebc08"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v-1h1v1z",
    fill: "#ecbc06"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v-1h1v1z",
    fill: "#ebbc0b"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#ebbc0a"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#ecbd0a"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#edbc04"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#f0bb03"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11v-1h1v1z",
    fill: "#f2ba00"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1z",
    fill: "#f4c61d"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#cdbb72",
    fillOpacity: 0.788
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#c8cae2",
    fillOpacity: 0.455
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#e5e0e8",
    fillOpacity: 0.357
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1z",
    fill: "#dfdbe3",
    fillOpacity: 0.255
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#dedede",
    fillOpacity: 0.122
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#d4d4ff",
    fillOpacity: 0.024
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v-1h1v1z",
    fill: "#ececff",
    fillOpacity: 0.055
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11h1v1H7z",
    fill: "#e3d7b7",
    fillOpacity: 0.757
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H8v-1h1z",
    fill: "#eccb51"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H9v-1h1z",
    fill: "#ecbd0f"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12h-1v-1h1z",
    fill: "#ecbf15"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11h1v1h-1z",
    fill: "#eebf14"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11h1v1h-1z",
    fill: "#f0c01b"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11h1v1h-1z",
    fill: "#f0c015"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11v1h-1v-1z",
    fill: "#f1c00d"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11h1v1h-1z",
    fill: "#efc20a"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11v1h-1v-1z",
    fill: "#f1c208"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12h-1v-1h1z",
    fill: "#f4c304"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h1v1h-1z",
    fill: "#f3c60c"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11v1h-1v-1z",
    fill: "#f7ce24"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v-1h1v1z",
    fill: "#f9db55"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11v1h-1v-1z",
    fill: "#f8e76a"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12v-1h1v1z",
    fill: "#f7eb80"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12v-1h1v1z",
    fill: "#f5ee90"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11h1v1h-1z",
    fill: "#f7ee9b"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11h1v1h-1z",
    fill: "#f7eaa1"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11v1h-1v-1z",
    fill: "#f7df77"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12v-1h1v1z",
    fill: "#f4cd2b"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h-1v-1h1z",
    fill: "#f3c605"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M31 11h1v1h-1z",
    fill: "#edc005"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12h-1v-1h1z",
    fill: "#eabd00"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-1v-1h1z",
    fill: "#eebe18"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#e9bc0a"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#ecbd16"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#eebc02"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#f0bb00"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1z",
    fill: "#f0c11f"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#d6cabe"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M52 12v-1h1v1z",
    fill: "#f6f5ff"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1z",
    fill: "#e9eaed"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12h-1v-1h1z",
    fill: "#d7dcd3",
    fillOpacity: 0.933
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1z",
    fill: "#d4dac9",
    fillOpacity: 0.816
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1z",
    fill: "#d3d8cc",
    fillOpacity: 0.62
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#d6d6d4",
    fillOpacity: 0.373
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#dbdbdb",
    fillOpacity: 0.141
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12h1v1H6z",
    fill: "#e0d7c6",
    fillOpacity: 0.584
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12h1v1H7z",
    fill: "#e8ca4b"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h1v1H8z",
    fill: "#eaba03"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13v-1h1v1z",
    fill: "#eebb04"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v1h-1v-1z",
    fill: "#f0be00"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13v-1h1v1z",
    fill: "#f0c100"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12v1h-1v-1z",
    fill: "#f0c201"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13v-1h1v1z",
    fill: "#f0c302"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v1h-1v-1z",
    fill: "#f1c507"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v1h-1v-1z",
    fill: "#f3c710"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12v1h-1v-1z",
    fill: "#f4d338"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12h1v1h-1z",
    fill: "#f7de5c"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13v-1h1v1z",
    fill: "#f9e878"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12v1h-1v-1z",
    fill: "#f7f28f"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13v-1h1v1z",
    fill: "#faf49b"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12v1h-1v-1z",
    fill: "#faee9b"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12h1v1h-1z",
    fill: "#eed56e"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12h1v1h-1z",
    fill: "#ddbb24"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v1h-1v-1z",
    fill: "#d7b20b"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h1v1h-1z",
    fill: "#dab70a"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13v-1h1v1z",
    fill: "#e5bd09"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#f3c001"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1z",
    fill: "#ecba02"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M38 13v-1h1v1z",
    fill: "#ebbb05"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#ecbb08"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#ebba06"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#eebb03"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#ecbe00"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#e7bd3e"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#d9d7df"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#ebf3f3"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#d4eccb"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#d4eace"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1z",
    fill: "#d8e6d4"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#d4e1cf"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#d1dacc",
    fillOpacity: 0.941
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#d8dfd4",
    fillOpacity: 0.722
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#daddda",
    fillOpacity: 0.412
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#e2d9e2",
    fillOpacity: 0.106
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13v1H5v-1z",
    fill: "#e6e2df",
    fillOpacity: 0.282
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14v-1h1v1z",
    fill: "#e0c869",
    fillOpacity: 0.988
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H7v-1h1z",
    fill: "#e8b803"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H8v-1h1z",
    fill: "#ebb902"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14h-1v-1h1z",
    fill: "#ecbb00"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13v1h-1v-1z",
    fill: "#f1c503"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14h-1v-1h1z",
    fill: "#f0ca1f"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M23 13v1h-1v-1z",
    fill: "#f4d443"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13v1h-1v-1z",
    fill: "#fde266"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13h1v1h-1z",
    fill: "#e8d764"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13v1h-1v-1z",
    fill: "#b9ab55"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14v-1h1v1z",
    fill: "#918a52"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13h1v1h-1z",
    fill: "#767451"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13v1h-1v-1z",
    fill: "#6b6b4d"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14h-1v-1h1z",
    fill: "#616344"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13h1v1h-1z",
    fill: "#58583b"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13h1v1h-1z",
    fill: "#5a5322"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h-1v-1h1z",
    fill: "#736812"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#b29211"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#e3ba07"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1z",
    fill: "#ebc000"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1z",
    fill: "#eaba05"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#ebba00"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#eaba00"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#efbd02"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1z",
    fill: "#ecbe03"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#edbc03"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#e1c57c"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h-1v-1h1z",
    fill: "#d6e1e3"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#daeaca"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#d6e9c7"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#d4eacc"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#d3e8cb"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1z",
    fill: "#d2e8cb"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#d6ebd2"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#d8e8d4"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#d6e2d5",
    fillOpacity: 0.91
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1z",
    fill: "#dae1da",
    fillOpacity: 0.608
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1z",
    fill: "#e4e4df",
    fillOpacity: 0.188
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15v-1h1v1z",
    fill: "#dccd92",
    fillOpacity: 0.804
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14v1H6v-1z",
    fill: "#e8bc14"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v1H7v-1z",
    fill: "#ebb700"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15v-1h1v1z",
    fill: "#e9b800"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14v1H9v-1z",
    fill: "#eab801"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14v1h-1v-1z",
    fill: "#ebb901"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15v-1h1v1z",
    fill: "#f0c102"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1v-1h1z",
    fill: "#efc305"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-1h1v1z",
    fill: "#f5c50e"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h-1v-1h1z",
    fill: "#f0c714"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v-1h1v1z",
    fill: "#b9a53a"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15v-1h1v1z",
    fill: "#908b69"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15v-1h1v1z",
    fill: "#a9a6aa"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h-1v-1h1z",
    fill: "#c5c3cf"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15v-1h1v1z",
    fill: "#d6d7db"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15v-1h1v1z",
    fill: "#dcdde7"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14h1v1h-1z",
    fill: "#dadbe2"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1z",
    fill: "#ced1d1"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14v1h-1v-1z",
    fill: "#b3b3b6"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v-1h1v1z",
    fill: "#707372"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h1v1h-1z",
    fill: "#3d4730"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15h-1v-1h1z",
    fill: "#716327"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#c9a311"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15h-1v-1h1z",
    fill: "#f1bd04"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#ecbd04"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#f1bd00"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1z",
    fill: "#ebbe1e"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#cad1b5"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1z",
    fill: "#d4e8d1"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#d4e5c0"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#d2e6cb"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#d5e5ca"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#d2e7c7"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#d1ebc7"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#d1eac9"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#d0e8ce"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1z",
    fill: "#d4ead6"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1z",
    fill: "#d8e5d8",
    fillOpacity: 0.953
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1z",
    fill: "#e1e9e1",
    fillOpacity: 0.604
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1z",
    fill: "#e1e7e1",
    fillOpacity: 0.169
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15v1H4v-1z",
    fill: "#e3dcca",
    fillOpacity: 0.4
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16v-1h1v1z",
    fill: "#e2c444"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15h1v1H6z",
    fill: "#e7b500"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15h1v1H8z",
    fill: "#e9b702"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15h1v1H9z",
    fill: "#e9b802"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15v1h-1v-1z",
    fill: "#e9b901"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16v-1h1v1z",
    fill: "#eaba02"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16h-1v-1h1z",
    fill: "#ebbb02"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15v1h-1v-1z",
    fill: "#ebbd00"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15v1h-1v-1z",
    fill: "#edbf01"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v1h-1v-1z",
    fill: "#f0c003"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16h-1v-1h1z",
    fill: "#ecc00c"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v-1h1v1z",
    fill: "#b79f46"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15h1v1h-1z",
    fill: "#a29f9a"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16v-1h1v1z",
    fill: "#dfe0e6"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#f9f9fb"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#fbfefb"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h1v1h-1z",
    fill: "#feffff"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15h1v1h-1z",
    fill: "#fefeff"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15v1h-1v-1z",
    fill: "#e8e7eb"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h1v1h-1z",
    fill: "#d5d4d5"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#c2cbca"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#879482"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15v1h-1v-1z",
    fill: "#565836"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h-1z",
    fill: "#ba9b11"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#eabb00"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#edbd03"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#dccb6b"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#cbe4cf"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#d2e8c7"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#d3e4cf"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#d4e4ca"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#d3e5c9"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#d1e6c5"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#d3e6c8"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#d2e7ca"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1z",
    fill: "#cfe8ca"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1z",
    fill: "#cfe8ce"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#d5ead7"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#d6e4d8",
    fillOpacity: 0.929
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#dae2de",
    fillOpacity: 0.498
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#d2c3d2",
    fillOpacity: 0.067
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17v-1h1v1z",
    fill: "#dccc8b",
    fillOpacity: 0.804
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16v1H5v-1z",
    fill: "#e5b90c"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16h1v1H7z",
    fill: "#e7b502"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17v-1h1v1z",
    fill: "#eab902"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17h-1v-1h1z",
    fill: "#e8bc00"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-1v-1h1z",
    fill: "#c5b13d"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16v1h-1v-1z",
    fill: "#b5b3b3"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17v-1h1v1z",
    fill: "#f1f4f9"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17h-1v-1h1z",
    fill: "#fffffe"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v-1h1v1z",
    fill: "#d4d6d1"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16h1v1h-1z",
    fill: "#c8cec7"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M31 16v1h-1v-1z",
    fill: "#ccd1c6"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h-1v-1h1z",
    fill: "#cedfd7"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h-1v-1h1z",
    fill: "#d0e1de"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#d2e7e8"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#bdded1"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1z",
    fill: "#819283"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h1v1h-1z",
    fill: "#515627"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16v1h-1v-1z",
    fill: "#d8b00c"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#eabb01"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#e9bd00"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#efbe01"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#ebbf01"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1z",
    fill: "#e9c127"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#ccdcb9"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#d2e9d2"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#d0e7cc"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#d0e7ca"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#d0e6ca"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#d1e4c8"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#d1e3c7"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#d0e3c7"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#cfe5c7"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#d1e7cb"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#d1e5d0"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#d6e5d9"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#d8e1dc",
    fillOpacity: 0.8
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#e4e4e4",
    fillOpacity: 0.227
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17h1v1H3z",
    fill: "#e3e3df",
    fillOpacity: 0.22
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-1h1v1z",
    fill: "#dabf4f",
    fillOpacity: 0.988
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18h-1v-1h1z",
    fill: "#e8b700"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17v1h-1v-1z",
    fill: "#e7ba00"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18h-1v-1h1z",
    fill: "#e7bb00"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v1h-1v-1z",
    fill: "#deb714"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17v1h-1v-1z",
    fill: "#c0b89a"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h1v1h-1z",
    fill: "#ebeef2"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18h-1v-1h1z",
    fill: "#fffffd"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-1h1v1z",
    fill: "#fefdfe"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v-1h1v1z",
    fill: "#d2d6d5"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17v1h-1v-1z",
    fill: "#dde0dd"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h1v1h-1z",
    fill: "#efefee"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18v-1h1v1z",
    fill: "#cccecf"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18v-1h1v1z",
    fill: "#94b39e"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17v1h-1v-1z",
    fill: "#9cc0a0"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17h1v1h-1z",
    fill: "#c9e2d7"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#c8e5d8"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18v-1h1v1z",
    fill: "#bde9d9"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#aad5b9"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1z",
    fill: "#466849"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18h-1v-1h1z",
    fill: "#9d8714"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#f0c203"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1z",
    fill: "#edbe0f"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1z",
    fill: "#d4dba0"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#d1ead4"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#cde8d0"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#cfe9cc"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#cfe6cb"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#d2e6ca"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#cee2c8"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#cee2c6"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#d1e4cc"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#d3e7d3"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#d2e5d8"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#d2e0d7",
    fillOpacity: 0.945
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#dee8e1",
    fillOpacity: 0.4
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H3v-1h1z",
    fill: "#dcd2ab",
    fillOpacity: 0.49
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18h1v1H4z",
    fill: "#e5bb22"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18v1H5v-1z",
    fill: "#e5b101"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19v-1h1v1z",
    fill: "#e5b901"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19v-1h1v1z",
    fill: "#d5b841"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M21 18h1v1h-1z",
    fill: "#d4d4d5"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19v-1h1v1z",
    fill: "#fefdfa"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1z",
    fill: "#fdfefe"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18v1h-1v-1z",
    fill: "#f3f6f6"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h1v1h-1z",
    fill: "#eff2f4"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19h-1v-1h1z",
    fill: "#e0e4ea"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18h1v1h-1z",
    fill: "#c9d5d3"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19h-1v-1h1z",
    fill: "#bfe2ce"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M31 18h1v1h-1z",
    fill: "#94c4ad"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M33 18v1h-1v-1z",
    fill: "#b7ddcb"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#c7e3d3"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1z",
    fill: "#cae6d9"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#c0e5d3"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1z",
    fill: "#789d76"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1z",
    fill: "#7c7a18"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v1h-1z",
    fill: "#dad682"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#cce9d1"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#cbe9d5"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#cee9d0"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#cee7cd"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#cee6cc"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#cbe4c8"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#cde3ca"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#cee2cb"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#cee1cb"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#cde0cb"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#cee2cd"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#cee4cf"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#c6e4d1"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#cde3d5"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#dde7e2",
    fillOpacity: 0.565
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20v-1h1v1z",
    fill: "#deca83",
    fillOpacity: 0.702
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-1h1v1z",
    fill: "#e5b70d"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h1v1H5z",
    fill: "#e2b303"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19v1H7v-1z",
    fill: "#e1b601"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-1h1v1z",
    fill: "#e8b702"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20v-1h1v1z",
    fill: "#e7b702"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19h1v1h-1z",
    fill: "#e4b800"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-1v-1h1z",
    fill: "#d7bc54"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19v1h-1v-1z",
    fill: "#e5e6e6"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20h-1v-1h1z",
    fill: "#f7fcfc"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v-1h1v1z",
    fill: "#f5f9fa"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20v-1h1v1z",
    fill: "#f3f8fa"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19h1v1h-1z",
    fill: "#f8fbfe"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19h1v1h-1z",
    fill: "#ebeef8"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M29 19v1h-1v-1z",
    fill: "#ccd6e2"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v1h-1v-1z",
    fill: "#d0ebda"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20v-1h1v1z",
    fill: "#cfebd8"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-1z",
    fill: "#b6dcd2"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20h-1v-1h1z",
    fill: "#bbdcce"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20v-1h1v1z",
    fill: "#c9e7d7"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#cee3d8"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#d2e6de"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1z",
    fill: "#8eb486"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1z",
    fill: "#8a8a17"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M39 19v1h-1v-1z",
    fill: "#f0c105"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#edbe03"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#e1d171"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#cae8d1"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#cce7d1"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#cce6cf"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#cce5ce"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#c9e5cc"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#c9e3ca"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#cae1cc"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#c9e0ce"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#c9dfce"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#c8dfcc"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#c6e0cd"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#c7e2d0"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#c9e7d1"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#c9e7d0"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#d4e9da"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#e9efea",
    fillOpacity: 0.647
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#e5e5e5",
    fillOpacity: 0.039
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M3 20h1v1H3z",
    fill: "#d8c169",
    fillOpacity: 0.835
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20v1H4v-1z",
    fill: "#e3b603"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H5v-1h1z",
    fill: "#e1b500"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20h1v1h-1z",
    fill: "#ddc04b"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h1v1h-1z",
    fill: "#e7e8eb"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20v1h-1v-1z",
    fill: "#e8f7f6"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20h1v1h-1z",
    fill: "#edfafc"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v-1h1v1z",
    fill: "#f7fcfd"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20v1h-1v-1z",
    fill: "#f7f7fb"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21h-1v-1h1z",
    fill: "#eaeef8"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M27 20h1v1h-1z",
    fill: "#ced8e9"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M28 20h1v1h-1z",
    fill: "#d3e5e1"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h-1v-1h1z",
    fill: "#d3e8da"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20v1h-1v-1z",
    fill: "#d5ece1"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21v-1h1v1z",
    fill: "#d0e8d4"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20h1v1h-1z",
    fill: "#cfe6d1"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1z",
    fill: "#cee9d8"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20h1v1h-1z",
    fill: "#cee8d7"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#8faf79"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21h-1v-1h1z",
    fill: "#b2a511"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v1h-1v-1z",
    fill: "#ecc102"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#ecc101"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#efc101"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#e4d068"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#c6e7d9"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#c5e8ce"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#c9e5d1"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#c8e4ce"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#c9e2cc"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#c7e1cb"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#c6e3cc"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#c4e0ca"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#c7dfcc"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#c3dfcd"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#c0e0ce"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#c6e3ce"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#c7e4cd"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#cbe9ce"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#cbe8ce"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#deeede"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#f0f3ee",
    fillOpacity: 0.608
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21h1v1H2z",
    fill: "#f2ffff",
    fillOpacity: 0.078
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21v1H3v-1z",
    fill: "#d4bd5b",
    fillOpacity: 0.894
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H7v-1h1z",
    fill: "#e6b302"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22h-1v-1h1z",
    fill: "#dcb914"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22v-1h1v1z",
    fill: "#d8d8a9"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21h1v1h-1z",
    fill: "#daf1ef"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v1h-1v-1z",
    fill: "#f0fbfd"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21h1v1h-1z",
    fill: "#f7fdff"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21h1v1h-1z",
    fill: "#fafafe"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21h1v1h-1z",
    fill: "#dde8f0"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1z",
    fill: "#c0d8d6"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22h-1v-1h1z",
    fill: "#c8e3cf"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M30 22h-1v-1h1z",
    fill: "#cfe8db"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21h1v1h-1z",
    fill: "#dbeee0"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-1z",
    fill: "#d7ebd6"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M33 21v1h-1v-1z",
    fill: "#d0e8d7"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#d1e7d2"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#b9d8be"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#a1a745"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1z",
    fill: "#e3bf06"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22v-1h1v1z",
    fill: "#f4c202"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22v-1h1v1z",
    fill: "#edc504"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#ecc304"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#efc202"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#eec000"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#e3d26f"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#c1e4d8"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#c4e4d2"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#c7e4d4"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#c5e2cd"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#c6e1cb"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#c8e0cc"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#c6e0ce"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#c3decc"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#c3ddca"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#bfe0cd"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#c1e0cb"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#c3e2ca"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#c8e3ca"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#cbe7cf"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#cce5cf"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#dfecdf"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#f2f4f2",
    fillOpacity: 0.478
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22h1v1H2z",
    fill: "#ebffff",
    fillOpacity: 0.102
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v1H3v-1z",
    fill: "#d3bb57",
    fillOpacity: 0.922
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22v1H6v-1z",
    fill: "#e4b201"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23v-1h1v1z",
    fill: "#e5b201"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23h-1v-1h1z",
    fill: "#d4bc40"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23v-1h1v1z",
    fill: "#e1e6d0"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h-1v-1h1z",
    fill: "#e5f4f6"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23h-1v-1h1z",
    fill: "#f1fdfc"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1z",
    fill: "#f2fbfe"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v1h-1v-1z",
    fill: "#c9dedd"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22h1v1h-1z",
    fill: "#c9e6ce"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22v1h-1v-1z",
    fill: "#c9e6d0"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23v-1h1v1z",
    fill: "#cde7d4"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v-1h1v1z",
    fill: "#d4e7d9"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v1h-1v-1z",
    fill: "#d3e8d7"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#b9d9bc"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#aeb55e"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#debe14"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1z",
    fill: "#f5c907"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22h1v1h-1z",
    fill: "#f3c604"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M39 22h1v1h-1z",
    fill: "#f0c607"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#f2c404"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#f2c202"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#f0c301"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#f2c101"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#f3c202"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#f1c100"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#e3d882"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#c3e7db"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#c2e1d2"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#c0e3cc"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#c0ddca"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#c3ddcb"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#c2ddcd"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#bddecc"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#badfc9"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#bedfca"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#bfdeca"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#c1e0ca"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#c3e1cb"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#c7e1ca"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#c7e2cc"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#cce5cc"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#cde3c8"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#deecdd",
    fillOpacity: 0.969
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.259
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24v-1h1v1z",
    fill: "#eaffff",
    fillOpacity: 0.098
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23h1v1H3z",
    fill: "#d1b95f",
    fillOpacity: 0.918
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23h1v1H7z",
    fill: "#e4b402"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23v1h-1v-1z",
    fill: "#e5b600"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23v1h-1v-1z",
    fill: "#d5bd35"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M23 24v-1h1v1z",
    fill: "#e2e0b8"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23h1v1h-1z",
    fill: "#ebf1f3"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v1h-1v-1z",
    fill: "#cbe0e1"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23v1h-1v-1z",
    fill: "#cfe6cf"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23h1v1h-1z",
    fill: "#cfe4d0"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M29 23h1v1h-1z",
    fill: "#d1e5d2"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1z",
    fill: "#d3e7d6"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h1v1z",
    fill: "#d7eadd"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#bdceaa"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#bab956"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#e7c737"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#f7d017"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#f3c911"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#f2c809"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24h-1v-1h1z",
    fill: "#f5c70a"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#f4c70a"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#f3c502"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#f2c301"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#f2c409"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#bec178"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#9ebea4"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#bfdfcb"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#c0e1d0"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#bdddcb"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#bddbcc"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#bfdaca"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#bbdbc8"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#b4d9c2"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#b7ddc3"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#baddc6"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#bcddc7"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#bfdec7"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#c1dfc9"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#c1e0c9"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#c4dec6"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#c7e0c6"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#c8e1c6"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#cbe2c4"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#d4e7d3"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#e8f0ed",
    fillOpacity: 0.812
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24v1H2v-1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25v-1h1v1z",
    fill: "#d1bc71",
    fillOpacity: 0.843
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25v-1h1v1z",
    fill: "#e0b405"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24h1v1H6z",
    fill: "#e1b300"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25v-1h1v1z",
    fill: "#e1b401"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25v-1h1v1z",
    fill: "#e2b200"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24v1h-1v-1z",
    fill: "#e4b401"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24v1h-1v-1z",
    fill: "#e6b705"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25v-1h1v1z",
    fill: "#dcba17"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25h-1v-1h1z",
    fill: "#d8c960"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24h1v1h-1z",
    fill: "#bec486"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25v-1h1v1z",
    fill: "#bbcb98"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24h1v1h-1z",
    fill: "#c3d1ae"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24h1v1h-1z",
    fill: "#c4d3b7"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25h-1v-1h1z",
    fill: "#c6d6b7"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1z",
    fill: "#cbd9b8"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24h1v1h-1z",
    fill: "#c8cfa2"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1z",
    fill: "#c4c582"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25h-1v-1h1z",
    fill: "#d9ce74"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#f8df7b"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#feda6e"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#f8d644"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#f5cc1d"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#f3cb10"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#f6cb15"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#f3cb19"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#f3c806"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#f4c708"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#f4c505"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#f2c601"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#f2c502"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#f4c501"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#f5c501"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#f4c303"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#f4c301"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#f6c200"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#efc822"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#b5cfad"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#85a58d"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#7d9a70"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#a4c5a8"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#bfdccd"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#b9d6c7"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#b9d8c3"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#bad8c1"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#bdd9c3"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#bbdbc5"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#bedcc5"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#bfdbc6"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#c2dbc6"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#c4dcc7"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#c4ddca"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#c9dfcb"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#d0e2d5"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#d9e8e3"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#ecf8f5",
    fillOpacity: 0.431
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H3v-1h1z",
    fill: "#cfc28b",
    fillOpacity: 0.694
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25h1v1H4z",
    fill: "#dcb411"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26H5v-1h1z",
    fill: "#e4b200"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26H6v-1h1z",
    fill: "#e0b403"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26v-1h1v1z",
    fill: "#e4b305"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25v1H9v-1z",
    fill: "#e5b302"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26v-1h1v1z",
    fill: "#e7bb02"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M25 26v-1h1v1z",
    fill: "#e4ba0e"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25h1v1h-1z",
    fill: "#dabd16"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25v1h-1v-1z",
    fill: "#d7bf28"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25v1h-1v-1z",
    fill: "#dac033"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25h1v1h-1z",
    fill: "#dcc647"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25v1h-1v-1z",
    fill: "#e3d481"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#f0e3a7"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25h1v1h-1z",
    fill: "#fdeeb4"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#fdeeac"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#fce48c"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#f8e186"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#fae7a4"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#f4da5e"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#f7cc1e"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#f5cf1f"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#f3cb0d"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#f4ca0d"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#f4c809"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#f2c703"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#f4c603"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#f5c300"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#decf55"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#b4decd"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#add0c6"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#8fb9a4"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#789666"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#99b594"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#b3d8c7"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#afd3c0"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#b5d4c3"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#b7d5c2"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#b6d5c2"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#b9d7c4"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#b6d6c1"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#b8d8c2"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#bad6c4"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#bbd8c7"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#bdd9cb"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#c0dbd1"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#c0ded3"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#c5e1d7"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#cde1db"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#d5e3e2",
    fillOpacity: 0.843
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27v-1h1v1z",
    fill: "#ceccb6",
    fillOpacity: 0.494
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27H4v-1h1z",
    fill: "#d1b22a"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26h1v1H6z",
    fill: "#dfb304"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26h1v1H7z",
    fill: "#e4b104"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27v-1h1v1z",
    fill: "#e8bc01"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#ebbf00"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26h1v1h-1z",
    fill: "#edc100"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v-1h1v1z",
    fill: "#f2c30a"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27h-1v-1h1z",
    fill: "#f5c812"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M30 27h-1v-1h1z",
    fill: "#f8d541"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v1h-1v-1z",
    fill: "#ffe793"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M32 27h-1v-1h1z",
    fill: "#fff0c4"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h-1v-1h1z",
    fill: "#fef2cd"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#fef3d1"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#fcf0b1"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#f8eaaa"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#f9f2d2"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#f6ecb1"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M39 27v-1h1v1z",
    fill: "#f9d33f"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#f8d020"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#f7cf1f"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#f6cd15"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#f7ca0e"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#f6c80b"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#f6c704"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#f4c802"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#f3c702"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#f4c701"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#f1c701"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#f7c501"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#f2c70c"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#c5d996"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#c2e2d1"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#bcddd8"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#b9dacf"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#a5c1ab"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#759d60"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#94bf9c"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#afd3ca"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#acd2c2"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#aad0c3"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#a9cfc2"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#abcfc3"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#afd4c6"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#b0d6c9"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#b4d8ce"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#b9ddd6"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#b9dfd8"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#b8dfd7"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#b9e0d8"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#bee2db"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#c2e1db"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#c9e3e1"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#cee2e2"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#e3f1ed",
    fillOpacity: 0.286
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M3 27h1v1H3z",
    fill: "#e6e6fa",
    fillOpacity: 0.208
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28H4v-1h1z",
    fill: "#beac5a",
    fillOpacity: 0.98
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28v-1h1v1z",
    fill: "#dfb102"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28v-1h1v1z",
    fill: "#e3b202"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28v-1h1v1z",
    fill: "#eabd03"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27v1h-1v-1z",
    fill: "#efc00d"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1v1h-1z",
    fill: "#edc414"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27h1v1h-1z",
    fill: "#f0cb2a"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M29 28v-1h1v1z",
    fill: "#f6d34e"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h-1v-1h1z",
    fill: "#fde38d"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27h1v1h-1z",
    fill: "#feedc2"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v1h-1v-1z",
    fill: "#fef5e2"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#fef7d7"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#fef5db"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#fef5dc"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#fdedaa"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#fbecb2"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#f9f2d4"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#f7e8a2"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#f8d441"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#f7d024"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#f7cf1d"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#f7cc0e"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#f7cb04"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#f6cb06"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#f4c905"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#f4c902"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#f5c901"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#f4c901"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#f4c705"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#f5c600"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#d4d252"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#53d2ad"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#94d6b9"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#bddfd5"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#c2e0d2"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#b7dacd"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#98bfa1"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#839f6a"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#aacab5"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#a2cec6"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#a7d1c7"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#acd4cb"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#b1d6cd"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#b7dbd4"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#b8ded8"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#bae2db"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#b9e0da"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#bce2db"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#bce2d9"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#bee1da"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#c0dfdc"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#c0ded9"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#c4dfd5"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#cce6dc"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#cadcd3",
    fillOpacity: 0.573
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28v1H3v-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29H4v-1h1z",
    fill: "#bdb295",
    fillOpacity: 0.761
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28v1H5v-1z",
    fill: "#d1a713"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M7 29v-1h1v1z",
    fill: "#e3b102"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h-1v-1h1z",
    fill: "#ecc106"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28v1h-1v-1z",
    fill: "#ecc613"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29v-1h1v1z",
    fill: "#f1cc40"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28v1h-1v-1z",
    fill: "#f2d55f"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h-1v-1h1z",
    fill: "#f9e18d"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28h1v1h-1z",
    fill: "#fdf0cc"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28v1h-1v-1z",
    fill: "#fef3da"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#fef9ea"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#fdf6d6"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#fef9e5"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#fdf3cb"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#faeea9"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#fbeeb8"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#f6eebd"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#f9e381"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#fad53d"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#fbd435"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#f9d126"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#f4ce16"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#f5ce0f"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#f9cd12"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#f7c90a"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#f8c806"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#f4ca04"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#f8c700"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#f5cc21"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#69d9ba"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#2fdbc1"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#87cdae"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#aeddc4"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#c0e2d2"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#c1ded3"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#b8d6c8"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#95b089"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#95b389"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#b4ded1"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#b6dccd"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#bbded1"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#bbe1d5"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#b9e2d8"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#b2e1d6"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#aee1d6"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#acded7"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#addad9"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#add6d9"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#b0d2db"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#b5cfdb"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#bbcbd9"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#becfdd"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#bacdd6",
    fillOpacity: 0.835
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29v1H4v-1z",
    fill: "#d2d6dc",
    fillOpacity: 0.318
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30H5v-1h1z",
    fill: "#b2994b"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29h1v1H6z",
    fill: "#dfb201"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29h1v1h-1z",
    fill: "#e3b701"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30h-1v-1h1z",
    fill: "#e5b800"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-1h1v1z",
    fill: "#e8bd05"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29v1h-1v-1z",
    fill: "#eec20f"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M27 29h1v1h-1z",
    fill: "#ebc60f"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29h1v1h-1z",
    fill: "#f3ce4a"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M30 29v1h-1v-1z",
    fill: "#f4dc90"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h-1v-1h1z",
    fill: "#fce08e"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29h1v1h-1z",
    fill: "#fcf1c5"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29h1v1h-1z",
    fill: "#fef1ce"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h-1v-1h1z",
    fill: "#fef7e0"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#fcf8e3"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#fdf7df"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#fdf1bc"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#fceaac"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#fcf1c7"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#f9eeb1"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#f6dd63"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#fad743"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#fad22f"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#f7cf15"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#f7ce0f"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#f6cc0c"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#f6ce0b"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#f8cc09"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#f8c904"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#faca06"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#b2c683"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#15d2e4"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#64dcc4"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#99d6c0"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#aedec7"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#c0e1d4"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#bfded0"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#c1d9d1"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#a4c5a6"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#8ea974"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#c2e2cc"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#c3e3d2"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#c9e3d4"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#c5e3d4"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#bde4d2"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#b7e3d2"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#afe1d3"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#a5dfd5"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#99ddd4"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#8fdcd3"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#8ad9d1"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#88d5d1"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#89d4d2"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#92d1d6"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#9fd0dd"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#abd0dc",
    fillOpacity: 0.984
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#c2d5d9",
    fillOpacity: 0.216
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30h1v1H5z",
    fill: "#aaa68b",
    fillOpacity: 0.686
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M6 30h1v1H6z",
    fill: "#ba9822"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M8 31H7v-1h1z",
    fill: "#e7b504"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#e8be04"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#ebbf08"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#ecc110"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h1v1h-1z",
    fill: "#efc50b"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30h1v1h-1z",
    fill: "#efca2c"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30h1v1h-1z",
    fill: "#f3da7e"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30v1h-1v-1z",
    fill: "#fbdc80"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1z",
    fill: "#faeaa4"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#fef4da"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#fef2c9"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#fcfae6"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#fef5d8"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#fdf4d5"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#fef4d3"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#fbeeaa"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#fcf6d7"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#f7f0cd"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#f7e894"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#f8dc4d"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#f9d731"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#fad118"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#fbcf15"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#f5d015"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#f6d00e"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#f8cd0d"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#fcce0f"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#d8cd49"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#2b905d"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#2fb189"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#95ddc5"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#a1dbcd"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#bae4cd"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#bfe0cc"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#bcdece"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#c6d8d2"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#a4cab0"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#90b37e"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#c5e1c9"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#d0e6d9"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#cfe8d8"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#d0e9d7"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#d0e9da"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#cce9db"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#c5e8dc"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#b4e7d8"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#a9e5d7"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#a5e2d6"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#9cded7"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#a4e2df"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#aed9d5",
    fillOpacity: 0.459
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32H5v-1h1z",
    fill: "#ccdde5",
    fillOpacity: 0.118
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M6 31h1v1H6z",
    fill: "#77794b",
    fillOpacity: 0.847
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M7 31h1v1H7z",
    fill: "#c8a110"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31h1v1h-1z",
    fill: "#e5b602"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M17 32h-1v-1h1z",
    fill: "#e4b802"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31h1v1h-1z",
    fill: "#e8bf05"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#ecc30f"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#ecc213"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#eec50f"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32h-1v-1h1z",
    fill: "#f0c91a"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#f4d455"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1z",
    fill: "#fad96e"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#fde188"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#fef2cc"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#fef4d9"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#fefcee"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#fcf3c2"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#fdf1b6"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#fdeead"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#fbf4ca"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#fcf0bc"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#fce27b"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#fedc5f"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#f8d93e"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#fad83d"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#f9d432"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#f9d532"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#facf13"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#fcd317"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#d9c441"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#589f8f"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#45c8ac"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#5da76f"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#6f8e6a"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#b9d7bb"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#c4e5d9"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#badcd3"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#bfdcd4"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#c0d9d3"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#9ac4af"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#97b78a"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#c8e4cc"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#cae8d6"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#d0e8d8"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#d2e8da"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#d1e9da"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#d0e7da"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#d5e9dd"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#d5eade"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#d5eadd"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#d8ebde"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#d4e8de"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#d1e9df"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#cfeae0"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#ceebdc"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#caf1e6"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#c6e7dc",
    fillOpacity: 0.667
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32h1v1H6z",
    fill: "#6f8a7a",
    fillOpacity: 0.188
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32v1H7v-1z",
    fill: "#60642b",
    fillOpacity: 0.867
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32h1v1H8z",
    fill: "#d1a60f"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M9 32h1v1H9z",
    fill: "#e8ba01"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33h-1v-1h1z",
    fill: "#e3b700"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32h1v1h-1z",
    fill: "#e6b902"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33v-1h1v1z",
    fill: "#e9bf04"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1z",
    fill: "#e9c10b"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#ecc514"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#f0c914"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#f3d244"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#f8dd67"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#ffe188"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#fceca8"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#fdf4cc"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#fdf2c1"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#fff7e7"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#fef8df"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#feedb1"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#fcefaa"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#fdeba1"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#fde588"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#fee070"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#fdde63"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#fbdc50"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#fbd841"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#fad735"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#ffd72e"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#d1d055"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#339468"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#0ba69f"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#67d4bf"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#afd8c8"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#bed1d7"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#a1b693"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#a2c198"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#bed9d7"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#99c3a4"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#a3c094"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#cde9cf"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#cbe9d1"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#cfead3"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#d1ecd4"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#d1ebd6"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#d4eddb"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#d5ecdd"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#d5ecdf"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#d5ebe0"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#d4ebe0"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#d1edde"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#d4ecde"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#d8eadf"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#d7eddf"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#d1ecdc"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#cdf2e4"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#c0e8da",
    fillOpacity: 0.812
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#cff",
    fillOpacity: 0.02
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34H7v-1h1z",
    fill: "#475864",
    fillOpacity: 0.169
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34H8v-1h1z",
    fill: "#55461c",
    fillOpacity: 0.871
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34H9v-1h1z",
    fill: "#c8a00d"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34v-1h1v1z",
    fill: "#edbb04"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34v-1h1v1z",
    fill: "#e6b603"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34h-1v-1h1z",
    fill: "#e8b503"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34h-1v-1h1z",
    fill: "#e7bd03"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#e7be06"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#e9c10c"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#edc419"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#eec516"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#efc917"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#f2d13d"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#f8d85c"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#fce181"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#fee994"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#fdedaf"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#fdf4c9"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#fdf6d7"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#fdf1b9"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#feefb3"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#feeeac"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#fdeda2"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#fdeb9c"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#fce47c"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#fcde60"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#fbdc4e"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#fee04f"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#bbc14e"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#2a8942"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#10af8b"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#5bcfc0"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#a0d9cd"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#bfe0d7"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#c5e0d9"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#b6d1c5"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#95ac84"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#adcaa6"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#b9ddd7"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#aed1be"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#9fc297"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#bfd8b6"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#d1e9d7"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#d1e9d5"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#d3ead5"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#d2ebd4"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#d4ecd6"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#d4efd9"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#d4eddd"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#d8eee0"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#d6eedf"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#cceee0"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#baede0"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#abe8d9"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#9ee3d6"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#9ee0da"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#a4d6d7",
    fillOpacity: 0.882
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#dde",
    fillOpacity: 0.059
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34h1v1H8z",
    fill: "#303444",
    fillOpacity: 0.247
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34h1v1H9z",
    fill: "#312914",
    fillOpacity: 0.929
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35v-1h1v1z",
    fill: "#ac880b"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34v1h-1v-1z",
    fill: "#e1bb00"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#e7bc03"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#e6be04"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#e9c00e"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#eac115"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#eac315"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#eec618"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#f0c91f"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#f4d038"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#f8d64d"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#fcdf6b"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#fcea93"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#fcf3c4"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#fcf0c0"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#fdefae"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#feefb1"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#fef0b3"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#fdefaf"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#fdedac"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#fdeca6"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#fcea8d"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#ffe879"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#fce370"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#8dae44"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#148a32"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#099c4e"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#3ebc8b"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#a6d6b8"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#c8ded3"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#cce4dd"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#cfe3d8"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#c9e0d5"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#b3cbbd"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#9bb285"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#c0dfc3"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#adcca5"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#b6cda2"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#ceeadb"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#d2e9d7"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#d4e9d7"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#d4ead9"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#d4edd9"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#d6eed8"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#d0edd9"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#baeed6"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#a0ead7"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#96e6dd"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#83ded7"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#73d7d5"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#81d2d8"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#91cddc"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#a5c9e1"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#afc2d9",
    fillOpacity: 0.914
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#c5d0d0",
    fillOpacity: 0.086
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M10 36H9v-1h1z",
    fill: "#2d3d3d",
    fillOpacity: 0.459
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36h-1v-1h1z",
    fill: "#090a04"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35v1h-1v-1z",
    fill: "#765a0d"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36h-1v-1h1z",
    fill: "#d9af0b"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36v-1h1v1z",
    fill: "#e5ba02"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#e6bb01"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#e8bc02"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#e6bc04"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#e6be07"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#e9c10f"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#e9c211"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#e9c413"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#edc618"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#f0c91d"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#f6d448"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#fbde63"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#fee57c"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#feea8c"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#fdefaa"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#fff1b2"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#fff2b6"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#fef0b7"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#fef1b2"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#fff5af"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#fdf2a2"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#bfb870"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#83703d"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#5e855b"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#30a141"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#41af6a"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#7dc6a4"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#a6d4b9"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#c0d8c8"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#d9e6df"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#d9ece1"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#deeae2"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#d7e0dd"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#bac4a8"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#b5c28e"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#accdab"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#afe3d9"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#bfecde"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#caebdf"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#ceeadd"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#d0eadc"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#d2ecdd"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#d2ecdb"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#d2edda"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#d3f0dc"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#c8efd9"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#a2e9d4"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#3fe0cd"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#41d7d7"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#78ccdb"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#8cc0dd"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#94bbda"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#9fb6d5"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#a3b8ce"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#9eb8c0",
    fillOpacity: 0.902
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#bbc9c9",
    fillOpacity: 0.075
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M9 37H8v-1h1z",
    fill: "#fff",
    fillOpacity: 0.118
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37H9v-1h1z",
    fill: "#86bd88",
    fillOpacity: 0.749
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M11 37h-1v-1h1z",
    fill: "#105212"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36v1h-1v-1z",
    fill: "#383d19"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M13 37v-1h1v1z",
    fill: "#a08318"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36h1v1h-1z",
    fill: "#e2b408"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36v1h-1v-1z",
    fill: "#eabf02"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v-1h1v1z",
    fill: "#e3bb00"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#e4bb00"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#e6bb02"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#e6bb05"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#e7be07"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#e7c00b"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#e7c212"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#ebc61c"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#edc71c"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#efca20"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#f9d658"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#fce674"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#fdec8a"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#feee97"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#fdf3b2"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#fef2b7"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#fef3b8"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#fef1b5"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#fff8c0"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#fef4b8"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#c0c78b"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#667643"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#5a3904"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#9f5c22"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#68a383"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#28af9b"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#52ad9d"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#87b293"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#91c295"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#9cca96"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#bae0ba"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#c8e8cb"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#c0e6c0"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#9de398"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#73d46d"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#9cd2af"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#a9d1da"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#9ed3de"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#a8dadd"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#bbe5e2"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#c3e7e1"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#c9eae1"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#caebde"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#cbebdb"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#ccecdd"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#cfeede"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#d2eedf"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#b9ecda"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#39e3ce"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#23d6d5"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#7fc1dc"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#99b4df"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#9badd4"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#95aec6"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#97b5b8"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#99b4ab",
    fillOpacity: 0.835
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#d4ffd4",
    fillOpacity: 0.024
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M9 37v1H8v-1z",
    fill: "#fbfbff",
    fillOpacity: 0.322
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37v1H9v-1z",
    fill: "#bcd4bf"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37h1v1h-1z",
    fill: "#4c9c4c"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M11 38v-1h1v1z",
    fill: "#1a5f1d"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M12 37h1v1h-1z",
    fill: "#0b1810"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38h-1v-1h1z",
    fill: "#373c37"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M15 37v1h-1v-1z",
    fill: "#483f15"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v1h-1v-1z",
    fill: "#947c12"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-1v-1h1z",
    fill: "#d4ab0e"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38v-1h1v1z",
    fill: "#e8be05"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#eabf01"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#e5bc06"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#e3bc06"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#e5bd03"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#ebbe06"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#eac008"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#e9c318"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#ebc620"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#ecc720"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#efcd39"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#f2d145"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#f7d759"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#fee572"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#feeb82"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#fef090"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#fff2a6"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#fff7ad"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#fffcb8"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#fffbbc"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#ece6a8"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#a9bd7a"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#4f8038"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#494c06"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#a46700"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#cc8f1f"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#7bad70"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#1fb0a7"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#319faf"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#529bbd"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#6ba3c2"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#56c1a4"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#26e833"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#25f22d"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#28f25a"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#1cf442"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#09f918"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#01fd09"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#49ed85"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#a8d5d4"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#adcfd8"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#abcfdc"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#acd4e0"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#b4dee2"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#b8e4e4"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#bde7e0"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#c2e8de"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#c3ebde"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#c4eadc"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#cdeddf"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#cdeedd"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#8bebda"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#1bdbce"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#50cad9"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#91b5dd"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#9aabd4"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#9aa9c2"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#96b4b0"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#90b19f",
    fillOpacity: 0.725
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38v1H8v-1z",
    fill: "#ecf3ee",
    fillOpacity: 0.431
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38h1v1H9z",
    fill: "#d5e3d4"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39h-1v-1h1z",
    fill: "#a3c6ad"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v-1h1v1z",
    fill: "#5ca16f"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M12 39v-1h1v1z",
    fill: "#266830"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38v1h-1v-1z",
    fill: "#04190a"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1z",
    fill: "#0a0d14"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#312c1c"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h1v1h-1z",
    fill: "#6a5b1d"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#a68c1c"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#cdaa0b"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#e4bd10"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#eec40c"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#f1c305"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#ecc40b"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#ecc410"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#efcb1c"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#efd036"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#f4d858"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#f8de5c"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#fce36b"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#ffee80"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#fff57e"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#fff892"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#f8f598"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#e1d98b"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#afa472"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#646a46"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#265b1a"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#207f00"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#78a905"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#c4a821"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#a4b358"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#4cba96"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#20abad"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#3e95b3"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#5e9ac0"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#49a7c1"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#4fb4be"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#4fd198"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#05f91a"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#00ff5f"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#00fe9f"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#00fe98"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#01fe76"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#00fe31"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#0afb27"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#82e2b7"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#b5d0d3"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#b4d0d2"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#b7cbdb"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#b4cfe0"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#aed7e0"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#b0dcdf"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#bbe1e1"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#bce5df"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#bce7de"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#c0e8df"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#c7e9de"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#60e5d6"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#18d3d3"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#64bdd6"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#97acd8"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#a1a7c9"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#99b1b4"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#93b6a7",
    fillOpacity: 0.514
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M8 39h1v1H8z",
    fill: "#ecf4ee",
    fillOpacity: 0.478
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M10 40H9v-1h1z",
    fill: "#d2e8d6"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v1h-1v-1z",
    fill: "#c2d6c8"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40h-1v-1h1z",
    fill: "#b7ccbf"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39v1h-1v-1z",
    fill: "#73a58a"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M13 40v-1h1v1z",
    fill: "#367c50"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39h1v1h-1z",
    fill: "#143e24"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-1h1v1z",
    fill: "#000802"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M18 39v1h-1v-1z",
    fill: "#080811"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#191e1f"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#241f10"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#44390e"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#655811"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#867415"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#ab9219"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#c5a111"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#cdaf14"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#d2b51e"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#dbbb2b"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#dcbf3e"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#dbbd40"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#d4ba4f"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#c4b352"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#b0a255"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#8d893c"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#696236"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#3c3532"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#14132c"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#022c46"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#007b73"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#08c04e"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#63df41"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#6dbc5f"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#46b894"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#1ab7ae"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#21a3b3"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#4f96bf"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#3c9bbd"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#36b2c1"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#5abeb4"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#81c0bb"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#67d58b"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#04fa51"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#00ffbc"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#02fed7"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#01ffd5"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#02ffba"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#00fe63"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#2ef47e"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#a8dac9"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#b4d1cb"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#b5ced2"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#bacad7"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#bbcbdc"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#b4d1df"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#b7d8e2"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#b9dce4"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#b8e1e3"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#b7e2e0"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#b7e3de"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#bae6db"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#b8e7db"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#55dfd2"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#2fccd5"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#85b6dd"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#9caad2"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#95adb9",
    fillOpacity: 0.996
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#a2b9b2",
    fillOpacity: 0.302
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40v1H8v-1z",
    fill: "#eef0eb",
    fillOpacity: 0.471
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40h1v1H9z",
    fill: "#d7e8d5"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40v1h-1v-1z",
    fill: "#bed9c8"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40v1h-1v-1z",
    fill: "#c2d3ca"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41v-1h1v1z",
    fill: "#c0d3c8"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M14 40v1h-1v-1z",
    fill: "#96b7ad"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v-1h1v1z",
    fill: "#50947b"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40h1v1h-1z",
    fill: "#287847"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40v1h-1v-1z",
    fill: "#0d3d24"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h1v1h-1z",
    fill: "#001403"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#000400"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#062907"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#054c0a"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#033206"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#000100"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#0a0f0d"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1z",
    fill: "#0a0804"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#0d0c03"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#151504"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#211e0c"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#1e1a09"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#150f08"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#100e1d"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#070428"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#000034"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#00004b"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#00035f"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#000a77"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#044693"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#04a0ab"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#01c2b7"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#0ad9bb"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#2fe1b8"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#20c1a8"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#33afaf"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#3aa1b9"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#369dc4"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#39aec2"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#4cbdbd"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#7fc0b8"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#94c1b4"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#9ec4ba"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#63dd8f"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#01fd91"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#02fdf9"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#01fefe"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#01fff4"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#02fed8"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#01feae"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#67eac1"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#b6d3c0"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#b1d1c4"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#b4cdc7"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#b7ccd1"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#baccd9"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#bccedf"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#b7d0e1"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#b4d5df"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#b1d8de"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#b2dcdc"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#b1e0dc"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#b8e0db"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#a2e3de"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#51d6d1"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#4bc5d4"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#9bb3df"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#9daec6",
    fillOpacity: 0.875
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#afbfbf",
    fillOpacity: 0.063
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#181818",
    fillOpacity: 0.082
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#2a352a",
    fillOpacity: 0.094
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#2a2a35",
    fillOpacity: 0.094
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#282833",
    fillOpacity: 0.098
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#333",
    fillOpacity: 0.098
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#31313a",
    fillOpacity: 0.102
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.106
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#383842",
    fillOpacity: 0.106
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1z",
    fill: "#3f3f48",
    fillOpacity: 0.11
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#484848",
    fillOpacity: 0.11
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1z",
    fill: "#4f4f57",
    fillOpacity: 0.114
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40v1h-1v-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.137
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40h1v1h-1z",
    fill: "#636a6a",
    fillOpacity: 0.141
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h-1v-1h1z",
    fill: "#5a625a",
    fillOpacity: 0.122
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M106 40v1h-1v-1z",
    fill: "#51515b",
    fillOpacity: 0.11
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M106 40h1v1h-1z",
    fill: "#4f574f",
    fillOpacity: 0.114
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41h-1v-1h1z",
    fill: "#606057",
    fillOpacity: 0.114
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41v-1h1v1z",
    fill: "#576057",
    fillOpacity: 0.114
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40v1h-1v-1z",
    fill: "#5d5d55",
    fillOpacity: 0.118
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40h1v1h-1z",
    fill: "#666",
    fillOpacity: 0.118
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M111 41v-1h1v1z",
    fill: "#5d5d66",
    fillOpacity: 0.118
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M112 40h1v1h-1z",
    fill: "#5d5d5d",
    fillOpacity: 0.118
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M113 41v-1h1v1z",
    fill: "#55555d",
    fillOpacity: 0.118
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M116 41h-1v-1h1z",
    fill: "#5a5a5a",
    fillOpacity: 0.122
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M116 40h1v1h-1z",
    fill: "#575757",
    fillOpacity: 0.125
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41h-1v-1h1z",
    fill: "#5c5555",
    fillOpacity: 0.141
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41h-1v-1h1z",
    fill: "#3c3c34",
    fillOpacity: 0.133
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41v-1h1v1z",
    fill: "#383838",
    fillOpacity: 0.035
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M8 41h1v1H8z",
    fill: "#ebf1eb",
    fillOpacity: 0.459
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42h-1v-1h1z",
    fill: "#bcd5c8"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41v1h-1v-1z",
    fill: "#bfd0c8"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v1h-1v-1z",
    fill: "#bcd0c8"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42h-1v-1h1z",
    fill: "#aacbbe"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h1v1z",
    fill: "#72aa98"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h-1v-1h1z",
    fill: "#379172"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1z",
    fill: "#1a8a4f"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#0e662b"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#094c10"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#115417"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#174925"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#06250f"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#001a05"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#000800"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#140f0a"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#29392a"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#082b51"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#0c2a5f"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#073772"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#0a497e"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#0b6290"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#0b829b"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#0aa6aa"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#0ebcac"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#14c4ab"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#13c2ab"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#1abaac"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#3aaeb8"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#46b0c0"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#4bb7c7"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#6fbfc5"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#91c2bd"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#a1c6bc"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#a1c2b3"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#a2c3b5"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#a9c4b8"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#5ae3a9"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#00fdd1"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#02fefa"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#01ffff"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#02ffff"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#03fefd"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#00fff0"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#1cf7e0"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#9ddec6"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#b7d3c3"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#b1d1c0"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#b9cec8"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#baccce"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#baccd2"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#bbcdd6"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#bcd1db"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#b2d1db"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#add3da"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#aed6d6"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#afd9d8"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#addddd"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#a0dddf"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#5ad3d7"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#7ec8e3"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#adbcd4",
    fillOpacity: 0.588
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#7f7fff",
    fillOpacity: 0.008
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#343230",
    fillOpacity: 0.537
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#413f3a",
    fillOpacity: 0.918
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#272726",
    fillOpacity: 0.933
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#252726",
    fillOpacity: 0.933
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#262628",
    fillOpacity: 0.933
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#28282a",
    fillOpacity: 0.933
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#272729",
    fillOpacity: 0.933
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#29292b",
    fillOpacity: 0.937
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#2a2a2c",
    fillOpacity: 0.937
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#2c2c2e",
    fillOpacity: 0.937
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#2c2c2e",
    fillOpacity: 0.941
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#2f2f31",
    fillOpacity: 0.941
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#343437",
    fillOpacity: 0.941
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#37383b",
    fillOpacity: 0.945
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#3a3b3e",
    fillOpacity: 0.945
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#3f4043",
    fillOpacity: 0.949
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#414244",
    fillOpacity: 0.949
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#434447",
    fillOpacity: 0.949
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42v-1h1v1z",
    fill: "#454648",
    fillOpacity: 0.949
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41v1h-1v-1z",
    fill: "#454648",
    fillOpacity: 0.961
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42v-1h1v1z",
    fill: "#4a4e50",
    fillOpacity: 0.961
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M104 41v1h-1v-1z",
    fill: "#4f5354",
    fillOpacity: 0.961
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41v1h-1v-1z",
    fill: "#515556",
    fillOpacity: 0.953
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h1v1h-1z",
    fill: "#545758",
    fillOpacity: 0.949
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M107 41v1h-1v-1z",
    fill: "#525455",
    fillOpacity: 0.949
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42h-1v-1h1z",
    fill: "#545556",
    fillOpacity: 0.949
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42h-1v-1h1z",
    fill: "#545656",
    fillOpacity: 0.949
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v-1h1v1z",
    fill: "#535454",
    fillOpacity: 0.949
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41h1v1h-1z",
    fill: "#505152",
    fillOpacity: 0.953
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42h-1v-1h1z",
    fill: "#4f4f52",
    fillOpacity: 0.953
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M112 42v-1h1v1z",
    fill: "#4b4c4f",
    fillOpacity: 0.949
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h-1v-1h1z",
    fill: "#47484a",
    fillOpacity: 0.953
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h-1v-1h1z",
    fill: "#414344",
    fillOpacity: 0.953
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M116 41v1h-1v-1z",
    fill: "#3d4142",
    fillOpacity: 0.953
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M116 42v-1h1v1z",
    fill: "#3c3e3d",
    fillOpacity: 0.953
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M118 41v1h-1v-1z",
    fill: "#353535",
    fillOpacity: 0.961
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41v1h-1v-1z",
    fill: "#343331",
    fillOpacity: 0.961
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M119 41h1v1h-1z",
    fill: "#4a4945",
    fillOpacity: 0.961
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M120 41h1v1h-1z",
    fill: "#464643",
    fillOpacity: 0.655
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v1H8v-1z",
    fill: "#eaf2ea",
    fillOpacity: 0.396
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43H9v-1h1z",
    fill: "#d4e5d4"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42h1v1h-1z",
    fill: "#b9d5c7"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1z",
    fill: "#b2d1c9"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43h-1v-1h1z",
    fill: "#b5cec7"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43v-1h1v1z",
    fill: "#b7cfc6"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43v-1h1v1z",
    fill: "#b6d1c7"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#9fccb8"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#62afa5"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#30a67f"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#229d5a"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#317e4a"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#63a884"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#3d8e6e"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#368453"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#2d7145"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#236139"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#235c34"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#1c4d2d"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#0d3621"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#3a5038"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#6f9f7a"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#48987c"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#3a9e8e"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#3ea993"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#32aa9b"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#36aea2"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#36aea8"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#32b2ad"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#2cbab2"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#2fbdbd"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#49bfc7"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#6fc3cc"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#8ec6c6"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#a5c6c4"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#a7c5bf"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#a9c7b9"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#a9c6b5"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#a8c5b3"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#a8c5b6"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#afcabc"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#4de7c7"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#00fef7"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#00fffe"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#00fefd"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#00fffa"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#59eee4"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#bbd6cb"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#b5d3c2"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#add3c1"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#b5cfc8"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#bacdc8"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#bdcbcb"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#bfced1"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#b8cdd3"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#b3cfd4"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#b5d1d6"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#afd0d3"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#a4d2d1"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#a4d7d5"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#9adadd"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#8ad2d7",
    fillOpacity: 0.973
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#aed8d8",
    fillOpacity: 0.235
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#242321",
    fillOpacity: 0.906
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#454440"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#1b1a1b"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#1f1d1f"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#222123"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#313233"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#3b3c3d"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#404243"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M101 42v1h-1v-1z",
    fill: "#454647"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42h1v1h-1z",
    fill: "#4f5152"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43h-1v-1h1z",
    fill: "#525556"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43v-1h1v1z",
    fill: "#595c5d"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M106 42v1h-1v-1z",
    fill: "#5d5f61"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43v-1h1v1z",
    fill: "#5c5e60"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M108 43h-1v-1h1z",
    fill: "#5c5c5f"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M109 43v-1h1v1z",
    fill: "#525356"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M111 42v1h-1v-1z",
    fill: "#4b4c4e"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M112 43h-1v-1h1z",
    fill: "#464848"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M113 43h-1v-1h1z",
    fill: "#434545"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M113 42h1v1h-1z",
    fill: "#3e4040"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M114 42h1v1h-1z",
    fill: "#3a3b3c"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42h1v1h-1z",
    fill: "#333435"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M117 43h-1v-1h1z",
    fill: "#2f3031"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M120 42v1h-1v-1z",
    fill: "#535351"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M121 42v1h-1v-1z",
    fill: "#454544",
    fillOpacity: 0.867
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M122 42v1h-1v-1z",
    fill: "#898989",
    fillOpacity: 0.051
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44H8v-1h1z",
    fill: "#eff7ef",
    fillOpacity: 0.263
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44v-1h1v1z",
    fill: "#d3e2d4"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44h-1v-1h1z",
    fill: "#b5d5c7"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44h-1v-1h1z",
    fill: "#b5d3c9"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M13 43h1v1h-1z",
    fill: "#b5d1cb"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#b0d3bf"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#b2d6bf"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#a3d6b9"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#7ac0ad"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#509e7d"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#a6cfb0"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#a9d0bf"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#8ec9ae"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#87bea1"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#7cb793"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#80b389"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#78ac84"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#649f7b"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#3a6e47"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#5c8068"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#77c1b4"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#6ebeb4"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#6bbfb1"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#67c4b4"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#6ec6bc"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#70c7c7"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#6fccc3"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#7ac9c2"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#91c9cb"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#a6c5ca"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#b0c5c6"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#b5c2c2"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#b1c5bf"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#abc8b5"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#adc7b7"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#abc5b6"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#aac6b6"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#adc6ba"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#aeccbb"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#3becdb"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#01fffd"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#01fcfe"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#09fdfa"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#2afcfb"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#2ffbfc"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#1bfdf9"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#0bfcfc"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#00fefe"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#15f9f7"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#96e4e0"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#bfd3c9"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#aed3c1"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#bad1c6"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#bbcfc4"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#bccec5"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#c1cdc8"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#bdcdc9"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#b9cecb"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#b8cecd"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#b5cfce"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#abd0cd"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#a6d0ca"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#acd6d3"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#b4d9d8",
    fillOpacity: 0.827
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#222",
    fillOpacity: 0.894
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#232322"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#292728"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#6b6966"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#767572"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#797875"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#7b7a77"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#7c7b78"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#7d7d7a"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#80807d"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#848480"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#868682"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#878884"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#8c8c88"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#8f908c"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#93948e"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#979992"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#9b9d96"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#9ea099"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#a2a49f"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M107 44v-1h1v1z",
    fill: "#a6a8a4"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M109 44h-1v-1h1z",
    fill: "#a4a7a2"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M110 44h-1v-1h1z",
    fill: "#a4a6a2"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44h-1v-1h1z",
    fill: "#a2a5a0"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M113 44v-1h1v1z",
    fill: "#9d9f9b"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44h-1v-1h1z",
    fill: "#9a9c98"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M115 44v-1h1v1z",
    fill: "#979895"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M117 43v1h-1v-1z",
    fill: "#959795"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M119 43h1v1h-1z",
    fill: "#323334"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M120 44v-1h1v1z",
    fill: "#3e3f3f",
    fillOpacity: 0.867
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v-1h1v1z",
    fill: "#919191",
    fillOpacity: 0.055
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44v1H8v-1z",
    fill: "#f1f8f1",
    fillOpacity: 0.145
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M10 44v1H9v-1z",
    fill: "#d5e5d6",
    fillOpacity: 0.965
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M11 44v1h-1v-1z",
    fill: "#bed9c7"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45v-1h1v1z",
    fill: "#b3d7c8"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44v1h-1v-1z",
    fill: "#aad5c2"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M14 45h-1v-1h1z",
    fill: "#afd6c7"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44v1h-1v-1z",
    fill: "#b2d4cc"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#b5d5c9"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1z",
    fill: "#b2d6be"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#bad7b8"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#bed8bf"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#7eb18b"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#9abd97"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#cddec5"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#c3dabe"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#c4ddc1"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#bfdbc4"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#bbd9c6"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#b8dac3"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#b7d7c5"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#86b8a3"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#4f785b"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#80977f"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#bfdbc9"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#aed5be"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#a9cfc5"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#a4cdc5"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#9acac2"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#9cc6c1"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#a6c4c6"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#a7c2c7"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#aac3bf"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#adc5bc"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#abc7b9"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#aec7b7"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#acc7b6"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#a7c6b3"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#a9c7b5"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#b0c8b9"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#aecdc0"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#30f1ea"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#02fdfd"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#28fcf9"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#71fdfd"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#a0fefe"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#a6fefd"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#9dfefe"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#7ffefe"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#50fdfc"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#25fbfc"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#6cf5f3"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#bfd9d6"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#b7d4c8"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#bbd1c7"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#bad0c5"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#c0d0c6"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#becfc3"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#b8cebf"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#b7cfc0"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#bad0c7"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#b3cfc7"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#b4cfc8"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#bed7cc"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#b0c7bd",
    fillOpacity: 0.718
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#594c59",
    fillOpacity: 0.078
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#222124",
    fillOpacity: 0.902
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#242527"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#8c8a86"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#bbbcb3"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#bcbeb4"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#bebfb6"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#c1c2ba"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#c3c4bd"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1z",
    fill: "#c7c9c1"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v-1h1v1z",
    fill: "#c7c9c2"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45h-1v-1h1z",
    fill: "#c9cbc3"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M109 45v-1h1v1z",
    fill: "#cbcec8"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44v1h-1v-1z",
    fill: "#cbcdc7"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v1h-1v-1z",
    fill: "#caccc7"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M114 45v-1h1v1z",
    fill: "#cacec8"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M116 44v1h-1v-1z",
    fill: "#c7ccc4"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M117 45h-1v-1h1z",
    fill: "#c9cbc5"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M119 44v1h-1v-1z",
    fill: "#636362"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M119 45v-1h1v1z",
    fill: "#323337"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M121 44v1h-1v-1z",
    fill: "#404143",
    fillOpacity: 0.875
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M9 45h1v1H9z",
    fill: "#d9e8dd",
    fillOpacity: 0.859
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46v-1h1v1z",
    fill: "#bddcc8"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M12 45v1h-1v-1z",
    fill: "#b0d7c4"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M13 46h-1v-1h1z",
    fill: "#add7c4"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46h-1v-1h1z",
    fill: "#abd7c5"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45v1h-1v-1z",
    fill: "#b1d6c7"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46h-1v-1h1z",
    fill: "#b6d6c6"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45h1v1h-1z",
    fill: "#b9d7c6"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#bdd7c6"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#bed7c3"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#bed7c1"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#92c1a5"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#85aa82"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#c2dcc1"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#c3dbca"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#c2dbc4"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#c5dac2"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#c6d9c3"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#c3dac4"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#c3dcc7"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#84b39a"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#497752"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#759a77"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#add4c0"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#a1c8c4"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#9ec5bf"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#a1c4c1"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#a6c1c5"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#a4c1c0"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#a7c4bd"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#adc4b4"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#aec7b3"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#afc8b5"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#aec6b7"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#abc6b7"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#a7c6b4"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#a7c5b3"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#b0c9bb"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#abd0c6"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#2bf2f3"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#04fefb"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#43fcfc"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#8cfefe"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#b5fefe"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#c8fffd"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#d2fefe"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#cefeff"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#c0feff"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#a4ffff"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#a1fdfd"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#bae6eb"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#b9d5ce"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#b7d4c5"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#bbd2ca"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#bbd0c6"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#bfd0c6"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#c1cec3"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#bccfbf"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#b6cfbf"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#bbcebd"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#b8cfc0"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#b9d5c0"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#a1bebc"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#83a5b3",
    fillOpacity: 0.557
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#454545",
    fillOpacity: 0.086
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#212123",
    fillOpacity: 0.914
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#202122"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#666665"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#bbbcb5"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#b2b4ab"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#b5b7ae"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#b8b9b0"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#b8b9ae"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#b9b9af"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#bbbbb1"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#bbbcb1"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#bcbdb6"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#c0c1bb"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#c2c3be"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v-1h1v1z",
    fill: "#c6c9c3"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M116 45v1h-1v-1z",
    fill: "#c8ccc5"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M121 46h-1v-1h1z",
    fill: "#444749",
    fillOpacity: 0.886
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47H9v-1h1z",
    fill: "#e1f0e7",
    fillOpacity: 0.671
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M11 46v1h-1v-1z",
    fill: "#c4e2d1"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-1v-1h1z",
    fill: "#acd7c3"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h1v1h-1z",
    fill: "#a9d6c2"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47v-1h1v1z",
    fill: "#aed8c5"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M15 47h-1v-1h1z",
    fill: "#b5d8c6"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46v1h-1v-1z",
    fill: "#bcd8c4"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h-1v-1h1z",
    fill: "#bed7c6"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46v1h-1v-1z",
    fill: "#c0d7c8"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1z",
    fill: "#c1d6c6"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#c2d7c5"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#aaceb9"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#75a786"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#b0caa0"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#cbddcb"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#c5dbcb"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#c5dbc7"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#c6dcc8"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#c4dbc7"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#c4dac4"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#b7d2c4"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#78b299"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#3c774a"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#638866"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#a4c3c0"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#a9c0b8"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#a7c2b7"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#a8c1b4"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#a9c3af"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#a8c4ad"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#aac4ae"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#aac5af"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#abc7b2"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#aac7b8"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#a9c4b5"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#aac7b5"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#aac7b6"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#afc7bb"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#afd1d1"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#48f6f4"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#54fefd"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#9cfdfc"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#b3fefd"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#c9fefe"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#d9fefd"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#e2feff"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#e1fefe"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#dffffd"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#ddfffe"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#dcfffe"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#d6ffff"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#d7f8fc"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#c1d9db"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#bcd5cb"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#c2d2ca"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#bfd2c9"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#bfd2c7"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#c4cec4"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#c3cfc2"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#bccfc1"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#b9d0c1"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#bdd3bf"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#a1c3b6"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#6c97be"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#89a6d4",
    fillOpacity: 0.349
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#3d3d3d",
    fillOpacity: 0.098
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#202020",
    fillOpacity: 0.929
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#b7b8b1"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#b1b2ab"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#b3b3ac"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#b6b7ae"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#babcb2"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#bbbcb2"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#bebfb8"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M111 46v1h-1v-1z",
    fill: "#c6cac2"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M120 46h1v1h-1z",
    fill: "#464849",
    fillOpacity: 0.894
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M121 47v-1h1v1z",
    fill: "#787878",
    fillOpacity: 0.075
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48H9v-1h1z",
    fill: "#edf5f0",
    fillOpacity: 0.408
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47h1v1h-1z",
    fill: "#d0e8db"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1z",
    fill: "#add8c3"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1z",
    fill: "#acd8c3"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1z",
    fill: "#b5dbc7"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48v-1h1v1z",
    fill: "#b9d8c4"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48v-1h1v1z",
    fill: "#bdd7c4"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1z",
    fill: "#bdd7c8"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1z",
    fill: "#bcd6c7"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#b4d3c4"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#78b39b"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#7ead7d"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#c7dfc6"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#c7d9ce"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#c5dac9"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#c4dbca"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#c2d9c7"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#c0d8ca"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#bed8c7"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#a5d2bc"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#60b098"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#307a52"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#4f7450"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#9fc0aa"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#a8c7b2"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#a9c4b0"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#a7c3aa"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#a6c4a9"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#aac8af"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#aac8b2"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#a7c5b5"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#aac5b5"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#adc8b6"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#aec8b8"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#afc8bc"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#b4d6d3"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#a3fbfa"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#a2feff"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#b8fffd"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#cafffd"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#dbfefe"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#e5fffe"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#edffff"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#effeff"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#ebfffe"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#e8fffe"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#e9fffe"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#e9fffd"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#ecffff"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#d7eaef"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#bfd5d3"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#c3d5cb"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#c0d3c9"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#c2d3c8"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#cad2c9"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#c7d0c9"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#b9d1c1"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#bed6bd"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#a7c7a3"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#41b7b2"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#67b8d0",
    fillOpacity: 0.973
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#d8e8f3",
    fillOpacity: 0.18
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.11
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#202020",
    fillOpacity: 0.941
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#b6b7b0"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#b4b5ad"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#b5b6ad"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#b6b8ac"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#babbb3"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#bbbcb4"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#bec0b9"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#c5c6c0"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#c6c8c1"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M109 47v1h-1v-1z",
    fill: "#cccfc8"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47v1h-1v-1z",
    fill: "#cccfc7"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M118 47v1h-1v-1z",
    fill: "#c3c6bf"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M118 48v-1h1v1z",
    fill: "#acaea9"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M120 47h1v1h-1z",
    fill: "#494b4c",
    fillOpacity: 0.898
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M122 47v1h-1v-1z",
    fill: "#727272",
    fillOpacity: 0.078
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#f7fff7",
    fillOpacity: 0.133
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h-1v-1h1z",
    fill: "#d7e7dc",
    fillOpacity: 0.945
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M12 49h-1v-1h1z",
    fill: "#b6dac4"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1z",
    fill: "#b3d9c4"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49h-1v-1h1z",
    fill: "#b7d7c4"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49h-1v-1h1z",
    fill: "#bbd7c5"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1z",
    fill: "#b9d4c5"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#b8d2c6"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#b7d3c7"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1z",
    fill: "#b1d2c3"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#85bfac"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#4b9977"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#99c29d"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#cdded1"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#c0dacb"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#bfd9c9"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#bfd7c7"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#bad6c6"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#b9d6c4"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#9bcec2"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#4eaca1"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#25725f"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#305f37"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#84a57b"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#adc8ad"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#a5c6aa"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#a1c3a7"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#a7c5ab"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#a8c6ae"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#aac7af"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#acc6b2"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#aac4b2"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#abc7b4"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#acc5b4"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#b0c9bf"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#bfd9db"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#cbfefd"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#bffefd"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#defefe"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#eafefe"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "azure"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#fafeff"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#f6feff"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#f7fffe"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#f6fcfe"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#d0dce0"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#c1d5ce"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#c2d5cc"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#c9d3cb"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#c9d2c9"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#c2d3c7"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#c8d5c2"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#9fbb97"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#64b195"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#7bcdcc"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#97d6d8",
    fillOpacity: 0.808
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#1a1a1a",
    fillOpacity: 0.114
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.949
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#6d6d6b"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#b5b6af"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#babcb1"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#b0b2a6"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#b1b3aa"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#b1b4ac"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#b3b5ae"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#b0b3ab"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#b0b2ab"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#b3b4af"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#b3b4ae"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#b4b5af"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#b3b5af"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#b4b7b1"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#b6b9b2"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v-1h1v1z",
    fill: "#bcbfb8"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#c2c5be"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M109 49h-1v-1h1z",
    fill: "#c8cbc5"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48v1h-1v-1z",
    fill: "#ced0ca"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M119 48v1h-1v-1z",
    fill: "#acafaa"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M120 49v-1h1v1z",
    fill: "#4d5051",
    fillOpacity: 0.906
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49h-1v-1h1z",
    fill: "#797979",
    fillOpacity: 0.09
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#e5edea",
    fillOpacity: 0.678
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h1v1h-1z",
    fill: "#c7e2d3"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49v1h-1v-1z",
    fill: "#b3d7c2"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h1v1h-1z",
    fill: "#b6d6c4"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M15 50h-1v-1h1z",
    fill: "#b7d6c5"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v1h-1v-1z",
    fill: "#b8d4c7"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49v1h-1v-1z",
    fill: "#bcd3c8"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v-1h1v1z",
    fill: "#b8d3c7"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M19 50h-1v-1h1z",
    fill: "#afcfc4"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50h-1v-1h1z",
    fill: "#b0cfc3"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#acccbd"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#95c9b6"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#4a9d8f"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#53956b"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#bdd7c1"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#bfd8c8"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#bad4c7"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#b3d2c3"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#aad0c1"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#a4ccc0"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#a5c9bb"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#9fc3bf"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#67a2a6"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#2f7963"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#205b2a"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#4d7d4a"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#98bc90"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#afcbb0"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#a9c8b0"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#a5c6b0"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#acc6b3"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#b1c4b4"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#a8c6b0"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#b0c6ba"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#b2c6bc"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#afc9c0"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#c8dde2"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#deffff"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#d5fefe"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#defffe"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#ebfefe"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#f4ffff"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#fbfffe"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#fbffff"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#ebeef3"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#cad5d4"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#c3d7ca"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#cad3ce"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#c6d7c9"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#b5d0b0"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#79ad89"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#5ca991"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#8bc3be"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#bdd7d4"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#c6e2de",
    fillOpacity: 0.498
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#1e1e1f",
    fillOpacity: 0.953
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#6d6e6c"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#7e7e79"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#42423f"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#454646"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#474849"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#53534f"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#64635f"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#5f5f5e"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#616163"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#626363"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#6b6e6f"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h1v1h-1z",
    fill: "#6e7273"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M104 50v-1h1v1z",
    fill: "#75797a"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M106 49v1h-1v-1z",
    fill: "#6c7071"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#575859"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#656766"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50h-1v-1h1z",
    fill: "#5c5e5e"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M110 50v-1h1v1z",
    fill: "#545656"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50v-1h1v1z",
    fill: "#767977"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M113 50h-1v-1h1z",
    fill: "#c3c6c4"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M113 49h1v1h-1z",
    fill: "#ced0cb"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h-1v-1h1z",
    fill: "#b2b3af"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M119 49h1v1h-1z",
    fill: "#4c4d4f"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M121 49v1h-1v-1z",
    fill: "#505152",
    fillOpacity: 0.922
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M122 49v1h-1v-1z",
    fill: "#767f7f",
    fillOpacity: 0.11
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50h1v1h-1z",
    fill: "#f7fbf7",
    fillOpacity: 0.259
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50v1h-1v-1z",
    fill: "#d5e8de",
    fillOpacity: 0.988
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M12 51v-1h1v1z",
    fill: "#afd5bf"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M14 50v1h-1v-1z",
    fill: "#b1d4c0"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M15 51h-1v-1h1z",
    fill: "#b7d2c5"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51h-1v-1h1z",
    fill: "#b7d1c7"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v1h-1v-1z",
    fill: "#b5d0c7"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50h1v1h-1z",
    fill: "#b0cec4"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50h1v1h-1z",
    fill: "#a7ccc3"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1z",
    fill: "#9ecbbd"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#9dc9bb"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#98c3b8"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#76aaa4"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#417e62"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#79b083"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#bbd4c7"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#b2d2be"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#afd0c6"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#a6ccc3"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#a6c9bf"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#aec6be"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#afc6bd"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#b2c2ba"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#acc1bb"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#7ab0a0"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#4a8f6d"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#287035"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#206326"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#598356"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#9cba93"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#b3cfb2"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#acccb9"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#a8c7ab"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#abc4b4"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#a7c8b6"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#abcbb8"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#aec8bd"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#d6e3e7"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#ebffff"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#e6fffe"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#efffff"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#f7ffff"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#faffff"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#fdfeff"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#fdfdfd"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#fdfafc"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#fefcfe"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#fefcfd"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#fdfbff"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#fdfcff"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#fefcff"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#fef5ff"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#dedbe7"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#c6ddd2"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#c1d7c1"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#8cb98d"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#5da56d"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#65b291"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#94c9b6"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#b3d3cd"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#bbd8cf",
    fillOpacity: 0.941
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#e2f7f0",
    fillOpacity: 0.141
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#1f1f20",
    fillOpacity: 0.957
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#252528"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#70706e"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#b8b9af"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#898984"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#282926",
    fillOpacity: 0.992
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#626260",
    fillOpacity: 0.784
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#818380",
    fillOpacity: 0.631
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#5b5b58",
    fillOpacity: 0.678
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#3d3e3d"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#393b3a"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#696964"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#a3a299"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#a3a49f"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#c1c6c7"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#bfc3c7"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#e0e5e9"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#ecf1f3"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h-1v-1h1z",
    fill: "#f7fafc"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51v-1h1v1z",
    fill: "#c1c3c7"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1z",
    fill: "#4b4c4f"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1z",
    fill: "#585a5a"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M109 50v1h-1v-1z",
    fill: "#6a6c6c",
    fillOpacity: 0.925
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M110 51h-1v-1h1z",
    fill: "#a8aaaa",
    fillOpacity: 0.357
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M111 51h-1v-1h1z",
    fill: "#939595",
    fillOpacity: 0.671
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M111 50h1v1h-1z",
    fill: "#575959",
    fillOpacity: 0.945
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v-1h1v1z",
    fill: "#757877"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50v1h-1v-1z",
    fill: "#cfd1cc"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M114 50h1v1h-1z",
    fill: "#cfd0c9"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51v-1h1v1z",
    fill: "#cccdc6"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50v1h-1v-1z",
    fill: "#b9b9b5"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h1v1h-1z",
    fill: "#555557"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M121 51h-1v-1h1z",
    fill: "#505153",
    fillOpacity: 0.941
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M122 50v1h-1v-1z",
    fill: "#747b7b",
    fillOpacity: 0.137
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52h-1v-1h1z",
    fill: "#e6f1ec",
    fillOpacity: 0.686
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51v1h-1v-1z",
    fill: "#c2e1d0"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M14 52h-1v-1h1z",
    fill: "#add0bd"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M14 51h1v1h-1z",
    fill: "#b4d0c5"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51v1h-1v-1z",
    fill: "#b2cdc7"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M17 52h-1v-1h1z",
    fill: "#a8ccc2"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M18 51v1h-1v-1z",
    fill: "#a3cac0"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#a2c5be"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#9dc3b9"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#9cc2b6"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#a1bfb2"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#9dc1ac"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#59957c"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#408d47"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#94c395"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#b1d2cc"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#a6cdc2"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#b1c8c0"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#adc8c0"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#aec7be"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#b2c5bb"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#b3c2b9"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#b4c2b2"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#a8c5b0"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#97c0b0"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#5aac8f"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#3c9167"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#286d45"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#235d2c"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#507f47"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#8bad87"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#adcbae"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#b1d2bb"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#a6ccbc"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#a5c6bb"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#aecbbe"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#e1e7ed"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#f9ffff"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#f5ffff"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#fdf5fd"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#fef5fe"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#fef7fe"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#fef8fe"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#fff8fe"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#fff6ff"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#feeffe"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#e0dde9"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#95bbaa"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#70a989"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#6daf90"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#8dbfa9"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#a9d1bf"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#b6d4c5"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#bddccc"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#c9e7db",
    fillOpacity: 0.565
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#232324",
    fillOpacity: 0.961
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#71716f"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#b8bab0"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#b0b1a8"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#535350"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#575757",
    fillOpacity: 0.871
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#bdbdb6",
    fillOpacity: 0.137
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#575755",
    fillOpacity: 0.796
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#3d3e3b"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#63635e"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#a7a79d"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51v1h-1v-1z",
    fill: "#aaada5"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52h-1v-1h1z",
    fill: "#c4caca"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v-1h1v1z",
    fill: "#dde5e8"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#fdffff"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h1v1h-1z",
    fill: "#d6d7da"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51v1h-1v-1z",
    fill: "#4e4f50"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M107 52v-1h1v1z",
    fill: "#616261",
    fillOpacity: 0.922
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52h-1v-1h1z",
    fill: "#b3b3b3",
    fillOpacity: 0.318
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M112 51v1h-1v-1z",
    fill: "#939593",
    fillOpacity: 0.51
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h-1v-1h1z",
    fill: "#515553"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M113 51h1v1h-1z",
    fill: "#c6c8c4"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h1v1h-1z",
    fill: "#cecfc8"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51v1h-1v-1z",
    fill: "#bdbeba"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M119 51h1v1h-1z",
    fill: "#5a5a5c"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52h-1v-1h1z",
    fill: "#505153",
    fillOpacity: 0.957
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v-1h1v1z",
    fill: "#767676",
    fillOpacity: 0.161
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53h-1v-1h1z",
    fill: "#f9f9ff",
    fillOpacity: 0.169
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53v-1h1v1z",
    fill: "#dcebe3",
    fillOpacity: 0.933
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M14 53h-1v-1h1z",
    fill: "#b2d0c3"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53h-1v-1h1z",
    fill: "#a6ccbf"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53v-1h1v1z",
    fill: "#a7c8bf"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#a9c6c0"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#a4c4be"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#a4c4bd"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#a1bfae"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#a7c1a4"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#8eb8a1"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#45885b"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#4e944e"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#9fc8a6"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#b1c5b7"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#b0c5b6"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#b1c5b5"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#abc4b2"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#aec6b4"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#abc5b3"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#aec5b7"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#a9c6b3"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#adc7b9"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#8abdaf"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#57aa96"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#4a9972"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#2f784c"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#215726"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#306833"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#5e8759"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#89b287"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#a5c9af"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#b4d1c4"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#eeecf2"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#fffeff"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#fffdff"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#fffbff"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#ffedff"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#ffeffe"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#f7effc"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#e5eaf4"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#cedce5"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#bfc8d3"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#b1bfc6"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#87aea6"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#a3bdb3"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#b5ccbd"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#b8d4c4"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#b9d5c9"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#bbdace"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#c3dfd2",
    fillOpacity: 0.886
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#ecf5ec",
    fillOpacity: 0.106
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#070707",
    fillOpacity: 0.125
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#252526",
    fillOpacity: 0.961
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#71726f"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#b7b9af"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#565651"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#565652",
    fillOpacity: 0.557
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#636563",
    fillOpacity: 0.522
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#3f403e"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#474644"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52v1h-1v-1z",
    fill: "#686864"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M100 53h-1v-1h1z",
    fill: "#696b69"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v1h-1v-1z",
    fill: "#73787a"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53h-1v-1h1z",
    fill: "#8c9093"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#999c9d"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h1v1z",
    fill: "#9c9d9f"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53h-1v-1h1z",
    fill: "#9f9fa0"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M106 52v1h-1v-1z",
    fill: "#89898b"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M106 53v-1h1v1z",
    fill: "#535353"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53h-1v-1h1z",
    fill: "#626260",
    fillOpacity: 0.882
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M109 52v1h-1v-1z",
    fill: "#cfcfcf",
    fillOpacity: 0.106
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h-1v-1h1z",
    fill: "#676967",
    fillOpacity: 0.369
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M112 52h1v1h-1z",
    fill: "#555756"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M113 52h1v1h-1z",
    fill: "#c9cdc9"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M114 52h1v1h-1z",
    fill: "#d0d2cc"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M120 53h-1v-1h1z",
    fill: "#5c5c5e"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v1h-1v-1z",
    fill: "#4f5052",
    fillOpacity: 0.969
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M122 52v1h-1v-1z",
    fill: "#737379",
    fillOpacity: 0.173
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h-1v-1h1z",
    fill: "#f0f5f2",
    fillOpacity: 0.416
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v-1h1v1z",
    fill: "#cfe5da"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54h-1v-1h1z",
    fill: "#a1c5b6"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54v-1h1v1z",
    fill: "#a6c3bb"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M17 54h-1v-1h1z",
    fill: "#adc3bd"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#a3c1b6"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#a0c3b6"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#a1c1b3"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#a3c1b0"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#a4c1ad"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#a4c0a7"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#a7bfa6"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#80b196"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#478151"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#55924d"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#a8c6a9"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#b5c8b7"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#b1c6b3"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#adc5b1"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#aec5b0"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#adc6af"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#afc3b5"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#afc6ba"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#acc8b5"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#aac9b5"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#b1cab9"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#a9cbbb"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#96bfb7"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#64ad99"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#3b9773"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#258562"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1z",
    fill: "#196d4c"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#176530"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#367057"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#a097d0"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#a4b4dd"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#b0d6e6"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#bde8f0"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#caeef5"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#d3eff7"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#d8f1f7"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#ddeef7"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#dbedf6"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#e4e8f7"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#e7e0f5"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#e0dcf5"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#dddaf6"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#b9d3e9"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#8ec7cd"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#84c1bc"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#99c1c2"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#b3bac6"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#c4c2c8"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#c5ccc6"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#c1d1c7"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#b9d4c8"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#bbd7c8"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#b9d9cb"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#c4e1d6",
    fillOpacity: 0.984
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#dcf2ef",
    fillOpacity: 0.322
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#1d1d15",
    fillOpacity: 0.137
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#272727",
    fillOpacity: 0.969
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#73726e"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#b7b8ad"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#afb0a7"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#b8b9b1"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#86877f"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#383933",
    fillOpacity: 0.847
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#7b7b77",
    fillOpacity: 0.235
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#747470",
    fillOpacity: 0.231
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#484847",
    fillOpacity: 0.957
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#272728"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#2c2d2e"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#353636"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53v1h-1v-1z",
    fill: "#606060"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M109 54h-1v-1h1z",
    fill: "#6b6b6b",
    fillOpacity: 0.455
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54v-1h1v1z",
    fill: "#747474",
    fillOpacity: 0.094
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53v1h-1v-1z",
    fill: "#4b4c49",
    fillOpacity: 0.667
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M112 53h1v1h-1z",
    fill: "#8b8c88"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M119 54v-1h1v1z",
    fill: "#5f5f60"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54h-1v-1h1z",
    fill: "#4d4e50",
    fillOpacity: 0.976
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M121 53h1v1h-1z",
    fill: "#6c7171",
    fillOpacity: 0.184
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h1v1h-1z",
    fill: "#eaf3ee",
    fillOpacity: 0.588
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M14 54h1v1h-1z",
    fill: "#cadcd1"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#a8c1b3"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#a9c3b4"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#a5c4b3"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#a0c2b1"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h-1v-1h1z",
    fill: "#a5c4b4"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#a3c1ae"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#a4c3ad"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#a5c2ae"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#a7c0a9"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#a8bfa9"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#78a195"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#3a844d"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#518a3e"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#abc1a4"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#b8c8b9"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#b4c4b3"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#b1c7b0"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#aec8ba"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#b0c7b7"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#adc8b9"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#adc8b8"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#aec8b6"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#acc8b8"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#acc6b8"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#b1c9bb"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#a9c7b8"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#8dc3b7"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#69b4a9"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#45a6a2"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#42a494"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#7299b1"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#f8c4ff"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#eed2f7"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#d8d2f7"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#cbd7f8"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#c5daf7"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#c1dbf8"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#bfdbf4"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1z",
    fill: "#c8daf4"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#ccd9f3"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#e0dbf9"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#e7d5fa"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#e6d5f9"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#efd2fd"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#dac2f2"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#bdbbd6"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#c9c6cc"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#cacbcc"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#c6d0d0"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#c9d1cf"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#c7d3cf"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#c0d5cc"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#bed6ca"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#bdd6c8"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#c6e2d5"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#d8ece6",
    fillOpacity: 0.494
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#262626",
    fillOpacity: 0.157
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#282829",
    fillOpacity: 0.973
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#262527"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#b9b9ae"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#b2b3a9"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#7e7f78"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#545550",
    fillOpacity: 0.886
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#595956",
    fillOpacity: 0.812
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#50514c",
    fillOpacity: 0.929
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#4e4f4a"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#50504c"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#484846"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v1h-1v-1z",
    fill: "#595957"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h1z",
    fill: "#5a5a57"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55v-1h1v1z",
    fill: "#4a4a48"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#575755"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54v1h-1v-1z",
    fill: "#656563"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h1v1h-1z",
    fill: "#686866"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M105 54h1v1h-1z",
    fill: "#5b5c59"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M107 54v1h-1v-1z",
    fill: "#6e6e6c"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54v1h-1v-1z",
    fill: "#767674"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M108 54h1v1h-1z",
    fill: "#727270",
    fillOpacity: 0.992
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55v-1h1v1z",
    fill: "#7b7b79",
    fillOpacity: 0.859
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55v-1h1v1z",
    fill: "#7b7b79",
    fillOpacity: 0.851
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M111 55v-1h1v1z",
    fill: "#9c9d9a"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M120 55h-1v-1h1z",
    fill: "#646464"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M121 54v1h-1v-1z",
    fill: "#4c4d4f",
    fillOpacity: 0.98
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M121 55v-1h1v1z",
    fill: "#6d6d6d",
    fillOpacity: 0.192
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M14 55v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h-1v-1h1z",
    fill: "#e7f0e8",
    fillOpacity: 0.678
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55v1h-1v-1z",
    fill: "#a5c2ac"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55h1v1h-1z",
    fill: "#a6c4ae"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1z",
    fill: "#a7c2b0"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M21 55h1v1h-1z",
    fill: "#a4c3ae"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1z",
    fill: "#a7c1b1"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#a9c0af"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#a7beab"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#a1c0ad"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#68a191"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#3b8447"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#488240"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#a7be9f"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#becbc2"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#b3c7b7"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#b7c6ba"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#afc8b8"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#acc7b9"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#b0c9ba"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#b0c7b9"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#a4c9b4"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#a0c4b7"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#a9c3bd"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#a7c8bb"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#98c6bd"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#b7bfdb"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#fecbff"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#fbd2fd"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#fec6fe"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#ffc2fe"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#ffc4fd"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#ffc5fc"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#fdc0fb"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#fdc0fc"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#fcc7fc"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#fdc8fb"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#ffcbfe"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#fecefc"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#ffd2fc"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#ffd0ff"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#eecdf2"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#cad4d8"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#c1d7cf"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1z",
    fill: "#c6d4d1"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#c2d5d1"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1z",
    fill: "#c5d6d3"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#c3d6d0"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#c3d7cf"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#cde3d8"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#d3e6dc",
    fillOpacity: 0.616
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.165
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#272727",
    fillOpacity: 0.976
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#767671"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#b8b9ad"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#b4b6ab"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#b1b3a9"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#afb1a7"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#b3b5aa"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#b7b8b0"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#b9bab3"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#bfc0b9"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55v1h-1v-1z",
    fill: "#c2c3bc"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1z",
    fill: "#c6c7c0"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55v1h-1v-1z",
    fill: "#c8c9c3"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M108 56v-1h1v1z",
    fill: "#d4d6d0"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M109 55h1v1h-1z",
    fill: "#d6d8d2"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M111 56h-1v-1h1z",
    fill: "#d8d9d3"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M112 55v1h-1v-1z",
    fill: "#dadbd6"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v-1h1v1z",
    fill: "#d1d2cc"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M119 55v1h-1v-1z",
    fill: "#c9c9c5"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M119 56v-1h1v1z",
    fill: "#676767"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M120 56v-1h1v1z",
    fill: "#4a4b4d",
    fillOpacity: 0.984
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M121 55h1v1h-1z",
    fill: "#686868",
    fillOpacity: 0.192
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h1v1h-1z",
    fill: "#e0efe4",
    fillOpacity: 0.69
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#c0d8c5"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#a7c4ad"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M18 57v-1h1v1z",
    fill: "#a9c6b1"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#a7c5b2"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57v-1h1v1z",
    fill: "#a4c2af"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h-1v-1h1z",
    fill: "#a7c1af"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#a6c2ae"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#a4bfac"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1z",
    fill: "#5da58e"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#338549"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#397c38"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#95b18b"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#becfc2"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#b5cab8"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#b1c8ba"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#afc8bb"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#b1cabc"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#b5c9bb"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#b2cbbd"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#acc7bc"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#a4c6bb"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#9ec4b2"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#a6c3be"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#a4c6bf"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#a7cbc0"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#cfcae4"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#ffd1fc"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#fed5fc"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#fecdfd"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#ffc9fd"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#fccafe"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#fdc9fe"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#fdc7fe"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#fccbfe"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#fecdfe"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#fecefe"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#fdd2fd"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#fdd1fd"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#fed2ff"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#f9cffd"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#d2d7e7"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#c0dad3"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#c4d7d3"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#c2d9d5"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#c4d7d5"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#c5d8d5"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#dbece6",
    fillOpacity: 0.643
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#303030",
    fillOpacity: 0.165
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#242424",
    fillOpacity: 0.976
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#b6b6aa"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#aeb0a4"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#b1b3a7"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#b0b2a9"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#b4b6ac"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#b7b9ae"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#b9bbb0"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#babcb3"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#c0c1b9"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#c7c8c0"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#cccdc5"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#cacbc3"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1z",
    fill: "#cbccc4"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#c9cac3"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M106 57v-1h1v1z",
    fill: "#d0d2cb"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M109 56h1v1h-1z",
    fill: "#cdd1ca"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M110 56h1v1h-1z",
    fill: "#cbcdc6"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M112 56v1h-1v-1z",
    fill: "#d0d0ca"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M114 56v1h-1v-1z",
    fill: "#d4d5cf"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M116 57h-1v-1h1z",
    fill: "#d7d8d2"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v-1h1v1z",
    fill: "#646465"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M120 56h1v1h-1z",
    fill: "#494a4c",
    fillOpacity: 0.992
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M121 57v-1h1v1z",
    fill: "#666b6b",
    fillOpacity: 0.224
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57h1v1h-1z",
    fill: "#e2eee5",
    fillOpacity: 0.659
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v-1h1v1z",
    fill: "#caddcd"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M19 57v1h-1v-1z",
    fill: "#acc5b0"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58h-1v-1h1z",
    fill: "#a9c4b2"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57h1v1h-1z",
    fill: "#a7c2b1"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57h1v1h-1z",
    fill: "#a8c2ae"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57v1h-1v-1z",
    fill: "#a9c2b0"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h1v1h-1z",
    fill: "#a8c1b2"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58h-1v-1h1z",
    fill: "#a7bfb5"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#a8c1b1"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#a2c2af"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#70aa94"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#348756"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#1f7029"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#70946d"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#b8ccb8"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#b5ccbe"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#adcbbb"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#b2c9b9"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#b4cabc"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#b4cbbe"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#b2ccbd"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#aecabb"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#a7c7b8"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#a0c6b6"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#a1c5b7"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#a6c4be"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#a9c7bd"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#a9cbc4"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#dbc4ee"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#ffc0fe"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#fcc6fe"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#fcc6ff"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#fdc6fe"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#fbcafd"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#fcd0fe"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#fad0fd"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#f9d2fd"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#fad4fd"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#fcd4ff"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#ffd0fe"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#ffceff"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#ead6f7"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#cadbdf"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#c5dbd5"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#c7d9d5"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#c9ddd9"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#cfe4e1",
    fillOpacity: 0.992
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#e0f2ee",
    fillOpacity: 0.549
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#333",
    fillOpacity: 0.176
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#242424",
    fillOpacity: 0.98
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#71726c"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#b4b6a9"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#afb1a5"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#b3b4ab"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#b3b5ab"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#b8bab1"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#c1c2b9"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#cbcbc4"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M108 58h-1v-1h1z",
    fill: "#d2d3ce"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M110 57v1h-1v-1z",
    fill: "#d3d4cf"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M110 58v-1h1v1z",
    fill: "#d2d4cd"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M112 58h-1v-1h1z",
    fill: "#d9dad2"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h-1v-1h1z",
    fill: "#e1e2da"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58v-1h1v1z",
    fill: "#dcdcd5"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M115 57v1h-1v-1z",
    fill: "#d9dad3"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M116 58h-1v-1h1z",
    fill: "#d9dbd4"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h-1v-1h1z",
    fill: "#d7d9d3"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M118 57v1h-1v-1z",
    fill: "#d3d5ce"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M119 57v1h-1v-1z",
    fill: "#cdcfca"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M120 58h-1v-1h1z",
    fill: "#5e5e60"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.337
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59h-1v-1h1z",
    fill: "#e6f1ea",
    fillOpacity: 0.573
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M19 58v1h-1v-1z",
    fill: "#ceded1"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58v1h-1v-1z",
    fill: "#b2c7b7"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M22 58v1h-1v-1z",
    fill: "#abc3b1"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59v-1h1v1z",
    fill: "#adc2b7"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1z",
    fill: "#abc1b6"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M25 59h-1v-1h1z",
    fill: "#a6c1b3"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1z",
    fill: "#aac0b4"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#aac2b2"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#76b0a0"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#308370"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#176738"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#417940"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#9ab598"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#bcd1c4"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#b0cdbd"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#afc9bb"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#b0cabc"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#adc8ba"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#a4c7b8"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#9ec4b7"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#a7c2bd"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#aac3c0"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#a5c8be"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#aacac3"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#dfc3f1"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#febbfc"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#fac3fe"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#fbc8fe"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#f9cbff"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#f8d1ff"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#f6d5fe"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#f5d7ff"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#f5d8ff"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#f5d9fe"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#f7dbff"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#fadbfe"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#fad8fe"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#f9d7fd"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#f6daff"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#e0dcef"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#cbddd9"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#d1e7de"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#d4ebe3",
    fillOpacity: 0.91
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#e6f6f4",
    fillOpacity: 0.365
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#353535",
    fillOpacity: 0.188
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#252526",
    fillOpacity: 0.984
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#666765"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#9c9d97"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#969790"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#959690"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#999a93"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#979891"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#9a9b94"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#9d9e98"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#9fa09a"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#a3a49e"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#a4a5a0"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#a7a7a2"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M98 58h1v1h-1z",
    fill: "#a8aaa5"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58v1h-1v-1z",
    fill: "#adafac"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#b4b6b4"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#b9bbb8"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58h1v1h-1z",
    fill: "#bfc0bb"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M103 58h1v1h-1z",
    fill: "#c4c5c0"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M105 59h-1v-1h1z",
    fill: "#c6c7c2"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M106 59h-1v-1h1z",
    fill: "#c7c8c3"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M107 58v1h-1v-1z",
    fill: "#c9cac5"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M108 59v-1h1v1z",
    fill: "#cfd0cb"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h-1v-1h1z",
    fill: "#c8cac6"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59v-1h1v1z",
    fill: "#c5c6c2"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M113 58h1v1h-1z",
    fill: "#b6b7b4"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M114 58h1v1h-1z",
    fill: "#afb0ad"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58v1h-1v-1z",
    fill: "#aaaca8"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M117 58h1v1h-1z",
    fill: "#a8aaa6"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M119 58v1h-1v-1z",
    fill: "#a3a5a3"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M119 59v-1h1v1z",
    fill: "#555758"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M121 58h1v1h-1z",
    fill: "#444744",
    fillOpacity: 0.365
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60h-1v-1h1z",
    fill: "#ebf2f0",
    fillOpacity: 0.412
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60h-1v-1h1z",
    fill: "#d9e5da",
    fillOpacity: 0.937
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60v-1h1v1z",
    fill: "#bed2bd"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M21 59h1v1h-1z",
    fill: "#aac2af"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1z",
    fill: "#a7c3b5"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h1v1h-1z",
    fill: "#a6c3b2"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#a7c2b2"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#a9c2b4"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#a7c1b2"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#a6c0ae"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#a0bfb0"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#83b5af"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#379380"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#167346"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#215c29"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#59815a"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#a3bfa3"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#bad2c3"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1z",
    fill: "#bbcec2"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#b4c8bc"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#a6c7b9"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#a4c7bc"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#a5c3bc"
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#abc0bf"
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#acc3c0"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#a7cac1"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#b1cac8"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#e6c6f5"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#fbc3fe"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#f9c9fe"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#f8ccfd"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#f7cefd"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#f6d2fe"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#f5d5fe"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#f4dafe"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#f5dbfe"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#f6dffe"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#f8e1fe"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#f8e1ff"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1z",
    fill: "#f7e1fd"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#fedcff"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#f6e8ff"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#daeced"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#e1f3ed",
    fillOpacity: 0.675
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#f1ffff",
    fillOpacity: 0.149
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#38383d",
    fillOpacity: 0.212
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#232325",
    fillOpacity: 0.992
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#262625"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#282827"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#222221"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#242423"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#252524"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#313130"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#323231"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v1h-1v-1z",
    fill: "#323432"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60h-1v-1h1z",
    fill: "#343536"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#3f4142"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60h-1v-1h1z",
    fill: "#424342"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60v-1h1v1z",
    fill: "#464645"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M107 60h-1v-1h1z",
    fill: "#4e4e4d"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M109 59v1h-1v-1z",
    fill: "#4c4c4c"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v-1h1v1z",
    fill: "#4d4d4d"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60v-1h1v1z",
    fill: "#4b4b4c"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M111 60v-1h1v1z",
    fill: "#454749"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M112 59h1v1h-1z",
    fill: "#424345"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M113 59h1v1h-1z",
    fill: "#363739"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M115 59h1v1h-1z",
    fill: "#4d4f4f"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M117 60h-1v-1h1z",
    fill: "#494a4b"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59v1h-1v-1z",
    fill: "#464849"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M119 60h-1v-1h1z",
    fill: "#434446"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M121 59v1h-1v-1z",
    fill: "#444546"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M121 60v-1h1v1z",
    fill: "#3d4040",
    fillOpacity: 0.373
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h-1v-1h1z",
    fill: "#f4f9f4",
    fillOpacity: 0.192
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1z",
    fill: "#e2ede2",
    fillOpacity: 0.729
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#cddfd0"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61h-1v-1h1z",
    fill: "#b3cbb9"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#aac4b7"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#a6c2b4"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#a7c2b4"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#a8c4b2"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#a2bead"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#99bca9"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#8abeac"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#5fa29a"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#327467"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#185c44"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#255c36"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#5b8960"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#9bbaa2"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#afceb7"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#a5cfbb"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#a9c6bd"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#adc3c0"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#acc4bf"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#adc6bf"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#b1cac2"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#b9cbcd"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#e7c7f7"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#f5caff"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#f6cefe"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#f5d1fd"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#f6d3fe"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#f4d6ff"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#f3dcff"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#f2ddfe"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#f4e0fe"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#f5e2ff"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#f6e5fe"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#f6e6fe"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#f8e6ff"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#fbe7ff"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1z",
    fill: "#fdeeff"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#f8f1ff"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#f1f5ff",
    fillOpacity: 0.804
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#ecfbff",
    fillOpacity: 0.329
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#353539",
    fillOpacity: 0.243
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#1e1e1f"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#212122"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#353535"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#393939"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#3b3d3c"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M99 60h1v1h-1z",
    fill: "#3f4140"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61h-1v-1h1z",
    fill: "#424141"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#43413d"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v-1h1v1z",
    fill: "#4d4c4a"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M107 61h-1v-1h1z",
    fill: "#565656"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M109 60v1h-1v-1z",
    fill: "#5b5b5b"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M112 60v1h-1v-1z",
    fill: "#4f4f50"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M112 61v-1h1v1z",
    fill: "#4e4e4f"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M114 61h-1v-1h1z",
    fill: "#464647"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M116 61h-1v-1h1z",
    fill: "#4d4e50"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61h-1v-1h1z",
    fill: "#494a4d"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M122 61h-1v-1h1z",
    fill: "#414341",
    fillOpacity: 0.384
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v1z",
    fill: "#ffd4ff",
    fillOpacity: 0.024
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M22 61v1h-1v-1z",
    fill: "#ecf4ee",
    fillOpacity: 0.373
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62v-1h1v1z",
    fill: "#dfebe1",
    fillOpacity: 0.824
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#cbdad0"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1z",
    fill: "#b3c9bb"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#a4c2b0"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1z",
    fill: "#a8c4b4"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#a4c2b1"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#9fbeb1"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#95bbad"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#9abcae"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#9bbaab"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#8bb5ab"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#5d9597"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#3b786f"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#2e745a"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#43767c"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#688692"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#87a894"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#a5c2a8"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#b5c6b8"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1z",
    fill: "#b5c8c1"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#b1cac4"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#b3cbc3"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#bfced2"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#ebcafa"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#f1cffd"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#f4d2fd"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#f5d7fe"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#f4d9fe"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#f1dcfe"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#efdfff"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#efe2ff"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#eee2fd"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#ece4fb"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#f0e9fd"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#f4eeff"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#f8f2ff"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#fbf7ff"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#f2f3fe"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#f0f6fc",
    fillOpacity: 0.784
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#ecfcff",
    fillOpacity: 0.373
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#2c2c30",
    fillOpacity: 0.271
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#201f22"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#1c1c1b"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#1f1f1e"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#29292a"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#363636"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#3d3e3f"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61v1h-1v-1z",
    fill: "#444646"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61h1v1h-1z",
    fill: "#3a3936"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v1h-1v-1z",
    fill: "#575249"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M103 62h-1v-1h1z",
    fill: "#484541"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v-1h1v1z",
    fill: "#545453"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62h-1v-1h1z",
    fill: "#585856"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62h-1v-1h1z",
    fill: "#60605f"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M107 62v-1h1v1z",
    fill: "#616160"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M108 61h1v1h-1z",
    fill: "#5d5d5c"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62h-1v-1h1z",
    fill: "#525251"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1z",
    fill: "#494947"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M112 62v-1h1v1z",
    fill: "#4a4a49"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M115 62h-1v-1h1z",
    fill: "#2d2d2e"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M119 62v-1h1v1z",
    fill: "#3c3d3f"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M121 61v1h-1v-1z",
    fill: "#3b3d3d"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M121 62v-1h1v1z",
    fill: "#454545",
    fillOpacity: 0.416
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#f0faf2",
    fillOpacity: 0.4
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#ddece0",
    fillOpacity: 0.812
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#c7dccd"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#bcd2c4"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#acc4b7"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#a5bfb1"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#9fbdb0"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#9bbbb2"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1z",
    fill: "#a0bdb2"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#a1b7b1"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#9db5ab"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#9fbcae"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#98b5ae"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#76a4a1"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#9094c8"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#b78cf0"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#9f98cb"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#86acaa"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#82b196"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#98ba9a"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#aabea4"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#b2c7b8"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#c5cecf"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#e8d3f4"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#f1d8fb"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#f1dffc"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#f0e4fb"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#efe5f9"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#eee6f7"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#eee8f8"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#ebedf8"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#ebf1f9"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#ebf2f8"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#eaf2f6"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#e5f1f5",
    fillOpacity: 0.957
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#e7f6f8",
    fillOpacity: 0.82
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#e7f8f9",
    fillOpacity: 0.596
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#edfffb",
    fillOpacity: 0.282
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#dfffff",
    fillOpacity: 0.031
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#2b2b2f",
    fillOpacity: 0.275
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#1c1b1f"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#1d1c1e"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#232323"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#262626"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M101 62v1h-1v-1z",
    fill: "#313231"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63h-1v-1h1z",
    fill: "#33302c"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62h1v1h-1z",
    fill: "#3c3a3a"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62v1h-1v-1z",
    fill: "#4c4c4a"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M106 63v-1h1v1z",
    fill: "#535352"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#454544"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h-1v-1h1z",
    fill: "#40403f"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M114 62v1h-1v-1z",
    fill: "#414142"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h-1v-1h1z",
    fill: "#48494b"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M117 62h1v1h-1z",
    fill: "#3f4042"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h1v1h-1z",
    fill: "#3b3c3f"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63v-1h1v1z",
    fill: "#37383a"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M122 62v1h-1v-1z",
    fill: "#424246",
    fillOpacity: 0.439
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#f5fbf8",
    fillOpacity: 0.302
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M27 63v1h-1v-1z",
    fill: "#e8f2eb",
    fillOpacity: 0.655
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#d6e4db",
    fillOpacity: 0.906
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#c6d8cc"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#b5cac1"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#a3bab0"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#a0b9af"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#a2b8aa"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#a7baab"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#a0bcb0"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#bfc4d4"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#d4bff9"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#d0b8f9"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#bdbbef"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#acc7dc"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#99cdca"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#99c6ba"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#90c4b6"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#9bd1bf"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#b5ddd7"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#d7dfe2"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#c6d3d0"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#bfcece",
    fillOpacity: 0.992
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#cedddd",
    fillOpacity: 0.988
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#d4dedf",
    fillOpacity: 0.957
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1z",
    fill: "#d9e2e2",
    fillOpacity: 0.91
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#dce3e3",
    fillOpacity: 0.812
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#e0eae9",
    fillOpacity: 0.686
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#e3f1ef",
    fillOpacity: 0.518
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#e3f8f2",
    fillOpacity: 0.329
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#ebffff",
    fillOpacity: 0.153
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#2b2b2b",
    fillOpacity: 0.275
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#22201f"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#24241f"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.91
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#1a1a1a",
    fillOpacity: 0.91
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#2e2e2e",
    fillOpacity: 0.804
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#1e1e1e",
    fillOpacity: 0.776
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M101 63h1v1h-1z",
    fill: "#303031"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#494948",
    fillOpacity: 0.663
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64v-1h1v1z",
    fill: "#1b1b1b",
    fillOpacity: 0.702
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63v1h-1v-1z",
    fill: "#434343"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63h1v1h-1z",
    fill: "#383837",
    fillOpacity: 0.776
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63v1h-1v-1z",
    fill: "#222221",
    fillOpacity: 0.89
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h-1v-1h1z",
    fill: "#3c3c3d"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63v1h-1v-1z",
    fill: "#2e2e30"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64h-1v-1h1z",
    fill: "#3e4042"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v-1h1v1z",
    fill: "#494a4c"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h1v1h-1z",
    fill: "#393a3c"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63v1h-1v-1z",
    fill: "#3a3b3b"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M120 63h1v1h-1z",
    fill: "#3a3935"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M122 64h-1v-1h1z",
    fill: "#424242",
    fillOpacity: 0.361
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.341
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1z",
    fill: "#d2dbd7",
    fillOpacity: 0.835
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#ccd5d3"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#cfdbd2"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#c5d8cd"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#c0d3c5"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#becac5"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#b4cac0"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#b7cdbb"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#c8d0cb"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#d8dbe0"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#dedee4"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#e2dddf"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#dbdfd8"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#d6dedd"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#d6dee1"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#d2e3e1"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#d2ebea",
    fillOpacity: 0.918
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#cfe9e8",
    fillOpacity: 0.753
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#cedddd",
    fillOpacity: 0.537
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#bcd6cc",
    fillOpacity: 0.318
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#d7faf0",
    fillOpacity: 0.204
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#e1fffa",
    fillOpacity: 0.2
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#dafff7",
    fillOpacity: 0.137
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#e2ffff",
    fillOpacity: 0.071
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#262222",
    fillOpacity: 0.286
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#34302b"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#514f47"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#1a1a17"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#1a1a18"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#1d1d1c"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#191919"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#2b2b2b",
    fillOpacity: 0.78
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#313131",
    fillOpacity: 0.584
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.933
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#282828",
    fillOpacity: 0.886
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#292b2a"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65h-1v-1h1z",
    fill: "#2a2a29"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64v1h-1v-1z",
    fill: "#474746"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65h-1v-1h1z",
    fill: "#494948",
    fillOpacity: 0.859
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64h1v1h-1z",
    fill: "#3e3e3e",
    fillOpacity: 0.847
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M108 64h1v1h-1z",
    fill: "#404040"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M111 64v1h-1v-1z",
    fill: "#4d4d4d",
    fillOpacity: 0.4
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65v-1h1v1z",
    fill: "#2e2e2c",
    fillOpacity: 0.561
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M114 65h-1v-1h1z",
    fill: "#3d3c3d"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h1v1h-1z",
    fill: "#38383b"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64v1h-1v-1z",
    fill: "#343538"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M120 64v1h-1v-1z",
    fill: "#42423e"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M121 64v1h-1v-1z",
    fill: "#514e46"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M122 64v1h-1v-1z",
    fill: "#3f3c38",
    fillOpacity: 0.282
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h1v1z",
    fill: "#655a57",
    fillOpacity: 0.286
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65h1v1h-1z",
    fill: "#595150",
    fillOpacity: 0.878
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#625c5c"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#73706d"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#898785"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#9e9e9c"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#b0b5ae"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#c3cac0"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#ccd2c9"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#d2dcd2"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#d6e0d9"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#d4dad7"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#ccd6ce"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#c3c8c3"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#c5cac4",
    fillOpacity: 0.871
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#d7e2db",
    fillOpacity: 0.561
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#f3f7f3",
    fillOpacity: 0.267
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.067
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#332b33",
    fillOpacity: 0.137
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#252120",
    fillOpacity: 0.8
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#242320",
    fillOpacity: 0.867
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#1f1e1f",
    fillOpacity: 0.863
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.863
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#202020",
    fillOpacity: 0.859
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.878
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#1e1e1e",
    fillOpacity: 0.918
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#202020",
    fillOpacity: 0.914
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#232323",
    fillOpacity: 0.91
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#242424",
    fillOpacity: 0.906
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#262626",
    fillOpacity: 0.878
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.902
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.898
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#262626",
    fillOpacity: 0.906
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.91
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.894
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1z",
    fill: "#2a2d2d",
    fillOpacity: 0.894
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65v1h-1v-1z",
    fill: "#2b2c2a",
    fillOpacity: 0.89
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h1v1z",
    fill: "#2f2f2d",
    fillOpacity: 0.886
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M102 65v1h-1v-1z",
    fill: "#303030",
    fillOpacity: 0.882
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v-1h1v1z",
    fill: "#333334",
    fillOpacity: 0.882
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66h-1v-1h1z",
    fill: "#373737",
    fillOpacity: 0.882
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65h1v1h-1z",
    fill: "#3e3e3e",
    fillOpacity: 0.878
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65h1v1h-1z",
    fill: "#464645",
    fillOpacity: 0.875
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65v1h-1v-1z",
    fill: "#434342",
    fillOpacity: 0.906
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M107 66v-1h1v1z",
    fill: "#434343",
    fillOpacity: 0.922
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#424142",
    fillOpacity: 0.886
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65h1v1h-1z",
    fill: "#3f3e3f",
    fillOpacity: 0.878
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M110 66v-1h1v1z",
    fill: "#3b3a3a",
    fillOpacity: 0.839
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M111 65h1v1h-1z",
    fill: "#3c3b39",
    fillOpacity: 0.847
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M112 65h1v1h-1z",
    fill: "#3a3939",
    fillOpacity: 0.871
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66v-1h1v1z",
    fill: "#373738",
    fillOpacity: 0.871
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M115 65v1h-1v-1z",
    fill: "#3c3c3e",
    fillOpacity: 0.8
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M116 66h-1v-1h1z",
    fill: "#323335",
    fillOpacity: 0.694
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M117 65v1h-1v-1z",
    fill: "#414244",
    fillOpacity: 0.69
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M117 66v-1h1v1z",
    fill: "#3b3b3c",
    fillOpacity: 0.694
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M118 65h1v1h-1z",
    fill: "#3c3e3f",
    fillOpacity: 0.675
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M120 66h-1v-1h1z",
    fill: "#383837",
    fillOpacity: 0.651
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M121 66h-1v-1h1z",
    fill: "#393530",
    fillOpacity: 0.471
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M121 65h1v1h-1z",
    fill: "#717171",
    fillOpacity: 0.035
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h1v1h-1z",
    fill: "#706b69",
    fillOpacity: 0.455
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67h-1v-1h1z",
    fill: "#625c59",
    fillOpacity: 0.976
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M29 66h1v1h-1z",
    fill: "#5f5654"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#554d4b"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#584e50"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#524a4a"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#504b48"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#524d4a"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#4e4846"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#56504d"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#615857"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#635f5e"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#65605f"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#635a59"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#5b5352"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#595151",
    fillOpacity: 0.969
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#554c4b",
    fillOpacity: 0.871
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#534a4a",
    fillOpacity: 0.694
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#4c4846",
    fillOpacity: 0.471
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#514d4d",
    fillOpacity: 0.271
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#727272",
    fillOpacity: 0.114
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#919191",
    fillOpacity: 0.027
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#676767",
    fillOpacity: 0.106
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#626262",
    fillOpacity: 0.102
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#666",
    fillOpacity: 0.098
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.094
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#5b5b5b",
    fillOpacity: 0.098
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#636363",
    fillOpacity: 0.09
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#666",
    fillOpacity: 0.078
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67h-1v-1h1z",
    fill: "#5d5d6b",
    fillOpacity: 0.075
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M107 67h-1v-1h1z",
    fill: "#4c4c4c",
    fillOpacity: 0.078
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66v1h-1v-1z",
    fill: "#555",
    fillOpacity: 0.094
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#5d505d",
    fillOpacity: 0.075
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67v-1h1v1z",
    fill: "#5a4b4b",
    fillOpacity: 0.067
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M115 66v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.024
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#494646",
    fillOpacity: 0.584
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67v1h-1v-1z",
    fill: "#615a5a"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#5d5454"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#584f4f"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#574f50"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#595353"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67h1v1h-1z",
    fill: "#544c4c"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#544b4b"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#514748"
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#443f3e"
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#47403d"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#4d4643"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#514a48"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#544d4a"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#564f4d"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#403d3e",
    fillOpacity: 0.925
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#444445",
    fillOpacity: 0.761
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#494749",
    fillOpacity: 0.545
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#464242",
    fillOpacity: 0.314
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#464646",
    fillOpacity: 0.141
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#716a6a",
    fillOpacity: 0.141
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#736d6d",
    fillOpacity: 0.675
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#5f5959"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#575051"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#585254"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#534d4d"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#504749"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#564c4e"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#524a4b"
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#4b4344"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#4f4748"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#4a4145"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#443c3e"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#463f3f"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#403c39"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#413c3b"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#443f40"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#424041"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#363435",
    fillOpacity: 0.957
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M52 68h1v1h-1z",
    fill: "#3a3738",
    fillOpacity: 0.808
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#3e3e3e",
    fillOpacity: 0.608
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#454545",
    fillOpacity: 0.388
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#484848",
    fillOpacity: 0.192
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#454545",
    fillOpacity: 0.043
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#646060",
    fillOpacity: 0.259
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#575353",
    fillOpacity: 0.871
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#5b5454"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#524c4c"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#534d4e"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#4f494b"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#575152"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#554f4f"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#504949"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#564d4f"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#534b4d"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#4c4647"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#514c4c"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#4d4746"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#4b4446"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#443e3f"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#3f3a3a"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#413b3c"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#393334"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#373434"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#343134"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#393737"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#3a3838"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#373637"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#323233",
    fillOpacity: 0.976
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#383839",
    fillOpacity: 0.855
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#383838",
    fillOpacity: 0.659
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#3b3b3e",
    fillOpacity: 0.435
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#454545",
    fillOpacity: 0.216
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1z",
    fill: "#636060",
    fillOpacity: 0.392
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#585355",
    fillOpacity: 0.949
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#534e4f"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#514b4c"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#5e565a"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#5d5459"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#595155"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#595053"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#524a4c"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#574f51"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#554d4d"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#565050"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#4e4949"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#4c4747"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#4f4949"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#473f40"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#443d3f"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#312c31"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#2c2a2a"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#2a2927"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#2b2a29"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#2f2f31",
    fillOpacity: 0.984
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#2a2a2c",
    fillOpacity: 0.875
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#282828",
    fillOpacity: 0.694
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#2b2b2b",
    fillOpacity: 0.482
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#393939",
    fillOpacity: 0.259
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#5e5e5e",
    fillOpacity: 0.106
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#615b5b",
    fillOpacity: 0.545
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#5a5556",
    fillOpacity: 0.996
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#565153"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#5b5458"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#71676d"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#8e8389"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#a79ca1"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#afa4ab"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#a49aa3"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#978d94"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#7e767a"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#685f61"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#514b4b"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#4f4b4a"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#524e4d"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#4b4645"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#4a4243"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h-1v-1h1z",
    fill: "#4a4143"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#40393b"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#342f32"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#332e31"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#2c2a2b"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#28282a",
    fillOpacity: 0.914
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#2c2a2e",
    fillOpacity: 0.749
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#2e2e33",
    fillOpacity: 0.522
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#303034",
    fillOpacity: 0.286
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M20 73h-1v-1h1z",
    fill: "#848484",
    fillOpacity: 0.106
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M21 73h-1v-1h1z",
    fill: "#5b5658",
    fillOpacity: 0.702
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#60595c"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#655e63"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#7c747b"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#9f969e"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#b6acb4"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#bdb2ba"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#beb3ba"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#bfb3ba"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#bdb2b8"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#bfb4ba"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1z",
    fill: "#b3a9af"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#a4999e"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#91868b"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72v1h-1v-1z",
    fill: "#7a7175"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#655c60"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#443d3e"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#423c3d"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#2e2c2c"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#2a282b"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#1d1c21",
    fillOpacity: 0.918
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#2b2b2f",
    fillOpacity: 0.765
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#34363a",
    fillOpacity: 0.549
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#2f3235",
    fillOpacity: 0.337
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#28282e",
    fillOpacity: 0.149
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M19 74h-1v-1h1z",
    fill: "#6e6969",
    fillOpacity: 0.2
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M19 73h1v1h-1z",
    fill: "#595556",
    fillOpacity: 0.82
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M20 74v-1h1v1z",
    fill: "#615b5f"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73v1h-1v-1z",
    fill: "#7d747c"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1z",
    fill: "#a299a2"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#beb4bf"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#c4bac4"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#bcb3bb"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1z",
    fill: "#b9aeb7"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#bbb0b8"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#baafb5"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#b9afb3"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#bab0b5"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#bab0b7"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#bbafb7"
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#bfb0ba"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#beb2ba"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#bcb0b9"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#b3a7ae"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#a29698"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#8b8082"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#706566"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#584e4f"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#453e3e"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#3c3639"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#363234"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#252427"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#202021"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#27262d"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#2e2d33"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#26272b",
    fillOpacity: 0.965
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#2a2a2e",
    fillOpacity: 0.824
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#2e2e30",
    fillOpacity: 0.604
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#37373a",
    fillOpacity: 0.376
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#424242",
    fillOpacity: 0.18
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.035
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M17 75v-1h1v1z",
    fill: "#555252",
    fillOpacity: 0.353
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v1h-1z",
    fill: "#564e50",
    fillOpacity: 0.914
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#6d6468"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75h-1v-1h1z",
    fill: "#92898f"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75v-1h1v1z",
    fill: "#bdb3bc"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75h-1v-1h1z",
    fill: "#c8bfc8"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#c2b8c1"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h1v1h-1z",
    fill: "#bfb4bd"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v1h-1v-1z",
    fill: "#beb2bb"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M27 75h-1v-1h1z",
    fill: "#beb3bc"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1z",
    fill: "#c1b6bf"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#c5bac4"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#c0b7c0"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#bbb4bb"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#bbb1b8"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#bbaeb6"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#bcb0b8"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#bab0b8"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#b9b0b7"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#baafb3"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#b8adb1"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#b8a9ac"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#b2a0a2"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#8f8483"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#4e4748"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#534d51"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#554d51"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#433c3e"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#322e2f"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#302b2e"
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#282629"
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#272528"
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#232424"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#1d1c21"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#2f2e34"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#2e2e32",
    fillOpacity: 0.973
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#2d2b30",
    fillOpacity: 0.843
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#2c2c2d",
    fillOpacity: 0.655
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#39393b",
    fillOpacity: 0.42
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#484848",
    fillOpacity: 0.208
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M16 75h1v1h-1z",
    fill: "#514e4c",
    fillOpacity: 0.525
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76h-1v-1h1z",
    fill: "#554e4d",
    fillOpacity: 0.984
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76v-1h1v1z",
    fill: "#6f6367"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75h1v1h-1z",
    fill: "#9d9097"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v-1h1v1z",
    fill: "#c5b9c2"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M22 76h-1v-1h1z",
    fill: "#c9bec6"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75v1h-1v-1z",
    fill: "#c1b6be"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#bdb3bb"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1z",
    fill: "#bfb5be"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M25 75h1v1h-1z",
    fill: "#c6bdc8"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#cfc5d0"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#cdc4ce"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#cbc1cd"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#d4ccd7"
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#d7d0db"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#cfc6d1"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#c7bdc7"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#baafb8"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#b8afb7"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#bab2bb"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#bbb0b5"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#bbafaf"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#b4a6a6"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#716766"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#574e4f"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#605758"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#4d4344"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#3c3231"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#39302f"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#362f2d"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#342d2b"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#302b28"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#262326"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#252628"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#232427"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M70 76h-1v-1h1z",
    fill: "#1c1c1f"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#232228"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#26252a"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#2f2f34",
    fillOpacity: 0.98
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#353439",
    fillOpacity: 0.855
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#323234",
    fillOpacity: 0.671
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#343236",
    fillOpacity: 0.455
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#454545",
    fillOpacity: 0.231
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#6b6b78",
    fillOpacity: 0.075
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76v1h-1v-1z",
    fill: "#797979",
    fillOpacity: 0.082
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76h1v1h-1z",
    fill: "#484546",
    fillOpacity: 0.663
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M17 77h-1v-1h1z",
    fill: "#504a4a"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M18 77h-1v-1h1z",
    fill: "#6a5e60"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77h-1v-1h1z",
    fill: "#9c8d93"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v1h-1v-1z",
    fill: "#baadb3"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76h1v1h-1z",
    fill: "#bcafb6"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77v-1h1v1z",
    fill: "#bcb0b7"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77v-1h1v1z",
    fill: "#c2b7c0"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#c5bcc8"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#d0c8d5"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#d3ccda"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#cbc4d2"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1z",
    fill: "#c4bdcb"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#c4bcca"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#d0c9d6"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#e4dbea"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#e4deec"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#e1ddeb"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#dbd6e3"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#d6ccd9"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#cec5d0"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#c6c0cb"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#c2bac5"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#c1b7bb"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#b4aaa9"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#736969"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#5a5051"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#675c5b"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#564b49"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#3e3331"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#342b29"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#302925"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#292423"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#282325"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#212026"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#37363a"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#373438"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#39373a",
    fillOpacity: 0.992
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#3a393c",
    fillOpacity: 0.882
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#3c3c3f",
    fillOpacity: 0.698
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#434345",
    fillOpacity: 0.49
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#434343",
    fillOpacity: 0.251
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77v1h-1v-1z",
    fill: "#676161",
    fillOpacity: 0.184
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77h1v1h-1z",
    fill: "#453f41",
    fillOpacity: 0.808
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h-1v-1h1z",
    fill: "#4a4345"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M17 77v1h-1v-1z",
    fill: "#62585c"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M17 78v-1h1v1z",
    fill: "#8f8287"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77v1h-1v-1z",
    fill: "#b8a9ae"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1z",
    fill: "#b6aaae"
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1z",
    fill: "#b7acb1"
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1z",
    fill: "#cfc7d3"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#ded7e7"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#d8d1e2"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#c7c1d0"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#c9c3d2"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M27 78v-1h1v1z",
    fill: "#cfc9d8"
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#dcd6e6"
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#e5deee"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#e4dbed"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#e3ddee"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#e1dff0"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#e5dbee"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#e1d8e8"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#d9d3e1"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#d6ced9"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#c3b9bb"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#746b6a"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#5c5457"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#695f60"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#594c4b"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#423431"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#3f3330"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#372d2c"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#332b29"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#252120"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#242020"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#201d20"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#1b1a1e"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#1b1a1f"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#1f2022"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#1e1f21"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#3f3d40"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#3f3e40"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#3e3d40"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#434345",
    fillOpacity: 0.902
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1z",
    fill: "#444445",
    fillOpacity: 0.729
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#4a484a",
    fillOpacity: 0.494
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77v1h-1v-1z",
    fill: "#514d51",
    fillOpacity: 0.271
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M13 78v1h-1v-1z",
    fill: "#555151",
    fillOpacity: 0.306
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79v-1h1v1z",
    fill: "#403b3c",
    fillOpacity: 0.91
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M15 78v1h-1v-1z",
    fill: "#3e3639"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v-1h1v1z",
    fill: "#544a4c"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h1v1h-1z",
    fill: "#6f6368"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79h-1v-1h1z",
    fill: "#a99ba2"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#b5a8ac"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#b5aab0"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v1z",
    fill: "#c1b7c3"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78v1h-1v-1z",
    fill: "#dad3e1"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#e3dfec"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#e6def0"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#e4ddef"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#dddbea"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#dbd8e9"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#e2dff1"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#e4e0f4"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#e4e0f3"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#e0daee"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#e1ddef"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#dfddee"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#ded4e9"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#e3d9ea"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#ccc2ce"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#776e6e"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#605756"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#6d6264"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#5a4c4b"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#423633"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#3f3432"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#362c2a"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#2f2824"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#2a2220"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#27211e"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#221f1e"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#1f1e1f"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#1a1a1a"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#201e23"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#262429"
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#27262b"
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#282829"
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#3d3c3f"
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1z",
    fill: "#4a464b"
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#4b464a"
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#484247",
    fillOpacity: 0.925
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#585258",
    fillOpacity: 0.761
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M96 79h-1v-1h1z",
    fill: "#645f61",
    fillOpacity: 0.525
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#6d6a6a",
    fillOpacity: 0.31
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79v-1h1v1z",
    fill: "#787078",
    fillOpacity: 0.133
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79h1v1h-1z",
    fill: "#474545",
    fillOpacity: 0.459
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M12 80v-1h1v1z",
    fill: "#3b3737",
    fillOpacity: 0.969
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v1h-1v-1z",
    fill: "#41393d"
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79h1v1h-1z",
    fill: "#594f52"
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M17 79v1h-1v-1z",
    fill: "#7c7275"
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M17 80v-1h1v1z",
    fill: "#9f9398"
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1z",
    fill: "#aea2a8"
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#c5b9c3"
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79h1v1h-1z",
    fill: "#ded5df"
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M21 79h1v1h-1z",
    fill: "#e5dfe7"
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#e5dfe9"
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#e5ddec"
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79h1v1h-1z",
    fill: "#e5def0"
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#e3e0f3"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#e5e2f6"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#e3e0f5"
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#e2e0f4"
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h-1v-1h1z",
    fill: "#e0dff0"
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#e1ddee"
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#e4e1f1"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#dbd9e8"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#e3dded"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#ebe2f3"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#e7ddea"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#cac1c9"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#797275"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#63595b"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#6f6261"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#5c4e49"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#473835"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#3d3231"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#352c29"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#2e2724"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#24211e"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#23201d"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#211d1b"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#1e1b18"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#1a1816"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#171717"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#171718"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#1b1a1d"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#1d1c1f"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#1e1f22"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#1f2024"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#202125"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#202124"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#242326"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#29292c"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#2c2c2f"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h-1v-1h1z",
    fill: "#353235"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#383638"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-1h1v1z",
    fill: "#4c474c"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#514c52"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1z",
    fill: "#5a5559"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80h-1v-1h1z",
    fill: "#5f595c"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1z",
    fill: "#605b5e"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h1v1h-1z",
    fill: "#60595e",
    fillOpacity: 0.945
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M99 79v1h-1v-1z",
    fill: "#5a565b",
    fillOpacity: 0.796
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80v-1h1v1z",
    fill: "#4f4e53",
    fillOpacity: 0.588
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M101 80h-1v-1h1z",
    fill: "#545459",
    fillOpacity: 0.357
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80h-1v-1h1z",
    fill: "#616167",
    fillOpacity: 0.184
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M102 79h1v1h-1z",
    fill: "#8b8b8b",
    fillOpacity: 0.043
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M9 81v-1h1v1z",
    fill: "#949494",
    fillOpacity: 0.047
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M10 80h1v1h-1z",
    fill: "#3c393b",
    fillOpacity: 0.608
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80v1h-1v-1z",
    fill: "#312c2f"
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80h1v1h-1z",
    fill: "#4b4247"
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M16 80v1h-1v-1z",
    fill: "#5e5458"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M17 81h-1v-1h1z",
    fill: "#7b7174"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h-1v-1h1z",
    fill: "#968a8d"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1z",
    fill: "#b6a8ab"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#dcced5"
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v1h-1z",
    fill: "#e2d7df"
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M21 81v-1h1v1z",
    fill: "#e3dae0"
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#e1d6de"
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#e3dbea"
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#e3dced"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#e4dff0"
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#dfdbeb"
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#e1dceb"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#e8e5f2"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#e4e1ee"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#e8e1ef"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#dfd9e5"
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#c6bdc5"
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#796e71"
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#655b5c"
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#6f6464"
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#5a4d49"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#493a33"
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#473935"
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#3d3230"
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#352b29"
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#25201b"
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#211e1b"
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#1d1a19"
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#1b1717"
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#181516"
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#181819"
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#1b1c20"
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#202126"
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#3e393c"
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#464146"
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#484346"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M95 81v-1h1v1z",
    fill: "#4e494c"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M97 80v1h-1v-1z",
    fill: "#554f54"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80v1h-1v-1z",
    fill: "#595457"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80h1v1h-1z",
    fill: "#5a555a"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80h1v1h-1z",
    fill: "#575359"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81v-1h1v1z",
    fill: "#4f4d52"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80v1h-1v-1z",
    fill: "#46454c",
    fillOpacity: 0.973
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81v-1h1v1z",
    fill: "#47474b",
    fillOpacity: 0.843
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M103 80h1v1h-1z",
    fill: "#4a494d",
    fillOpacity: 0.655
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81h-1v-1h1z",
    fill: "#48464d",
    fillOpacity: 0.427
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81v-1h1v1z",
    fill: "#4c4c50",
    fillOpacity: 0.224
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M106 81v-1h1v1z",
    fill: "#717171",
    fillOpacity: 0.071
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82H8v-1h1z",
    fill: "#57574f",
    fillOpacity: 0.114
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82v-1h1v1z",
    fill: "#353232",
    fillOpacity: 0.733
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v1h-1v-1z",
    fill: "#312b2c"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81h1v1h-1z",
    fill: "#322b2d"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82v-1h1v1z",
    fill: "#332e2f"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M13 82v-1h1v1z",
    fill: "#322d30"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81v1h-1v-1z",
    fill: "#4a4247"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81h1v1h-1z",
    fill: "#696064"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M16 81h1v1h-1z",
    fill: "#7c7173"
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82v-1h1v1z",
    fill: "#a69899"
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h1v1h-1z",
    fill: "#d2c1c2"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81v1h-1v-1z",
    fill: "#ddccd0"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81h1v1h-1z",
    fill: "#dccfd6"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M22 81v1h-1v-1z",
    fill: "#dfd3da"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82v-1h1v1z",
    fill: "#e1d2da"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#e2d4dd"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#e1d5e1"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1z",
    fill: "#e0d7e4"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1z",
    fill: "#ddd7e4"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M28 81h1v1h-1z",
    fill: "#dfd8e6"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#e1d5e7"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#e7dded"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h1z",
    fill: "#f4effb"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#e3e1ec"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#ccc6d0"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#746c70"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#685b5d"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#726466"
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#5a4c49"
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#4a3d36"
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#4a3c38"
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#463835"
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#433632"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#3e3330"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#342a28"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#2d2622"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#2b2421"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#201b1a"
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#1b1816"
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#17161a"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#19181d"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#28272b"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#29282e"
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#2c2c30"
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h-1v-1h1z",
    fill: "#363438"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M90 81h1v1h-1z",
    fill: "#3a363c"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v-1h1v1z",
    fill: "#3e393e"
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82v-1h1v1z",
    fill: "#4d494d"
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81h1v1h-1z",
    fill: "#4d4a4f"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82v-1h1v1z",
    fill: "#49484d"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81h1v1h-1z",
    fill: "#47464d"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h-1v-1h1z",
    fill: "#45444b"
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82h-1v-1h1z",
    fill: "#424148"
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M106 81v1h-1v-1z",
    fill: "#3e3d43",
    fillOpacity: 0.992
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M107 82h-1v-1h1z",
    fill: "#3e3d42",
    fillOpacity: 0.882
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M107 81h1v1h-1z",
    fill: "#444249",
    fillOpacity: 0.706
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M108 81h1v1h-1z",
    fill: "#48484c",
    fillOpacity: 0.494
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M109 82v-1h1v1z",
    fill: "#44444c",
    fillOpacity: 0.263
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h-1v-1h1z",
    fill: "#3a3a44",
    fillOpacity: 0.102
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M7 83v-1h1v1z",
    fill: "#444",
    fillOpacity: 0.22
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82v1H8v-1z",
    fill: "#2e2a29",
    fillOpacity: 0.847
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82h1v1H9z",
    fill: "#292525"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M14 83h-1v-1h1z",
    fill: "#2f2b2c"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h-1v-1h1z",
    fill: "#322d2e"
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M15 82h1v1h-1z",
    fill: "#494345"
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M16 83v-1h1v1z",
    fill: "#5a5355"
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82h1v1h-1z",
    fill: "#837777"
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M19 82v1h-1v-1z",
    fill: "#b6a5a8"
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83h-1v-1h1z",
    fill: "#cebfca"
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83h-1v-1h1z",
    fill: "#d9cfdb"
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83v-1h1v1z",
    fill: "#ded4df"
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83h-1v-1h1z",
    fill: "#e1d4e3"
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#e0d1e2"
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#dfd1e2"
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#e0d3e3"
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#e0d4e3"
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#e2d5e5"
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#e2d6e5"
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#e2d5e4"
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#ece0f0"
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#eee8f5"
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#f3eff7"
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#c7c0c7"
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#736b72"
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#665b60"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#706161"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#5c4d48"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#4b3e39"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#443935"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#413632"
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#3a2f2d"
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1z",
    fill: "#302826"
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#292321"
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#211d1a"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#1d1a17"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#1b1817"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#1a1719"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#1b181b"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#1e1d1f"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#212126"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#222428"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#25282b"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#313132"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#333334"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#3d383e"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M96 83h-1v-1h1z",
    fill: "#413f41"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M101 83v-1h1v1z",
    fill: "#413f44"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83v-1h1v1z",
    fill: "#3d3c42"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M106 82h1v1h-1z",
    fill: "#3a383f"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83v-1h1v1z",
    fill: "#393841"
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M108 83v-1h1v1z",
    fill: "#383840"
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M109 82h1v1h-1z",
    fill: "#34373e"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M110 82h1v1h-1z",
    fill: "#32353c",
    fillOpacity: 0.929
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M111 82h1v1h-1z",
    fill: "#32353a",
    fillOpacity: 0.769
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83h-1v-1h1z",
    fill: "#37393d",
    fillOpacity: 0.557
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M113 83v-1h1v1z",
    fill: "#5b5b5b",
    fillOpacity: 0.055
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M6 83h1v1H6z",
    fill: "#3b3838",
    fillOpacity: 0.353
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84H7v-1h1z",
    fill: "#252322",
    fillOpacity: 0.933
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M9 83v1H8v-1z",
    fill: "#252121"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83v1h-1v-1z",
    fill: "#272324"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83v1h-1v-1z",
    fill: "#302b2d"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M18 83v1h-1v-1z",
    fill: "#393131"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M18 84v-1h1v1z",
    fill: "#463c3b"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84v-1h1v1z",
    fill: "#817a7e"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M22 83v1h-1v-1z",
    fill: "#a9a2a8"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#cfc4cf"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#e4d7e6"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#e8dbea"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1z",
    fill: "#e7dbe8"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#e5d9e6"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#e4d8e5"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#e1dde5"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#e1e2e8"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#f3f1f6"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#ccc4c8"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#72696b"
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#665c5d"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#6e6160"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#5a4b47"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#4d3e38"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#4e3f3a"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#4b3d39"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#443834"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#352c2a"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#2f2725"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#282220"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#211b1a"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#1d1917"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#211e1f"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#292829"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#29272c"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h1v1z",
    fill: "#36373a"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M90 84v-1h1v1z",
    fill: "#3d3d41"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M92 84v-1h1v1z",
    fill: "#3c3b3f"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84v-1h1v1z",
    fill: "#444245"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h-1v-1h1z",
    fill: "#3d3b3e"
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83v1h-1v-1z",
    fill: "#3c3a3d"
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M98 84h-1v-1h1z",
    fill: "#424043"
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83v1h-1v-1z",
    fill: "#38353a"
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83h1v1h-1z",
    fill: "#292931"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M109 83v1h-1v-1z",
    fill: "#2b2b33"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84v-1h1v1z",
    fill: "#2d3037"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M110 83h1v1h-1z",
    fill: "#2f3239"
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M112 83v1h-1v-1z",
    fill: "#2e3136"
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M112 83h1v1h-1z",
    fill: "#2d2e31",
    fillOpacity: 0.886
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M5 84h1v1H5z",
    fill: "#2e2c2c",
    fillOpacity: 0.494
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M6 84h1v1H6z",
    fill: "#221f20",
    fillOpacity: 0.98
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84h1v1H9z",
    fill: "#221e1f"
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M11 85v-1h1v1z",
    fill: "#252022"
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85v-1h1v1z",
    fill: "#252224"
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M14 84v1h-1v-1z",
    fill: "#272526"
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M15 84v1h-1v-1z",
    fill: "#2b2829"
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M18 85h-1v-1h1z",
    fill: "#312d2d"
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85h-1v-1h1z",
    fill: "#302b29"
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v-1h1v1z",
    fill: "#342f2c"
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84h1v1h-1z",
    fill: "#35302d"
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M21 84h1v1h-1z",
    fill: "#403a37"
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v1h-1v-1z",
    fill: "#5c5655"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#7a7376"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#a1989c"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#c5bcbe"
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#ddd4d6"
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#e9dfe1"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#e7e0e3"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#dddde2"
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#dfe1e4"
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#bfbcbd"
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#6e6464"
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#645b5a"
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#6a5e5b"
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#574843"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#4e3f38"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#4d3f3a"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#4b3d38"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#473937"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#433834"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#3f3431"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#251f1b"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#2b2728"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85h-1v-1h1z",
    fill: "#353438"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84v1h-1v-1z",
    fill: "#414045"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h1v1h-1z",
    fill: "#3d3d42"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M101 84v1h-1v-1z",
    fill: "#3d3c41"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M105 84h1v1h-1z",
    fill: "#2a282d"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M108 85h-1v-1h1z",
    fill: "#232329"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M109 84h1v1h-1z",
    fill: "#1f2227"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85v-1h1v1z",
    fill: "#23262b"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M113 84v1h-1v-1z",
    fill: "#4c4d51",
    fillOpacity: 0.722
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M3 85h1v1H3z",
    fill: "#7f7f7f",
    fillOpacity: 0.016
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M5 86H4v-1h1z",
    fill: "#292928",
    fillOpacity: 0.573
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M6 85v1H5v-1z",
    fill: "#1f1d1c"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85v1H6v-1z",
    fill: "#211d1e"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86H8v-1h1z",
    fill: "#272225"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86v-1h1v1z",
    fill: "#252124"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M10 85h1v1h-1z",
    fill: "#1d181c"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M11 86v-1h1v1z",
    fill: "#201c1f"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M12 85h1v1h-1z",
    fill: "#262325"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M14 86h-1v-1h1z",
    fill: "#282627"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M14 85h1v1h-1z",
    fill: "#292627"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M16 85v1h-1v-1z",
    fill: "#2e2a2b"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#383232"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M20 85h1v1h-1z",
    fill: "#363031"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1z",
    fill: "#3f3a3b"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#3b3737"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#474141"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#574e4e"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#6d6564"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85h1v1h-1z",
    fill: "#918987"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86v-1h1v1z",
    fill: "#b2adad"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1z",
    fill: "#c7c5ca"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#afa7ad"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#675d5f"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#615756"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#625857"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#53443f"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#503f38"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#50413b"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#4d3e39"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#493c38"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#463836"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#423632"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#3f3430"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#343232"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#3b393b"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#312e35"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#3c3942"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85h1v1h-1z",
    fill: "#40393d"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M87 85h1v1h-1z",
    fill: "#4a4346"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85v1h-1v-1z",
    fill: "#433e40"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86v-1h1v1z",
    fill: "#3e3c40"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85h1v1h-1z",
    fill: "#3b3a3e"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M93 86h-1v-1h1z",
    fill: "#3c393e"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M107 85h1v1h-1z",
    fill: "#212226"
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85h1v1h-1z",
    fill: "#22242a"
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M112 85v1h-1v-1z",
    fill: "#2e3137"
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86h-1v-1h1z",
    fill: "#727479",
    fillOpacity: 0.592
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M5 86v1H4v-1z",
    fill: "#191815",
    fillOpacity: 0.914
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M5 87v-1h1v1z",
    fill: "#1c1b1a"
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M7 86h1v1H7z",
    fill: "#232125"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M9 86v1H8v-1z",
    fill: "#282527"
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M10 86v1H9v-1z",
    fill: "#2a2829"
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h-1v-1h1z",
    fill: "#282525"
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#443e41"
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#3f3a3e"
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v1h-1z",
    fill: "#474242"
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87h-1v-1h1z",
    fill: "#62585a"
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#645a5b"
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#655c5d"
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#564c4a"
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#4c3e39"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#4f3f39"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#4f413b"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#4f4039"
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#4c3f38"
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#483c37"
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#453935"
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#423531"
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#3e332f"
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#292421"
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#3d3b3d"
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#3d3e45"
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#514f59"
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1z",
    fill: "#776f72"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-1h1v1z",
    fill: "#8c8083"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86h1v1h-1z",
    fill: "#908487"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v-1h1v1z",
    fill: "#82797a"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86h1v1h-1z",
    fill: "#6e6568"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M91 86h1v1h-1z",
    fill: "#5a5356"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86v1h-1v-1z",
    fill: "#3b383c"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v-1h1v1z",
    fill: "#3a393c"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h1v1h-1z",
    fill: "#373639"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87v-1h1v1z",
    fill: "#3a393d"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86v1h-1v-1z",
    fill: "#333238"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h-1v-1h1z",
    fill: "#2e2e32"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M105 87h-1v-1h1z",
    fill: "#2a2b2f"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M106 86v1h-1v-1z",
    fill: "#27292e"
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M106 87v-1h1v1z",
    fill: "#25272a"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87h-1v-1h1z",
    fill: "#252629"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87v-1h1v1z",
    fill: "#222228"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M109 87v-1h1v1z",
    fill: "#2c2d33"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M110 86h1v1h-1z",
    fill: "#1c1d1e"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M112 87h-1v-1h1z",
    fill: "#5a5d66"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86v1h-1v-1z",
    fill: "#868893",
    fillOpacity: 0.439
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M4 87h1v1H4z",
    fill: "#10100f",
    fillOpacity: 0.718
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M6 88H5v-1h1z",
    fill: "#060505"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M6 88v-1h1v1z",
    fill: "#0f0e0f"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M7 87h1v1H7z",
    fill: "#191719"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M8 87h1v1H8z",
    fill: "#1e1c1e"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M9 87h1v1H9z",
    fill: "#222020"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M13 87v1h-1v-1z",
    fill: "#252223"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M16 87h1v1h-1z",
    fill: "#302d2f"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88h-1v-1h1z",
    fill: "#312f30"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87v1h-1v-1z",
    fill: "#433d3f"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#403c3e"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#454040"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#544f50"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#5b5453"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#584d4c"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-1h1v1z",
    fill: "#524442"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#4e3e3d"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#4a3d38"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#473a36"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#413532"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#3d3330"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#352d2a"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#322b28"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#272320"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#2b2725"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#3f3c3f"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#3d3c3e"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#4e515d"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1z",
    fill: "#5f6474"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#868793"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h1v1z",
    fill: "#99949b"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h1v1h-1z",
    fill: "#a8a0a7"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v1h-1v-1z",
    fill: "#aaa0a6"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87h1v1h-1z",
    fill: "#a99fa4"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M91 87v1h-1v-1z",
    fill: "#a89b9e"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88v-1h1v1z",
    fill: "#a09397"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v1h-1v-1z",
    fill: "#92868a"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1z",
    fill: "#6d666b"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v1h-1v-1z",
    fill: "#5d585c"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87h1v1h-1z",
    fill: "#4d484c"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87h1v1h-1z",
    fill: "#3c393d"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M105 88v-1h1v1z",
    fill: "#2a2c31"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M107 88v-1h1v1z",
    fill: "#222229"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M109 88h-1v-1h1z",
    fill: "#26262d"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M109 87h1v1h-1z",
    fill: "#27282c"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88h-1v-1h1z",
    fill: "#292b2c"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M111 87h1v1h-1z",
    fill: "#797c8a"
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88v-1h1v1z",
    fill: "#828896",
    fillOpacity: 0.345
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M4 89v-1h1v1z",
    fill: "#1c1c1c",
    fillOpacity: 0.463
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M6 89H5v-1h1z",
    fill: "#010001"
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M8 89v-1h1v1z",
    fill: "#050405"
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89v-1h1v1z",
    fill: "#0d0b0c"
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M10 89v-1h1v1z",
    fill: "#161515"
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89h-1v-1h1z",
    fill: "#1d1c1d"
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M13 88v1h-1v-1z",
    fill: "#242121"
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M13 89v-1h1v1z",
    fill: "#272323"
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M14 88h1v1h-1z",
    fill: "#282424"
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88v1h-1v-1z",
    fill: "#2b2727"
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89h-1v-1h1z",
    fill: "#2d2b2b"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88v1h-1v-1z",
    fill: "#393436"
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M23 88v1h-1v-1z",
    fill: "#403a3c"
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M24 89h-1v-1h1z",
    fill: "#3c3538"
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M25 89h-1v-1h1z",
    fill: "#3e3939"
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89h-1v-1h1z",
    fill: "#44403f"
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#3e393d"
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#4c4244"
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#4d4143"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#4f4443"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#4e4342"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#493e3c"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#423836"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#3a312f"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#382f2c"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#2f2623"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#27221f"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#272220"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#3f3e42"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#403e43"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1z",
    fill: "#535457"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#727684"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#8b8ea0"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M86 89h-1v-1h1z",
    fill: "#a1a2af"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M87 88v1h-1v-1z",
    fill: "#b0adb7"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M88 88v1h-1v-1z",
    fill: "#b3b0b9"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M89 89h-1v-1h1z",
    fill: "#b1abb2"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M89 88h1v1h-1z",
    fill: "#b0a6ad"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89h-1v-1h1z",
    fill: "#aa9fa2"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88h1v1h-1z",
    fill: "#a79c9d"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v-1h1v1z",
    fill: "#a59b9d"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-1v-1h1z",
    fill: "#a59a9e"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M97 88v1h-1v-1z",
    fill: "#938a8f"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89h-1v-1h1z",
    fill: "#6b6367"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89v-1h1v1z",
    fill: "#544e53"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M105 88h1v1h-1z",
    fill: "#28292e"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M107 88v1h-1v-1z",
    fill: "#25262c"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88v1h-1v-1z",
    fill: "#22212a"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88h1v1h-1z",
    fill: "#303137"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M109 89v-1h1v1z",
    fill: "#0c0d10"
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88v1h-1v-1z",
    fill: "#3d4144"
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88h1v1h-1z",
    fill: "#818699"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88h1v1h-1z",
    fill: "#9094a5",
    fillOpacity: 0.235
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M5 89v1H4v-1z",
    fill: "#212121",
    fillOpacity: 0.271
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M5 89h1v1H5z",
    fill: "#030303",
    fillOpacity: 0.996
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M12 90v-1h1v1z",
    fill: "#0c0a09"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M14 89v1h-1v-1z",
    fill: "#181413"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h-1v-1h1z",
    fill: "#231f1e"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M16 89h1v1h-1z",
    fill: "#2e2b2b"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#3e3839"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#403b3a"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#3d3838"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#453f42"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#494142"
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#4f4648"
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#4c4342"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#423a38"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#39312e"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#2c2421"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#2a2320"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#373331"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1z",
    fill: "#424046"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#504d55"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#8b8891"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#8c8d96"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#adaeb8"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M85 89h1v1h-1z",
    fill: "#bcb7c3"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v-1h1v1z",
    fill: "#bcb7c4"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90v-1h1v1z",
    fill: "#b7b4be"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90v-1h1v1z",
    fill: "#afa4aa"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89v1h-1v-1z",
    fill: "#ada1a2"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#aca0a1"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#aa9ea0"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#a4989d"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h1v1h-1z",
    fill: "#a79ca4"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M96 89v1h-1v-1z",
    fill: "#a3979f"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90v-1h1v1z",
    fill: "#a4979d"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M98 89v1h-1v-1z",
    fill: "#a6999d"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M98 90v-1h1v1z",
    fill: "#a6999e"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89h1v1h-1z",
    fill: "#9a8f95"
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89v1h-1v-1z",
    fill: "#7f767c"
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M101 90v-1h1v1z",
    fill: "#5d585e"
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89v1h-1v-1z",
    fill: "#3f3c41"
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89h1v1h-1z",
    fill: "#28272e"
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M107 90h-1v-1h1z",
    fill: "#26272c"
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M108 89v1h-1v-1z",
    fill: "#26272d"
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M109 89v1h-1v-1z",
    fill: "#24252b"
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90v-1h1v1z",
    fill: "#1f2023"
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M111 90h-1v-1h1z",
    fill: "#656971"
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90h-1v-1h1z",
    fill: "#7e849b",
    fillOpacity: 0.957
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M113 90h-1v-1h1z",
    fill: "#999fb2",
    fillOpacity: 0.157
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M4 91v-1h1v1z",
    fill: "#2a2a2a",
    fillOpacity: 0.118
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M6 90v1H5v-1z",
    fill: "#050505",
    fillOpacity: 0.941
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h1v1h-1z",
    fill: "#080707"
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M22 91v-1h1v1z",
    fill: "#3d383a"
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#423d3f"
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91v-1h1v1z",
    fill: "#464142"
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#3f3b3d"
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#464042"
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#4d4748"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#463e3c"
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#3a322f"
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#241e1b"
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#26201c"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#27201d"
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#24201e"
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#231e1c"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#312b2b"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#423d43"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#424045"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#47444a"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#8e8b94"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#aeacb9"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#b2afbb"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#bbb7c2"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#d2cbd7"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91h-1v-1h1z",
    fill: "#d7cee1"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90h1v1h-1z",
    fill: "#d3c9dd"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M88 91v-1h1v1z",
    fill: "#cbc0d0"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90h1v1h-1z",
    fill: "#bcb0bb"
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91v-1h1v1z",
    fill: "#b2a6ab"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M92 91h-1v-1h1z",
    fill: "#aea0a5"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M92 90h1v1h-1z",
    fill: "#b2a5ac"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1z",
    fill: "#b3a9b4"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M95 90v1h-1v-1z",
    fill: "#afa6ae"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M96 91h-1v-1h1z",
    fill: "#a69ca2"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90h1v1h-1z",
    fill: "#a1969b"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M98 91h-1v-1h1z",
    fill: "#a4989c"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90v1h-1v-1z",
    fill: "#a99da1"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90h1v1h-1z",
    fill: "#a4989e"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v-1h1v1z",
    fill: "#9b9197"
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M102 90v1h-1v-1z",
    fill: "#8d828a"
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91h-1v-1h1z",
    fill: "#6a656c"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91h-1v-1h1z",
    fill: "#202025"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90h1v1h-1z",
    fill: "#484b51"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M110 90h1v1h-1z",
    fill: "#7a8093"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90v1h-1v-1z",
    fill: "#7f8697",
    fillOpacity: 0.902
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M112 91v-1h1v1z",
    fill: "#a5a5b2",
    fillOpacity: 0.078
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M5 91v1H4v-1z",
    fill: "#666",
    fillOpacity: 0.02
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M6 92H5v-1h1z",
    fill: "#060606",
    fillOpacity: 0.824
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91h1v1h-1z",
    fill: "#6e6e6e"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M17 92v-1h1v1z",
    fill: "#343333"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91v1h-1v-1z",
    fill: "#141213"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91h1v1h-1z",
    fill: "#343132"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#433c3f"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91h1v1h-1z",
    fill: "#3c3738"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M28 91h1v1h-1z",
    fill: "#403b3d"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#494545"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#322c2c"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#231d1c"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#221d1b"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#251d1b"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#241e1a"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#2b2524"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#443f44"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#413f43"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#484447"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#757075"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#aca8b0"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#adabb7"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91h1v1h-1z",
    fill: "#cecbd9"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#cdc8d8"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#cfc7d8"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1z",
    fill: "#d8d0e6"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M88 92h-1v-1h1z",
    fill: "#dbd3e9"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M89 91v1h-1v-1z",
    fill: "#d5ccdf"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92v-1h1v1z",
    fill: "#d2c9d7"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91h1v1h-1z",
    fill: "#cfc4cd"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h-1v-1h1z",
    fill: "#c7bcc5"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92v-1h1v1z",
    fill: "#c5bac6"
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#bfb8c6"
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#b8b2be"
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#b6aeb9"
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#b0a7af"
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h-1v-1h1z",
    fill: "#aca1a9"
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M99 91v1h-1v-1z",
    fill: "#ada2a7"
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v1h-1v-1z",
    fill: "#a49ba0"
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92h-1v-1h1z",
    fill: "#968e95"
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92v-1h1v1z",
    fill: "#8f8992"
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h-1v-1h1z",
    fill: "#7b7983"
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v-1h1v1z",
    fill: "#57555f"
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M107 92h-1v-1h1z",
    fill: "#2b2b31"
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91v1h-1v-1z",
    fill: "#2c2d30"
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91v1h-1v-1z",
    fill: "#656972"
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91h1v1h-1z",
    fill: "#80869c"
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h-1v-1h1z",
    fill: "#818696",
    fillOpacity: 0.773
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M113 91v1h-1v-1z",
    fill: "#c99",
    fillOpacity: 0.02
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M5 92h1v1H5z",
    fill: "#111",
    fillOpacity: 0.624
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93h-1v-1h1z",
    fill: "#7c7c7c"
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M18 93h-1v-1h1z",
    fill: "#e9e8e8"
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92v1h-1v-1z",
    fill: "#c1c1c1"
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#818181"
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v1h-1v-1z",
    fill: "#373335"
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#3d3839"
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#3e3a3c"
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#454245"
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#3e3b3f"
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#403e3f"
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#434244"
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#3c3b3d"
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#3c383c"
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1z",
    fill: "#4d494b"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#484445"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#352f30"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#221d1a"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#444045"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#413e44"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#464347"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#5c5757"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#a6a0a2"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#dfdce3"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#ceccda"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#cac7d5"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#d1cdde"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#d7d3e6"
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#d6d3e7"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-1h1z",
    fill: "#d3cedd"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#d2cbd9"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M90 92h1v1h-1z",
    fill: "#d1c8d3"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#d4ccda"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#d5cfe1"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1z",
    fill: "#d3cdde"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#d0cad9"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h-1v-1h1z",
    fill: "#cac4d2"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v-1h1v1z",
    fill: "#bfb8c4"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h1v1h-1z",
    fill: "#b1aab4"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h-1v-1h1z",
    fill: "#a49da4"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M100 92h1v1h-1z",
    fill: "#948d95"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M102 93h-1v-1h1z",
    fill: "#898791"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v1h-1v-1z",
    fill: "#777784"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h1v1h-1z",
    fill: "#5d5b67"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92h1v1h-1z",
    fill: "#47444b"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h1v1h-1z",
    fill: "#2a2a30"
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v-1h1v1z",
    fill: "#484c50"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M109 92h1v1h-1z",
    fill: "#666c79"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M110 92h1v1h-1z",
    fill: "#767b8e"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92v1h-1v-1z",
    fill: "#838896",
    fillOpacity: 0.412
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M5 94v-1h1v1z",
    fill: "#212121",
    fillOpacity: 0.424
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#edeeee"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#cfd0cf"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94v-1h1v1z",
    fill: "#959595"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94h-1v-1h1z",
    fill: "#535252"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h1v1h-1z",
    fill: "#242323"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#151314"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#312e2f"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#393435"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#3f393d"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#474344"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#484446"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#423f41"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#413e43"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#474548"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#484649"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#2c2725"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#241f1e"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#332f33"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#403e42"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#534c4f"
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#8d8482"
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1z",
    fill: "#dfdad9"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#dedbea"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#cdcbd9"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#d7d5e3"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#e3e1ef"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1z",
    fill: "#dfddec"
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#d2cfdc"
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94h-1v-1h1z",
    fill: "#d4ceda"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M90 93v1h-1v-1z",
    fill: "#d3c9d8"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h-1v-1h1z",
    fill: "#d2c9d6"
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93h1v1h-1z",
    fill: "#d7d2e0"
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M93 94h-1v-1h1z",
    fill: "#d6d3e4"
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M95 93v1h-1v-1z",
    fill: "#dbd3e3"
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94h-1v-1h1z",
    fill: "#dcd5e5"
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v1h-1v-1z",
    fill: "#dbd8e6"
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h1v1h-1z",
    fill: "#d8d7e7"
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h-1v-1h1z",
    fill: "#d1cedd"
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94v-1h1v1z",
    fill: "#c0b9c4"
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h1v1h-1z",
    fill: "#a89fa7"
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M102 94h-1v-1h1z",
    fill: "#97929d"
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h-1v-1h1z",
    fill: "#807f8c"
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h-1v-1h1z",
    fill: "#595662"
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94v-1h1v1z",
    fill: "#4b4950"
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M105 93h1v1h-1z",
    fill: "#343339"
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v1h-1v-1z",
    fill: "#2e3030"
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M109 94h-1v-1h1z",
    fill: "#656a76"
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M109 93h1v1h-1z",
    fill: "#5a6071"
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M111 94h-1v-1h1z",
    fill: "#5c616d",
    fillOpacity: 0.898
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M112 93v1h-1v-1z",
    fill: "#adadc5",
    fillOpacity: 0.086
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M6 94v1H5v-1z",
    fill: "#303030",
    fillOpacity: 0.247
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M6 95v-1h1v1z",
    fill: "#040404",
    fillOpacity: 0.992
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v1h-1v-1z",
    fill: "#e9eaea"
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1z",
    fill: "#eceded"
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#dadbdb"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#a9a9a9"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#666667"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#403b3c"
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#3e393b"
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#3f3c3e"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#3d393d"
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#413d40"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#474347"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#403c3f"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#39353a"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#383438"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#3d3b3c"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#353232"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#262220"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#231f1c"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#3e3a3e"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#403d3e"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#7c767a"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1z",
    fill: "#b9b0b5"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h1v1h-1z",
    fill: "#e0dae2"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#dbd8e3"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95h-1v-1h1z",
    fill: "#d4d2e4"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#dbd9eb"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#efedfa"
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#e1e0ec"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#e1deed"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#d5d1df"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94v1h-1v-1z",
    fill: "#d5d0dc"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#d0ccd9"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94h1v1h-1z",
    fill: "#d6d2e1"
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M92 94v1h-1v-1z",
    fill: "#dad6e7"
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-1h1v1z",
    fill: "#d9d3e3"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95v-1h1v1z",
    fill: "#dbd6e4"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94v1h-1v-1z",
    fill: "#dad6e4"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95v-1h1v1z",
    fill: "#d9d7e5"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M98 94v1h-1v-1z",
    fill: "#d9d8e6"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h-1v-1h1z",
    fill: "#d8d7e6"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h1v1h-1z",
    fill: "#d4cedd"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M101 95h-1v-1h1z",
    fill: "#c8bfc7"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94v1h-1v-1z",
    fill: "#8e8c98"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h1v1h-1z",
    fill: "#56545e"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h1v1h-1z",
    fill: "#4d4b52"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95h-1v-1h1z",
    fill: "#4a4b52"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95v-1h1v1z",
    fill: "#6c7285"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M110 94v1h-1v-1z",
    fill: "#525766"
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M110 95v-1h1v1z",
    fill: "#606269",
    fillOpacity: 0.51
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M6 95v1H5v-1z",
    fill: "#4d4d4d",
    fillOpacity: 0.09
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M6 95h1v1H6z",
    fill: "#070707",
    fillOpacity: 0.914
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M15 96v-1h1v1z",
    fill: "#181818"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M17 96h-1v-1h1z",
    fill: "#dadada"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#e4e5e5"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#babbbb"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#7b7c7b"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1z",
    fill: "#3e3d3e"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#1b1718"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#3a3536"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#403b3e"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#413b3f"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#444244"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#413f42"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M50 95v1h-1v-1z",
    fill: "#443f42"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#443f43"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#3d383c"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#423d41"
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#383337"
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#363133"
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#373435"
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#353233"
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#2f2b2b"
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#272322"
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#3c3736"
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#6a676c"
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#aeacb5"
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#cfccd9"
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#d2d0df"
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#d3d3e1"
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1z",
    fill: "#e4e5f3"
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-1v-1h1z",
    fill: "#eff0fc"
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#e9eaf6"
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1z",
    fill: "#e5e8f1"
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#d8dae7"
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95h1v1h-1z",
    fill: "#d5d4e1"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M89 96h-1v-1h1z",
    fill: "#d5d1e0"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M91 96h-1v-1h1z",
    fill: "#dbd8eb"
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M91 95h1v1h-1z",
    fill: "#dbd7ec"
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v1h-1v-1z",
    fill: "#d8d3e8"
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1z",
    fill: "#dad5e7"
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95h1v1h-1z",
    fill: "#dcd7e6"
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96v-1h1v1z",
    fill: "#d8d3e3"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95h1v1h-1z",
    fill: "#d9d6e5"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M98 96h-1v-1h1z",
    fill: "#dad8e6"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M98 95h1v1h-1z",
    fill: "#d9d7e6"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h1v1h-1z",
    fill: "#d4cfde"
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M100 96v-1h1v1z",
    fill: "#c8bec9"
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M102 95v1h-1v-1z",
    fill: "#b7b1bd"
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h-1v-1h1z",
    fill: "#8e8c9b"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M103 95h1v1h-1z",
    fill: "#605e69"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M105 95v1h-1v-1z",
    fill: "#4b4a50"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95h1v1h-1z",
    fill: "#616470"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95h1v1h-1z",
    fill: "#666c84"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96v-1h1v1z",
    fill: "#454956",
    fillOpacity: 0.925
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M111 96h-1v-1h1z",
    fill: "#4b4b55",
    fillOpacity: 0.106
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M7 97H6v-1h1z",
    fill: "#0e0e0e",
    fillOpacity: 0.706
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M7 97v-1h1v1z",
    fill: "#020202"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M16 96v1h-1v-1z",
    fill: "#060606"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#8f8f8f"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#1d1c1c"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#474144"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#413b3e"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#433e41"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#494447"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#413e41"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#343135"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#373031"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#322d2c"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#2c2626"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#24201f"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#353131"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#3e3b3b"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#3b393d"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#555457"
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#aba8b3"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#c2c1cd"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#d5d4e4"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#e5e5f5"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#eaebf8"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M83 97h-1v-1h1z",
    fill: "#f4f4fc"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M83 96h1v1h-1z",
    fill: "#f4f4fb"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1z",
    fill: "#e3e3eb"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1z",
    fill: "#d5d9e2"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M87 97v-1h1v1z",
    fill: "#d5d8e2"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#d5d4e3"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v-1h1v1z",
    fill: "#dbd7ed"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v1h-1z",
    fill: "#dcd8ee"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97h-1v-1h1z",
    fill: "#dbd8ee"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97v-1h1v1z",
    fill: "#dcd7ee"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h-1v-1h1z",
    fill: "#dcd6ea"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#dfd7e9"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96h1v1h-1z",
    fill: "#dcd5e6"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M96 97v-1h1v1z",
    fill: "#dcd8e7"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M97 96h1v1h-1z",
    fill: "#d8d6e3"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M99 96v1h-1v-1z",
    fill: "#d0cddb"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M99 97v-1h1v1z",
    fill: "#cbc4d3"
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97h-1v-1h1z",
    fill: "#bcb4bf"
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97v-1h1v1z",
    fill: "#b2adbc"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M102 96h1v1h-1z",
    fill: "#898798"
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h1v1h-1z",
    fill: "#696773"
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M104 96h1v1h-1z",
    fill: "#403f45"
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97h-1v-1h1z",
    fill: "#27262a"
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97v-1h1v1z",
    fill: "#4a4c50"
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M107 97v-1h1v1z",
    fill: "#696e7c"
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96v1h-1v-1z",
    fill: "#63697f"
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M110 96v1h-1v-1z",
    fill: "#515460",
    fillOpacity: 0.651
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M8 98H7v-1h1z",
    fill: "#161616",
    fillOpacity: 0.306
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M9 97v1H8v-1z",
    fill: "#131313",
    fillOpacity: 0.604
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M9 98v-1h1v1z",
    fill: "#0b0b0b",
    fillOpacity: 0.859
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h-1v-1h1z",
    fill: "#eae9ea"
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#d8d8d8"
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#a3a4a3"
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#5f6060"
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#2b2b2b"
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#191718"
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#3a3737"
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#413e3e"
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#454243"
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#3f3d3f"
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#343034"
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#353134"
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#2d2a2c"
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#2d2b2c"
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#363235"
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#383539"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#7b7475"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#cbc3cc"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98h-1v-1h1z",
    fill: "#e5e0ed"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#ede8f4"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#ebe5ee"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1z",
    fill: "#e7e1ea"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#d8d3d9"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#d2ccd3"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1z",
    fill: "#d8d2db"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#d4d3dc"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M88 97v1h-1v-1z",
    fill: "#d5d7df"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v1h-1v-1z",
    fill: "#dadae6"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#dedaed"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-1h1v1z",
    fill: "#dfd9ee"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M91 97h1v1h-1z",
    fill: "#dfd8ef"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-1h1z",
    fill: "#e0d8ef"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M93 97h1v1h-1z",
    fill: "#e1d8ec"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h1v1h-1z",
    fill: "#e2d8ea"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v-1h1v1z",
    fill: "#e2dae9"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97v1h-1v-1z",
    fill: "#ddd9e5"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98v-1h1v1z",
    fill: "#d8d7e0"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M99 98h-1v-1h1z",
    fill: "#d5d2de"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M99 97h1v1h-1z",
    fill: "#c9c1d0"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M100 98v-1h1v1z",
    fill: "#bdb5be"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97h1v1h-1z",
    fill: "#a9a6b0"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M102 98v-1h1v1z",
    fill: "#7d7b89"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M103 97h1v1h-1z",
    fill: "#595761"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M107 98h-1v-1h1z",
    fill: "#636471"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M108 97v1h-1v-1z",
    fill: "#666c7e"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M108 98v-1h1v1z",
    fill: "#686c7b",
    fillOpacity: 0.941
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M110 97v1h-1v-1z",
    fill: "#797f85",
    fillOpacity: 0.18
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M10 99v-1h1v1z",
    fill: "#2b2b2b",
    fillOpacity: 0.278
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M11 99v-1h1v1z",
    fill: "#0f0f0f",
    fillOpacity: 0.576
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M12 99v-1h1v1z",
    fill: "#0a0a0a",
    fillOpacity: 0.847
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M16 98h1v1h-1z",
    fill: "#6c6c6c"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98v1h-1v-1z",
    fill: "#f8f8f8"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#b6b6b6"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#383737"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#141414"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#292828"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#323132"
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#454344"
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#3c3a3c"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#312d31"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#2b292d"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#29282c"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#2a292d"
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#3d3a3f"
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#4c4447"
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#8c8282"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#a29598"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#bdafb3"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#cec2c8"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#cec4ca"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98h1v1h-1z",
    fill: "#ccc2c8"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98h1v1h-1z",
    fill: "#c9c0c8"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98h1v1h-1z",
    fill: "#ccc2cb"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M85 98v1h-1v-1z",
    fill: "#d4cad3"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h-1v-1h1z",
    fill: "#d6ccd7"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#d3ced7"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M88 98v1h-1v-1z",
    fill: "#d5d4de"
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#dddfea"
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#dbdbe8"
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h-1v-1h1z",
    fill: "#e0dded"
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M91 98h1v1h-1z",
    fill: "#e2dcef"
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M93 99h-1v-1h1z",
    fill: "#e1daed"
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1z",
    fill: "#e2d9ec"
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v1h-1v-1z",
    fill: "#e3daea"
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98h1v1h-1z",
    fill: "#e0dce6"
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M97 99h-1v-1h1z",
    fill: "#dbdbe2"
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98h1v1h-1z",
    fill: "#d8d8e2"
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M99 99v-1h1v1z",
    fill: "#cec5d1"
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M100 98h1v1h-1z",
    fill: "#c5bfc3"
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M102 98v1h-1v-1z",
    fill: "#a4a0a9"
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h-1v-1h1z",
    fill: "#74717d"
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M104 98v1h-1v-1z",
    fill: "#45424c"
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M106 98v1h-1v-1z",
    fill: "#4c4c53"
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99v-1h1v1z",
    fill: "#696e80"
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M108 98v1h-1v-1z",
    fill: "#63697d"
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M109 98v1h-1v-1z",
    fill: "#707381",
    fillOpacity: 0.604
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100h-1v-1h1z",
    fill: "#323232",
    fillOpacity: 0.259
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M14 100v-1h1v1z",
    fill: "#171717",
    fillOpacity: 0.561
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M15 99h1v1h-1z",
    fill: "#070707",
    fillOpacity: 0.827
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M17 99v1h-1v-1z",
    fill: "#0c0c0c",
    fillOpacity: 0.984
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M17 100v-1h1v1z",
    fill: "#878787"
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#c5c5c5"
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#888"
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#1c1c1c"
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#141313"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#383435"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#373536"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#3d3a3d"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#312f31"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#323032"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#2c2a2e"
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#464245"
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#575153"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#6e6668"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#9d9297"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#beb3b7"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#cfc5c8"
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100h-1v-1h1z",
    fill: "#d4c9ce"
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#d4c9d1"
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#d3c7d1"
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h1v1h-1z",
    fill: "#d2c8d2"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#d4cbd5"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v1h-1z",
    fill: "#d5cdd9"
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#dcd8e6"
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#dfe0ef"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M90 100h-1v-1h1z",
    fill: "#e0e2f0"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99v1h-1v-1z",
    fill: "#e0e2ed"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h1v1h-1z",
    fill: "#dee0eb"
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100v-1h1v1z",
    fill: "#dedde9"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M93 100v-1h1v1z",
    fill: "#dedce8"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M95 99h1v1h-1z",
    fill: "#dadce6"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100h-1v-1h1z",
    fill: "#dcdbeb"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M99 100h-1v-1h1z",
    fill: "#d7cede"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M99 100v-1h1v1z",
    fill: "#d1c9d4"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M101 99v1h-1v-1z",
    fill: "#bab4bc"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M101 100v-1h1v1z",
    fill: "#8c8891"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M102 100v-1h1v1z",
    fill: "#524f57"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h1v1h-1z",
    fill: "#302e35"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99h1v1h-1z",
    fill: "#656a7f"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M108 100h-1v-1h1z",
    fill: "#64697b",
    fillOpacity: 0.957
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M109 100h-1v-1h1z",
    fill: "#888d99",
    fillOpacity: 0.176
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M15 100h1v1h-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.031
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M17 101h-1v-1h1z",
    fill: "#282828",
    fillOpacity: 0.224
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M18 101h-1v-1h1z",
    fill: "#111",
    fillOpacity: 0.522
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v1h-1v-1z",
    fill: "#222",
    fillOpacity: 0.808
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100v1h-1v-1z",
    fill: "#4e4e4e",
    fillOpacity: 0.988
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100h1v1h-1z",
    fill: "#949494"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M21 101v-1h1v1z",
    fill: "#cfcfcf"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#9c9b9b"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#595859"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#272627"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#343133"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#373436"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#3a3738"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#3f3b3e"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#3b363a"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#343336"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#2f2d2f"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#393639"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101h-1v-1h1z",
    fill: "#443f45"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M79 100h1v1h-1z",
    fill: "#5a5459"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#766e72"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#9a9194"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1z",
    fill: "#bbb0b6"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101h-1v-1h1z",
    fill: "#d1c6ce"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101h-1v-1h1z",
    fill: "#dacfd8"
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#dbd2db"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#ddd2e0"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#e3daec"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M89 100h1v1h-1z",
    fill: "#e2e2f4"
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v-1h1v1z",
    fill: "#e0e3f3"
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M91 101v-1h1v1z",
    fill: "#dfe2f2"
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100h1v1h-1z",
    fill: "#dfe2f1"
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M94 101h-1v-1h1z",
    fill: "#dddeee"
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100v1h-1v-1z",
    fill: "#daddec"
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101v-1h1v1z",
    fill: "#d9d9ed"
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100v1h-1v-1z",
    fill: "#ded8ee"
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M98 100v1h-1v-1z",
    fill: "#dcd2e1"
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M98 100h1v1h-1z",
    fill: "#d5cdd5"
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100v1h-1v-1z",
    fill: "#c7c0cb"
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M100 101v-1h1v1z",
    fill: "#96919f"
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M101 100h1v1h-1z",
    fill: "#5a5861"
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M104 100h1v1h-1z",
    fill: "#4d4f57"
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M107 100v1h-1v-1z",
    fill: "#63687d"
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101h-1v-1h1z",
    fill: "#6c707f",
    fillOpacity: 0.62
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h-1v-1h1z",
    fill: "#0b0b0b",
    fillOpacity: 0.502
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101v1h-1v-1z",
    fill: "#202020",
    fillOpacity: 0.788
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101h1v1h-1z",
    fill: "#4a4a4a",
    fillOpacity: 0.973
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h-1v-1z",
    fill: "#8d8d8d"
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#dedede"
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#acacac"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#6c6b6b"
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#323131"
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#131112"
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#282727"
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#3a3636"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#3d393b"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#39363a"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#333034"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#322f33"
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#3d3a3e"
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101h1v1h-1z",
    fill: "#373539"
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#403c41"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#504a4d"
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101v1h-1v-1z",
    fill: "#676064"
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v-1h1v1z",
    fill: "#898186"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101v1h-1v-1z",
    fill: "#afa5ad"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#d4cbd6"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M88 102h-1v-1h1z",
    fill: "#eee2f3"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#f0e6fb"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v1h-1v-1z",
    fill: "#ece6fb"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h-1v-1h1z",
    fill: "#e7e3fa"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M92 101v1h-1v-1z",
    fill: "#e6e2f9"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M92 102v-1h1v1z",
    fill: "#e4dff6"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v-1h1v1z",
    fill: "#e0ddf4"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102v-1h1v1z",
    fill: "#e0dcf2"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101h1v1h-1z",
    fill: "#e0d9eb"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M97 101h1v1h-1z",
    fill: "#e0d5df"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M98 101h1v1h-1z",
    fill: "#d0c7d3"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102v-1h1v1z",
    fill: "#98919d"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M101 101v1h-1v-1z",
    fill: "#56525b"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102h-1v-1h1z",
    fill: "#3d3c43"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M103 101h1v1h-1z",
    fill: "#36383a"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M105 102h-1v-1h1z",
    fill: "#636873"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M106 102h-1v-1h1z",
    fill: "#64697e"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M106 102v-1h1v1z",
    fill: "#64697a",
    fillOpacity: 0.957
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M107 101h1v1h-1z",
    fill: "#878792",
    fillOpacity: 0.184
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h1v1h-1z",
    fill: "#999",
    fillOpacity: 0.02
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M23 103h-1v-1h1z",
    fill: "#0f0f0f",
    fillOpacity: 0.192
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M24 102v1h-1v-1z",
    fill: "#040404",
    fillOpacity: 0.463
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#1e1e1e",
    fillOpacity: 0.761
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#464646",
    fillOpacity: 0.957
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h-1v-1h1z",
    fill: "#858585"
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M28 103h-1v-1h1z",
    fill: "#c7c7c7"
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#bfbfbf"
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#7e7e7e"
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#3e3d3d"
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#191818"
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#121011"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#302d31"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#2d2b2f"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#312d32"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1z",
    fill: "#3c3b3e"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#3a363a"
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1z",
    fill: "#463f45"
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M87 103h-1v-1h1z",
    fill: "#5c555b"
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h1v1h-1z",
    fill: "#80787f"
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103v-1h1v1z",
    fill: "#b0a6b0"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103h-1v-1h1z",
    fill: "#d6cdda"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#ece5f6"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h1v1h-1z",
    fill: "#f1eafc"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v1h-1v-1z",
    fill: "#ece5f9"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-1z",
    fill: "#e9e1f6"
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M95 102v1h-1v-1z",
    fill: "#e8deee"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v-1h1v1z",
    fill: "#ccc4d1"
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h-1v-1h1z",
    fill: "#857f8c"
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102h1v1h-1z",
    fill: "#49454e"
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M104 103h-1v-1h1z",
    fill: "#505258"
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M104 102h1v1h-1z",
    fill: "#69707e"
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M105 103v-1h1v1z",
    fill: "#626a7e"
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M107 103h-1v-1h1z",
    fill: "#6e7381",
    fillOpacity: 0.643
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#171717",
    fillOpacity: 0.169
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M26 104v-1h1v1z",
    fill: "#060606",
    fillOpacity: 0.447
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M27 103h1v1h-1z",
    fill: "#151515",
    fillOpacity: 0.741
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M29 104h-1v-1h1z",
    fill: "#404040",
    fillOpacity: 0.953
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1z",
    fill: "#7d7d7d"
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1z",
    fill: "silver"
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#cdcdcd"
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#939393"
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#201f1f"
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#0f0e0e"
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#252324"
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#2d2b2d"
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#2e2b30"
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#2f2e30"
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#3c373d"
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#585258"
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#756e74"
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M91 103h1v1h-1z",
    fill: "#9d969e"
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h-1v-1h1z",
    fill: "#c3bcc5"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M94 103v1h-1v-1z",
    fill: "#ddd5e1"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v1h-1v-1z",
    fill: "#e2d9e4"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M96 103v1h-1v-1z",
    fill: "#d4ccd6"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#a29ca6"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M97 104v-1h1v1z",
    fill: "#5c5862"
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h-1v-1h1z",
    fill: "#3c3940"
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h1v1h-1z",
    fill: "#2b292f"
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M101 104h-1v-1h1z",
    fill: "#333239"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M102 103h1v1h-1z",
    fill: "#39383b"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M104 103v1h-1v-1z",
    fill: "#666a73"
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M106 104h-1v-1h1z",
    fill: "#626979",
    fillOpacity: 0.984
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M107 103v1h-1v-1z",
    fill: "#767b88",
    fillOpacity: 0.227
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M28 105v-1h1v1z",
    fill: "#1a1a1a",
    fillOpacity: 0.153
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105v-1h1v1z",
    fill: "#0e0e0e",
    fillOpacity: 0.424
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M31 104v1h-1v-1z",
    fill: "#161616",
    fillOpacity: 0.722
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#3c3c3c",
    fillOpacity: 0.933
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#797979"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#bcbcbc"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#e8e8e8"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#d9d8d8"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#a5a4a4"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#616161"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#171616"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#313032"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#343236"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#38363a"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#353238"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#39373b"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#302f32"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#302f31"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105h-1v-1h1z",
    fill: "#302f2f"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v-1h1v1z",
    fill: "#353135"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104v1h-1v-1z",
    fill: "#4e494e"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h1v1h-1z",
    fill: "#585359"
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105h-1v-1h1z",
    fill: "#5c5961"
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M96 104v1h-1v-1z",
    fill: "#4f4d55"
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#3e3c42"
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M98 104v1h-1v-1z",
    fill: "#2b2b30"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105v-1h1v1z",
    fill: "#2c2c31"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h1v1h-1z",
    fill: "#4d4e54"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M104 105h-1v-1h1z",
    fill: "#696e7d"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M104 104h1v1h-1z",
    fill: "#646b82"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M105 104h1v1h-1z",
    fill: "#6d727f",
    fillOpacity: 0.706
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#0d0d0d",
    fillOpacity: 0.384
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#171717",
    fillOpacity: 0.69
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#393939",
    fillOpacity: 0.922
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#777"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#bababa"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#e6e6e6"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#f4f4f3"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1z",
    fill: "#b6b6b5"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#373737"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#131312"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#2b2b2c"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#333035"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#333233"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106h-1v-1h1z",
    fill: "#333137"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105v1h-1v-1z",
    fill: "#323338"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M101 105v1h-1v-1z",
    fill: "#28282d"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M102 105v1h-1v-1z",
    fill: "#37353b"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M103 106h-1v-1h1z",
    fill: "#616370"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M105 105v1h-1v-1z",
    fill: "#646b7c",
    fillOpacity: 0.984
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M105 106v-1h1v1z",
    fill: "#7b7f8b",
    fillOpacity: 0.251
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#080808",
    fillOpacity: 0.114
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fillOpacity: 0.361
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#393939",
    fillOpacity: 0.906
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#b8b8b9"
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#e4e4e5"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#efeff0"
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#eaeae9"
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#c5c5c4"
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#1a191a"
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#171618"
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#302e30"
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#2f2c30"
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#353337"
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#322f31"
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h-1v-1h1z",
    fill: "#3b3a3d"
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1z",
    fill: "#2e2d30"
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M95 107h-1v-1h1z",
    fill: "#2d2e2f"
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M95 106h1v1h-1z",
    fill: "#353537"
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M99 107v-1h1v1z",
    fill: "#2e2e34"
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M100 106h1v1h-1z",
    fill: "#27272c"
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M101 107v-1h1v1z",
    fill: "#505158"
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M103 107v-1h1v1z",
    fill: "#656c82"
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M105 107h-1v-1h1z",
    fill: "#6d7381",
    fillOpacity: 0.71
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#282828",
    fillOpacity: 0.098
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#060609",
    fillOpacity: 0.329
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#111112",
    fillOpacity: 0.635
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#363637",
    fillOpacity: 0.886
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#6f6f71"
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#b6b6b7"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#e4e4e6"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#d2d3d2"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#9a9a99"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v-1h1v1z",
    fill: "#100f0f"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#151313"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#252325"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#323135"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#383639"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M93 108h-1v-1h1z",
    fill: "#322f35"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M95 108v-1h1v1z",
    fill: "#2a2a2d"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M100 107v1h-1v-1z",
    fill: "#24242a"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108v-1h1v1z",
    fill: "#373839"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M101 108v-1h1v1z",
    fill: "#646771"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M103 108v-1h1v1z",
    fill: "#676c81",
    fillOpacity: 0.984
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M104 107h1v1h-1z",
    fill: "#7f8392",
    fillOpacity: 0.267
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#262626",
    fillOpacity: 0.078
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#101010",
    fillOpacity: 0.31
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#131313",
    fillOpacity: 0.616
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#323234",
    fillOpacity: 0.878
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#6c6c6e"
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1z",
    fill: "#b3b2b5"
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#e3e3e4"
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#f1f1f0"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#f2f1f1"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#dddcdd"
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#acabab"
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v-1h1v1z",
    fill: "#696868"
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#2c2b2c"
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#100e11"
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#39393c"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#333335"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#3a3a3d"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#2d2d30"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h1v1h-1z",
    fill: "#303034"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M95 109v-1h1v1z",
    fill: "#29282b"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108v1h-1v-1z",
    fill: "#2b2a31"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108v1h-1v-1z",
    fill: "#242427"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108v1h-1v-1z",
    fill: "#696d7d"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108h1v1h-1z",
    fill: "#666d82"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M103 108h1v1h-1z",
    fill: "#6b717f",
    fillOpacity: 0.769
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fillOpacity: 0.067
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#0a0a0e",
    fillOpacity: 0.282
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#18181a",
    fillOpacity: 0.573
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#363638",
    fillOpacity: 0.851
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#676769"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#a9a9aa"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#ebeceb"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#f0f1f1"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#bbb"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#131314"
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#0f0f10"
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#38383a"
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1z",
    fill: "#2e2e31"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#2a2a2e"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110h-1v-1h1z",
    fill: "#27252b"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h-1v-1h1z",
    fill: "#373739"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M103 109v1h-1v-1z",
    fill: "#686e80"
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M104 109v1h-1v-1z",
    fill: "#7d818d",
    fillOpacity: 0.325
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fillOpacity: 0.047
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#000003",
    fillOpacity: 0.255
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#111115",
    fillOpacity: 0.557
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111v-1h1v1z",
    fill: "#2d2d2d",
    fillOpacity: 0.827
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1z",
    fill: "#5b5b5b",
    fillOpacity: 0.996
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M51 111v-1h1v1z",
    fill: "#9c9c9c"
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111h-1v-1h1z",
    fill: "#d9d9d9"
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#f2f2f3"
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h-1v-1h1z",
    fill: "#ececed"
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#8c8c8c"
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#4a4a4a"
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#0f0f0f"
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#191819"
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#333235"
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110h1v1h-1z",
    fill: "#323134"
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v1h-1v-1z",
    fill: "#363639"
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111v-1h1v1z",
    fill: "#2c2b2f"
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111h-1v-1h1z",
    fill: "#292a2c"
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M97 110v1h-1v-1z",
    fill: "#2d2f32"
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M99 111h-1v-1h1z",
    fill: "#272629"
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h1v1h-1z",
    fill: "#696b7e"
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M102 111h-1v-1h1z",
    fill: "#656c7e"
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M103 111h-1v-1h1z",
    fill: "#6c7382",
    fillOpacity: 0.78
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M103 110h1v1h-1z",
    fill: "#b6b6da",
    fillOpacity: 0.027
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1z",
    fill: "#4c4c4c",
    fillOpacity: 0.039
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v1h-1z",
    fillOpacity: 0.239
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M52 112h-1v-1h1z",
    fill: "#050505",
    fillOpacity: 0.525
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h1v1h-1z",
    fill: "#2a2a2a",
    fillOpacity: 0.8
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M53 112v-1h1v1z",
    fill: "#5b5b5c",
    fillOpacity: 0.98
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v1h-1v-1z",
    fill: "#9f9fa1"
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111h1v1h-1z",
    fill: "#d7d7d9"
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#9f9f9f"
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#232324"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#0e0e10"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#131316"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112v-1h1v1z",
    fill: "#2e2d2f"
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M96 111v1h-1v-1z",
    fill: "#28292c"
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M97 112h-1v-1h1z",
    fill: "#313336"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M98 111v1h-1v-1z",
    fill: "#242428"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M98 111h1v1h-1z",
    fill: "#3c3835"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M99 111h1v1h-1z",
    fill: "#6a6d74"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M100 112v-1h1v1z",
    fill: "#676d7f"
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M101 112v-1h1v1z",
    fill: "#676c7d"
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M103 111v1h-1v-1z",
    fill: "#787e8d",
    fillOpacity: 0.333
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#131313",
    fillOpacity: 0.208
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#0a0a0a",
    fillOpacity: 0.498
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "M55 112h1v1h-1z",
    fill: "#242426",
    fillOpacity: 0.784
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "M57 112v1h-1v-1z",
    fill: "#565658",
    fillOpacity: 0.973
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-1h1v1z",
    fill: "#979798"
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#e0e0e0"
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#b1b1b2"
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#6c6c6d"
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112h1v1h-1z",
    fill: "#0e0e0f"
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v-1h1v1z",
    fill: "#0f0e10"
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v1h-1v-1z",
    fill: "#1f1f22"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "M96 113h-1v-1h1z",
    fill: "#2d2e33"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "M97 113h-1v-1h1z",
    fill: "#2b2b2f"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "M99 112v1h-1v-1z",
    fill: "#746c64"
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "M100 112v1h-1v-1z",
    fill: "#7a7b87"
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "M100 113v-1h1v1z",
    fill: "#646d7f"
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "M101 112h1v1h-1z",
    fill: "#6f7286",
    fillOpacity: 0.788
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114v-1h1v1z",
    fill: "#3f3f3f",
    fillOpacity: 0.016
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "M56 114v-1h1v1z",
    fill: "#0f0f14",
    fillOpacity: 0.192
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114h-1v-1h1z",
    fill: "#111",
    fillOpacity: 0.471
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114v-1h1v1z",
    fill: "#202020",
    fillOpacity: 0.773
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v-1h1v1z",
    fill: "#4d4d4d",
    fillOpacity: 0.965
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h1v1z",
    fill: "#909090"
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h1v1h-1z",
    fill: "#cececf"
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#eeeef0"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v1z",
    fill: "#f3f3f5"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "M64 113h1v1h-1z",
    fill: "#ededf0"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114v-1h1v1z",
    fill: "#eaeaeb"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#f3f4f2"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v1h-1v-1z",
    fill: "#c1c2c1"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "M89 114h-1v-1h1z",
    fill: "#696a6a"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "M92 113v1h-1v-1z",
    fill: "#101012"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-1h1v1z",
    fill: "#17171a"
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "M93 114v-1h1v1z",
    fill: "#222226"
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "M96 114h-1v-1h1z",
    fill: "#2f3034"
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "M99 113v1h-1v-1z",
    fill: "#726e6e"
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "M100 113v1h-1v-1z",
    fill: "#6a6e7d"
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "M101 114v-1h1v1z",
    fill: "#757a87",
    fillOpacity: 0.392
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v1h-1v-1z",
    fillOpacity: 0.004
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "M60 115h-1v-1h1z",
    fillOpacity: 0.165
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1z",
    fill: "#101010",
    fillOpacity: 0.435
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h1v1h-1z",
    fill: "#232323",
    fillOpacity: 0.733
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v1h-1v-1z",
    fill: "#4c4c4d",
    fillOpacity: 0.953
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v-1h1v1z",
    fill: "#919193"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "M65 115h-1v-1h1z",
    fill: "#cdcccf"
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114h1v1h-1z",
    fill: "#ededee"
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114v1h-1v-1z",
    fill: "#e9e9e7"
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114h1v1h-1z",
    fill: "#eaebe9"
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "M88 114v1h-1v-1z",
    fill: "#eef0ef"
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#f5f7f7"
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115h-1v-1h1z",
    fill: "#5f6061"
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "M94 114h1v1h-1z",
    fill: "#080808"
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v-1h1v1z",
    fill: "#101116"
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "M96 115v-1h1v1z",
    fill: "#11131a"
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114v1h-1v-1z",
    fill: "#2a2d30"
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114h1v1h-1z",
    fill: "#636772"
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "M99 114h1v1h-1z",
    fill: "#656b7e"
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v-1h1v1z",
    fill: "#696d80",
    fillOpacity: 0.851
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "M102 115h-1v-1h1z",
    fill: "#7f9191",
    fillOpacity: 0.055
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115v1h-1v-1z",
    fillOpacity: 0.145
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "M64 115v1h-1v-1z",
    fill: "#070709",
    fillOpacity: 0.412
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h-1v-1h1z",
    fill: "#242225",
    fillOpacity: 0.718
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116v-1h1v1z",
    fill: "#484849",
    fillOpacity: 0.937
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116h-1v-1h1z",
    fill: "#c6c6c6"
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115h1v1h-1z",
    fill: "#f3f5f3"
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-1v-1z",
    fill: "#838486"
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "M96 116h-1v-1h1z",
    fill: "#01010b"
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "M97 116h-1v-1h1z",
    fill: "#0a0c14"
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "M98 116h-1v-1h1z",
    fill: "#31353b"
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "M99 115v1h-1v-1z",
    fill: "#636a79"
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v1h-1v-1z",
    fill: "#646a7f"
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115h1v1h-1z",
    fill: "#747785",
    fillOpacity: 0.427
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.133
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "M66 116h1v1h-1z",
    fill: "#020202",
    fillOpacity: 0.384
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "M67 116h1v1h-1z",
    fill: "#1a1a1a",
    fillOpacity: 0.678
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "M69 116v1h-1v-1z",
    fill: "#454545",
    fillOpacity: 0.918
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "M70 116v1h-1v-1z",
    fill: "#828282"
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "M90 117h-1v-1h1z",
    fill: "#757677"
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "M95 117h-1v-1h1z",
    fill: "#010105"
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "M95 116h1v1h-1z",
    fill: "#03050e"
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "M97 117h-1v-1h1z",
    fill: "#0c1017"
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "M98 116v1h-1v-1z",
    fill: "#3a4048"
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "M99 116v1h-1v-1z",
    fill: "#636a7b"
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "M99 117v-1h1v1z",
    fill: "#666b7a",
    fillOpacity: 0.863
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "M101 116v1h-1v-1z",
    fill: "#8f8f8f",
    fillOpacity: 0.063
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118v-1h1v1z",
    fill: "#1b1b1b",
    fillOpacity: 0.11
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "M69 118v-1h1v1z",
    fill: "#0d0d0d",
    fillOpacity: 0.361
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "M71 117h1v1h-1z",
    fill: "#404040",
    fillOpacity: 0.902
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "M73 118v-1h1v1z",
    fill: "#bdbdbd"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "M88 117h1v1h-1z",
    fill: "#f3f4f3"
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h-1v-1h1z",
    fill: "#6a6b6d"
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "M95 117v1h-1v-1z",
    fill: "#000105"
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "M95 118v-1h1v1z",
    fill: "#03060e"
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "M97 118h-1v-1h1z",
    fill: "#0d1118"
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "M97 118v-1h1v1z",
    fill: "#434954"
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "M100 117v1h-1v-1z",
    fill: "#707582",
    fillOpacity: 0.443
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118v1h-1v-1z",
    fillOpacity: 0.094
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "M72 119v-1h1v1z",
    fill: "#111",
    fillOpacity: 0.337
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h-1v-1h1z",
    fill: "#181818",
    fillOpacity: 0.643
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118v1h-1v-1z",
    fill: "#3b3b3b",
    fillOpacity: 0.89
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "M76 118h1v1h-1z",
    fill: "#b8b8b8"
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v-1h1v1z",
    fill: "#000206"
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "M95 118h1v1h-1z",
    fill: "#03060f"
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "M96 119v-1h1v1z",
    fill: "#10141b"
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "M97 118h1v1h-1z",
    fill: "#4a505d"
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "M98 119v-1h1v1z",
    fill: "#656a7d",
    fillOpacity: 0.91
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "M99 119v-1h1v1z",
    fill: "#848499",
    fillOpacity: 0.098
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h1v1h-1z",
    fillOpacity: 0.071
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "M76 120h-1v-1h1z",
    fill: "#060606",
    fillOpacity: 0.302
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120h-1v-1h1z",
    fill: "#1a1a1a",
    fillOpacity: 0.604
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "M78 119v1h-1v-1z",
    fill: "#393939",
    fillOpacity: 0.867
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119v1h-1v-1z",
    fill: "#6f6f6f"
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119h1v1h-1z",
    fill: "#b3b3b3"
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119v1h-1v-1z",
    fill: "#4b4b4b"
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "M94 120v-1h1v1z",
    fill: "#010508"
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "M96 120h-1v-1h1z",
    fill: "#060a12"
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "M96 120v-1h1v1z",
    fill: "#15181d"
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "M98 120h-1v-1h1z",
    fill: "#545b68"
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "M99 120h-1v-1h1z",
    fill: "#6b6f80",
    fillOpacity: 0.537
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "M78 120v1h-1v-1z",
    fill: "#1f1f1f",
    fillOpacity: 0.063
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "M78 121v-1h1v1z",
    fillOpacity: 0.282
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120v1h-1v-1z",
    fill: "#121212",
    fillOpacity: 0.584
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121v-1h1v1z",
    fill: "#363636",
    fillOpacity: 0.855
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "M81 120h1v1h-1z",
    fill: "#696969"
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "M83 120v1h-1v-1z",
    fill: "#afafaf"
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "M84 121h-1v-1h1z",
    fill: "#dfdfdf"
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "M89 121v-1h1v1z",
    fill: "#3f3f3f"
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "M95 120v1h-1v-1z",
    fill: "#020609"
  })), _path6500 || (_path6500 = /*#__PURE__*/React.createElement("path", {
    d: "M96 121h-1v-1h1z",
    fill: "#060a0f"
  })), _path6501 || (_path6501 = /*#__PURE__*/React.createElement("path", {
    d: "M97 121h-1v-1h1z",
    fill: "#1d2127"
  })), _path6502 || (_path6502 = /*#__PURE__*/React.createElement("path", {
    d: "M97 121v-1h1v1z",
    fill: "#5a606b",
    fillOpacity: 0.937
  })), _path6503 || (_path6503 = /*#__PURE__*/React.createElement("path", {
    d: "M99 121h-1v-1h1z",
    fill: "#868d9b",
    fillOpacity: 0.141
  })), _path6504 || (_path6504 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121h1v1h-1z",
    fill: "#363636",
    fillOpacity: 0.055
  })), _path6505 || (_path6505 = /*#__PURE__*/React.createElement("path", {
    d: "M81 122v-1h1v1z",
    fill: "#0b0b0b",
    fillOpacity: 0.255
  })), _path6506 || (_path6506 = /*#__PURE__*/React.createElement("path", {
    d: "M83 122h-1v-1h1z",
    fill: "#0e0e0e",
    fillOpacity: 0.549
  })), _path6507 || (_path6507 = /*#__PURE__*/React.createElement("path", {
    d: "M84 121v1h-1v-1z",
    fill: "#303030",
    fillOpacity: 0.827
  })), _path6508 || (_path6508 = /*#__PURE__*/React.createElement("path", {
    d: "M85 122h-1v-1h1z",
    fill: "#646464",
    fillOpacity: 0.988
  })), _path6509 || (_path6509 = /*#__PURE__*/React.createElement("path", {
    d: "M95 122h-1v-1h1z",
    fill: "#02040b"
  })), _path6510 || (_path6510 = /*#__PURE__*/React.createElement("path", {
    d: "M96 121v1h-1v-1z",
    fill: "#060b0f"
  })), _path6511 || (_path6511 = /*#__PURE__*/React.createElement("path", {
    d: "M96 122v-1h1v1z",
    fill: "#272b33"
  })), _path6512 || (_path6512 = /*#__PURE__*/React.createElement("path", {
    d: "M98 122h-1v-1h1z",
    fill: "#666771",
    fillOpacity: 0.588
  })), _path6513 || (_path6513 = /*#__PURE__*/React.createElement("path", {
    d: "M83 123v-1h1v1z",
    fill: "#1c1c1c",
    fillOpacity: 0.035
  })), _path6514 || (_path6514 = /*#__PURE__*/React.createElement("path", {
    d: "M85 123h-1v-1h1z",
    fill: "#111",
    fillOpacity: 0.231
  })), _path6515 || (_path6515 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122v1h-1v-1z",
    fill: "#111",
    fillOpacity: 0.525
  })), _path6516 || (_path6516 = /*#__PURE__*/React.createElement("path", {
    d: "M86 122h1v1h-1z",
    fill: "#292929",
    fillOpacity: 0.812
  })), _path6517 || (_path6517 = /*#__PURE__*/React.createElement("path", {
    d: "M87 122h1v1h-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.98
  })), _path6518 || (_path6518 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122v1h-1v-1z",
    fill: "#050505"
  })), _path6519 || (_path6519 = /*#__PURE__*/React.createElement("path", {
    d: "M94 123h-1v-1h1z",
    fill: "#010104"
  })), _path6520 || (_path6520 = /*#__PURE__*/React.createElement("path", {
    d: "M95 122v1h-1v-1z",
    fill: "#030510"
  })), _path6521 || (_path6521 = /*#__PURE__*/React.createElement("path", {
    d: "M95 123v-1h1v1z",
    fill: "#0b1016"
  })), _path6522 || (_path6522 = /*#__PURE__*/React.createElement("path", {
    d: "M97 122v1h-1v-1z",
    fill: "#2e3339",
    fillOpacity: 0.961
  })), _path6523 || (_path6523 = /*#__PURE__*/React.createElement("path", {
    d: "M97 123v-1h1v1z",
    fill: "#77777c",
    fillOpacity: 0.176
  })), _path6524 || (_path6524 = /*#__PURE__*/React.createElement("path", {
    d: "M87 124h-1v-1h1z",
    fillOpacity: 0.024
  })), _path6525 || (_path6525 = /*#__PURE__*/React.createElement("path", {
    d: "M89 123v1h-1v-1z",
    fill: "#0a0a0a",
    fillOpacity: 0.475
  })), _path6526 || (_path6526 = /*#__PURE__*/React.createElement("path", {
    d: "M89 124v-1h1v1z",
    fill: "#0b0b0b",
    fillOpacity: 0.765
  })), _path6527 || (_path6527 = /*#__PURE__*/React.createElement("path", {
    d: "M91 123v1h-1v-1z",
    fill: "#030303",
    fillOpacity: 0.969
  })), _path6528 || (_path6528 = /*#__PURE__*/React.createElement("path", {
    d: "M91 124v-1h1v1z",
    fill: "#020201"
  })), _path6529 || (_path6529 = /*#__PURE__*/React.createElement("path", {
    d: "M93 124v-1h1v1z",
    fill: "#010106"
  })), _path6530 || (_path6530 = /*#__PURE__*/React.createElement("path", {
    d: "M94 124v-1h1v1z",
    fill: "#03050f"
  })), _path6531 || (_path6531 = /*#__PURE__*/React.createElement("path", {
    d: "M95 123h1v1h-1z",
    fill: "#0f1219"
  })), _path6532 || (_path6532 = /*#__PURE__*/React.createElement("path", {
    d: "M96 124v-1h1v1z",
    fill: "#35363a",
    fillOpacity: 0.655
  })), _path6533 || (_path6533 = /*#__PURE__*/React.createElement("path", {
    d: "M90 124h1v1h-1z",
    fill: "#222",
    fillOpacity: 0.173
  })), _path6534 || (_path6534 = /*#__PURE__*/React.createElement("path", {
    d: "M91 124h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.451
  })), _path6535 || (_path6535 = /*#__PURE__*/React.createElement("path", {
    d: "M93 124v1h-1v-1z",
    fill: "#0d0d0e",
    fillOpacity: 0.745
  })), _path6536 || (_path6536 = /*#__PURE__*/React.createElement("path", {
    d: "M93 125v-1h1v1z",
    fill: "#07060a",
    fillOpacity: 0.937
  })), _path6537 || (_path6537 = /*#__PURE__*/React.createElement("path", {
    d: "M94 124h1v1h-1z",
    fill: "#080a0f",
    fillOpacity: 0.973
  })), _path6538 || (_path6538 = /*#__PURE__*/React.createElement("path", {
    d: "M95 124h1v1h-1z",
    fill: "#1a1c21",
    fillOpacity: 0.796
  })), _path6539 || (_path6539 = /*#__PURE__*/React.createElement("path", {
    d: "M97 124v1h-1v-1z",
    fill: "#3f3f45",
    fillOpacity: 0.173
  })), _path6540 || (_path6540 = /*#__PURE__*/React.createElement("path", {
    d: "M94 125v1h-1v-1z",
    fill: "#3d3d3d",
    fillOpacity: 0.129
  })), _path6541 || (_path6541 = /*#__PURE__*/React.createElement("path", {
    d: "M95 126h-1v-1h1z",
    fill: "#313131",
    fillOpacity: 0.18
  })), _path6542 || (_path6542 = /*#__PURE__*/React.createElement("path", {
    d: "M96 126h-1v-1h1z",
    fill: "#9f9f9f",
    fillOpacity: 0.031
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvdCdVcrTape);
export default __webpack_public_path__ + "static/media/dvd-cd-vcr-tape.177ba938d2142fe2e0f8aad86d78f29f.svg";
export { ForwardRef as ReactComponent };